module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110265-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110265-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("1825")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "rw-h2_110265-00001"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("NOVEMBER ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00002"
    }
  }, [_vm._v("20 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" I have bethought me on seeing lately some volumes of Byron’s notes that he probably had hit upon the right way of keeping such a memorandum-book by throwing aside all pretence to regularity and order and marking down events just as they occurd to recollection. I will try this plan and behold I have a handsome lockd volume such as might serve for a Lady’s Album. "), _c('i', [_vm._v("Nota Bene")]), _vm._v(" John Lockhart and Anne"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-83",
      "id": "num-footnote-1-83-back"
    }
  }, [_vm._v("1")])]), _vm._v(" and I are to raise a society for the suppression of Albums. It is a most troublesome shape of mendicity – Sir, your autograph – a line of poetry – or a prose sentence among all the sprawling sonnets and blotted trumpery that dishonours these miscellanies – a man must have a good stomach that can swallow this botheration as a compliment.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00003"
    }
  }, [_vm._v("I was in Ireland last summer and had a most delightful tour."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-84",
      "id": "num-footnote-2-84-back"
    }
  }, [_vm._v("2")])]), _vm._v(" It cost me upwards of "), _c('i', [_vm._v("£")]), _vm._v("500 including "), _c('i', [_vm._v("£")]), _vm._v("100 left with Walter and Jane1 for we travelld a large party and in stile.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00004"
    }
  }, [_vm._v("There is much less exaggerated about the Irish than is to be expected. Their poverty is not exaggerated – it is on the extreme verge of human misery – their cottages would scarce serve for pig-sties even in Scotland – and their rags seem the very refuse of a rag-shop and are disposed on their bodies with such ingenious variety of wretchedness that you would think nothing but some sort of per-verted taste could have assembled so many shreds together. You are constantly fearful that some knot or loop will give and place the individual before you in all the primitive simplicity of Paradise. Then for their food they have only potatoes and too few of them. Yet the men look stout and healthy the women buxsome and well coloured.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("Dined with us being Sunday Will. Clerk"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-85",
      "id": "num-footnote-1-85-back"
    }
  }, [_vm._v("3")]), _vm._v(" and Chas. Kirkpatrick Sharpe. W. C. is the second son of the celebrated author of "), _c('i', [_vm._v("Naval")]), _vm._v(" "), _c('i', [_vm._v("Tactics")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-86",
      "id": "num-footnote-2-86-back"
    }
  }, [_vm._v("4")])]), _vm._v(" I have known him intimately since our college days and to my thinking, never met a man of greater powers or more complete information on all desirable subjects. In youth he had strongly the Edinburgh "), _c('i', [_vm._v("pruritus disputandi")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-87",
      "id": "num-footnote-3-87-back"
    }
  }, [_vm._v("5")])]), _vm._v(" but habits of society have greatly mellowd it and though still anxious to gain your suffrage to his opinion he endeavours rather to conciliate your opinion than conquer it by force. Still there is enough of tenacity of sentiment to prevent in London Society, where all must go slack and easy, W. C. from rising to the very top of the tree as a Conversation man, who must not only wind the thread of his argument gracefully but also know when to let go. But I like the Scotch taste better: there is more matter, more information, above all more spirit in it. Clerk will I am afraid leave the world little more than the report of his fame. He is too indolent to finish any considerable work.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00007"
    }
  }, [_vm._v("Chas. Kirkpatricke Sharpe"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-88",
      "id": "num-footnote-4-88-back"
    }
  }, [_vm._v("6")])]), _vm._v(" is another very remarkable man. He was bred a clergyman but did not take orders owing I believe to a peculiar effeminacy of voice which must have been unpleasant in reading prayers. Some family quarrels occasiond his being indifferently provided for by a small annuity from his elder brother extorted by an arbitral decree. He has infinite wit and a great turn for antiquarian lore as the publications of Kirkton"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-89",
      "id": "num-footnote-5-89-back"
    }
  }, [_vm._v("7")])]), _vm._v(" etc. bear witness. His drawings are the most fanciful and droll imaginable – a mixture between Hogarth and some of those foreign masters \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("who painted temptations of Saint Antony and such grotesque subjects. As a poet he has not a very strong touch. Strange that his finger-ends can describe so well what he cannot bring out clearly and firmly in words. If he were to make drawing a resource it might raise him a large income. But though a lover of antiquities and therefore of expensive trifles C. K. S. is too aristocratic to use his art to assist his revenue. He is a very complete genealogist and has made many detections in Douglas"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-90",
      "id": "num-footnote-1-90-back"
    }
  }, [_vm._v("8")]), _vm._v(" and other books on pedigree which our nobles would do well to suppress if they had an opportunity. Strange that a man should be curious after Scandal of centuries old. Not but Charles loves it fresh and fresh also for being very much a fashionable man he is always master of the reigning report and he tells the anecdote with such gusto that there is no helping sympathizing with him: the peculiarity of voice adding not a little to the general effect. My idea is that C. K. S. with his oddities tastes satire and high aristocratic feelings resembles Horace Walpole – perhaps in his person also in a general way. See Miss Aikin’s anecdotes"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-91",
      "id": "num-footnote-2-91-back"
    }
  }, [_vm._v("9")])]), _vm._v(" for description of the author of "), _c('i', [_vm._v("The Castle of Otranto")]), _vm._v(".\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00008"
    }
  }, [_vm._v("No other company at dinner except my cheerful and goodhumourd friend "), _c('i', [_vm._v("Missie")]), _vm._v(" MacDonald,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-92",
      "id": "num-footnote-3-92-back"
    }
  }, [_vm._v("10")])]), _vm._v(" so calld in fondness – One bottle of Champagne with the ladies’ assistance, 2 of claret. I observe that both these great Connoisseurs were very nearly if not quite agreed that there are "), _c('i', [_vm._v("no")]), _vm._v(" absolutely undoubted originals of Queen Mary. But how then should we be so very distinctly informd as to her features? What has become of all the originals which suggested these innumerable copies? Surely Mary must have been as unfortunate in this as in other particulars of her life.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00001"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00001"
    }
  }, [_vm._v("21 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" I am enamourd of my Journal. I wish the zeal may but last. Once more of Ireland – I said their poverty was not exaggerated. Neither is their wit – nor their goodhumour – nor their whimsical absurdity – nor their courage.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00009"
    }
  }, [_c('i', [_vm._v("Wit")]), _vm._v(". I gave a fellow a shilling on some occasion when sixpence was \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("the fee – ‘Remember you owe me sixpence, Pat.’ ‘May your Honour live till I pay you.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-93",
      "id": "num-footnote-1-93-back"
    }
  }, [_vm._v("11")]), _vm._v(" There was courtesy as well as wit in this and all the clothes on Pat’s back would have been dearly bought by the sum in question.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00010"
    }
  }, [_c('i', [_vm._v("Goodhumour")]), _vm._v(". There is perpetual kindness in the Irish cabbin – butter milk – potatoes – a stool is offerd or a stone is rolld that your honour may sit down and be out of their smoke and those who beg everywhere else seem desirous to exercize free hospitality in their own houses. Their natural disposition is turned to gaiety and happiness. While a Scotchman is thinking about the term day, or if easy on that subject about Hell in the next world, while an English man is making a little hell of his own in the present because his muffin is not well roasted, Pat’s mind is always turnd to fun and ridicule. They are terribly excitable to be sure and will murther you on slight suspicion and find out next day that it was all a mistake and that it was not yourself they meant to kill at all at all.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00011"
    }
  }, [_c('i', [_vm._v("Absurdity")]), _vm._v(". They were widening the road near Lord Claremont’s seat"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-94",
      "id": "num-footnote-2-94-back"
    }
  }, [_vm._v("12")])]), _vm._v(" as we passd. A number of cars were drawn up together at a particular point where we also halted as we understood they were blowing a rock and the "), _c('i', [_vm._v("shot")]), _vm._v(" was expected presently to go off. After waiting two minutes or so a fellow calld out something and our carriage as a planet and the cars for satellites started all forward at once, the Irishmen whooping and crying and the horses galloping. Unable to learn the meaning of this I had only left to suppose that they had delayd firing the intended "), _c('i', [_vm._v("shot")]), _vm._v(" till we should pass and that we were passing quickly to make the delay as short as possible. No such thing. By dint of making great haste we got within ten yards of the rock when the blast took place throwing dust and gravel on our carriage and had our postillions brought us a little nearer (it was not for want of hollowing and flogging that he did not) we should have had a still more serious share of the explosion. The explanation I received from the drivers was that they had been told by the overseer that as the "), _c('i', [_vm._v("mine")]), _vm._v(" had been so "), _c('i', [_vm._v("long")]), _vm._v(" in going off he dared say we would have time to pass it. So we just waited long enough to make the danger imminent. I have only to add that two or three people got behind the carriage just for nothing but to see how our honours got passd.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("Went to the Oil Gas Committee this morning of which concern I am president or Chairman."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-95",
      "id": "num-footnote-1-95-back"
    }
  }, [_vm._v("13")]), _vm._v(" It has amused me much by bringing me into company with a body of active business-loving money-making citizens of Edinburgh, chiefly Whigs by the way, whose sentiments and proceedings amuse me. The Stock is rather low in the market, 35/-premium instead of "), _c('i', [_vm._v("£")]), _vm._v("5. 0. 0. It must rise however for the advantages of the Light are undeniable and folks will soon become accustom [d] to idle apprehensions or misapprehensions. From "), _c('i', [_vm._v("£")]), _vm._v("20 to "), _c('i', [_vm._v("£")]), _vm._v("25 should light a house capitally supposing you leave town in the vacation. The three last quarters cost me "), _c('i', [_vm._v("£")]), _vm._v("10.10. and the first, "), _c('i', [_vm._v("£")]), _vm._v("8, was greatly over charged. We will see what this – the worst and darkest quarter costs.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00013"
    }
  }, [_vm._v("Dined with Sir Robert Dundas"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-96",
      "id": "num-footnote-2-96-back"
    }
  }, [_vm._v("14")])]), _vm._v(" where we met Lord and Lady Melville."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-97",
      "id": "num-footnote-3-97-back"
    }
  }, [_vm._v("15")])]), _vm._v(" My little "), _c('i', [_vm._v("nieces")]), _vm._v(" ("), _c('i', [_vm._v("ex officio")]), _vm._v(") gave us some pretty musick. I do not know and cannot utter a note of music and complicated harmonies seem to me a babble of confused though pleasing sounds. Yet songs and simple melodies especially if connected with words and ideas have as much effect on me as on most people. But then I hate to hear a young person sing without feeling and expression suited to the song. I cannot bear a voice that has no more life in it than a pianoforte or a bugle horn. There is something about all the fine arts of soul and spirit which like the vital principle in Man defies the research of the most critical anatomist. You feel where it is not, yet you cannot describe what it is you want. Sir Joshua or some other great painter was looking at a painting on which much pains had been bestowd – ‘Why yes’ he said in a hesitating manner – ‘it is very clever – very well done – can’t find fault – but it wants some thing – it wants – it wants – damn me – it wants that’ – throwing his hand over his head and snapping his fingers. Tom Moore’s is the most exquisite warbling I ever heard.\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("Next to him David Macculloch"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-98",
      "id": "num-footnote-1-98-back"
    }
  }, [_vm._v("16")]), _vm._v(" for Scots songs. The last when a boy at Dumfries was much admired by Burns who used to get him to try over the words which he composed to new melodies. He is brother of Macculloch of Ardwall.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00002"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00002"
    }
  }, [_vm._v("22 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" "), _c('i', [_vm._v("Moore")]), _vm._v(". I saw Moore"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-99",
      "id": "num-footnote-2-99-back"
    }
  }, [_vm._v("17")])]), _vm._v(" (for the first time I may say) this season. We had indeed met in public twenty years ago. There is a manly frankness and perfect ease and good breeding about him which is delightful. Not the least touch of the poet or the pedant. A little – very little man – less I think than Lewis"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-100",
      "id": "num-footnote-3-100-back"
    }
  }, [_vm._v("18")])]), _vm._v(" and somewhat like him in person, God knows not in conversation, for Matt though a clever fellow was a bore of the first description. Moreover he lookd always like a school boy. I remember a picture of him being handed about at Dalkeith House. It was a miniature I think by Saunders who had contrived to mufle Lewis’s person in a cloak and placed some poniard or darklanthorn appurtenance (I think) in his hand so as to give the picture the cast of a Bravo. ‘That like Matt Lewis’ said Duke Henry"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-101",
      "id": "num-footnote-4-101-back"
    }
  }, [_vm._v("19")])]), _vm._v(" to whom it had passd in turn. ‘Why that is like a man.’ Imagine the effect. Lewis was at his elbow. Now Moore has none of this insignificance. To be sure his person is much stouter than that of M. G. L. His countenance is decidedly plain but the expression is so very animated especially in speaking or singing that it is far more interesting than the finest features could have renderd.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00015"
    }
  }, [_vm._v("I was aware that Byron had often spoken both in private society and in his journal of Moore and myself in the same breath and with the same sort of regard."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-102",
      "id": "num-footnote-5-102-back"
    }
  }, [_vm._v("20")])]), _vm._v(" So I was curious to see what there could be in common betwixt us, Moore having lived so much in the gay world I in the country and with people of business and sometimes with\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("politicians, Moore a scholar – I none – He a musician and artist – I without knowledge of a note – He a democrat – I an aristocrat – with many other points of difference besides his being an Irishman, I a Scotchman, and both tolerably national. Yet there is a point of resemblance and a strong one. We are both goodhumoured fellows who rather seek to enjoy what is going forward than to maintain our dignity as Lions. And we have both seen the world too widely and too well not to contemn in our souls the imaginary consequence of literary people who walk with their noses in the air and remind me always of the fellow whom Johnson met in an ale-house and who calld himself ‘the great Twalmly, Inventor of the flood-gate iron for smoothing linen.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-103",
      "id": "num-footnote-1-103-back"
    }
  }, [_vm._v("21")]), _vm._v(" He also enjoys the "), _c('i', [_vm._v("Mot pour rire")]), _vm._v(" and so do I. Moore has I think been ill treated about Byron’s Memoirs. He surrenderd them to the family (Ld. Byron’s exors) and thus lost "), _c('i', [_vm._v("£")]), _vm._v("2000 which he had raised upon them at a most distressing moment of his life. It is true they offerd and pressd the money on him afterwards but they ought to have settled it with the Booksellers and not put poor Tom’s spirit in arms against his interest. I think at least it might have been so managed. At any rate there must be an authentic life of Byron by somebody. Why should they not give the benefit of their materials to Tom Moore whom Byron had made the depositary of his own Memoirs? But T. M. thinks that Cam Hobhouse"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-104",
      "id": "num-footnote-2-104-back"
    }
  }, [_vm._v("22")])]), _vm._v(" has the purpose of writing Byron’s life himself. He and Moore were at sharp words during the negotiation and there was some explanation necessary before the affair ended. It was a pity that nothing save the total destruction of Byron’s Memoirs would satisfy his Exors – But there was a reason – "), _c('i', [_vm._v("Premet Nox alta")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-105",
      "id": "num-footnote-3-105-back"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00016"
    }
  }, [_vm._v("It would be [a] delightful addition to life if T. M. had a cottage within two miles of one. We went to the theatre together and the House being luckily a good one received T. M. with rapture. I could have huggd them for it paid back the debt of the kind reception I met with in Ireland."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-106",
      "id": "num-footnote-4-106-back"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00018"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("Here is matter for a May morning."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-107",
      "id": "num-footnote-1-107-back"
    }
  }, [_vm._v("25")]), _vm._v(" But much fitter for a November one. The general distress in the city has affected H. and R.,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-108",
      "id": "num-footnote-2-108-back"
    }
  }, [_vm._v("26")])]), _vm._v(" Constable’s great agents. Should they "), _c('i', [_vm._v("go")]), _vm._v(" it is not likely that Constable can stand, and such an event would lead to great distress and perplexity on the part of J. B."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-109",
      "id": "num-footnote-3-109-back"
    }
  }, [_vm._v("27")])]), _vm._v(" and myself. Thank God I have enough at worst to pay 40/-in the pound taking matters at the very worst. But much distress and inconvenience must be the consequence. I had a lesson in 1814 which should have done good upon me."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-110",
      "id": "num-footnote-4-110-back"
    }
  }, [_vm._v("28")])]), _vm._v(" But success and abundance erazed it from my mind. But this is no time for journalizing or moralizing either. Necessity is like a sour-faced Cookmaid and I a turnspit whom she has flogged ere now till he mounted his wheel. If W-st-k can be out by 25 January it will do much and it is possible."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-111",
      "id": "num-footnote-5-111-back"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00019"
    }
  }, [_vm._v("Sir John Sinclair’s son has saved his comrade on shipboard (young Hope) by throwing himself overboard and keeping the other afloat – a very gallant thing. But the "), _c('i', [_vm._v("Gran Giag’ Asso")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-112",
      "id": "num-footnote-6-112-back"
    }
  }, [_vm._v("30")])]), _vm._v(" asks me to write a poem "), _c('i', [_vm._v("on the Civic crown")]), _vm._v(" of which he sends me a description quoted from Adam’s "), _c('i', [_vm._v("Antiquities")]), _vm._v(","), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-113",
      "id": "num-footnote-7-113-back"
    }
  }, [_vm._v("31")])]), _vm._v(" which mellifluous performance is to persuade the admiralty to give the young conservator promotion. Oh he is a rare Headpiece – an admirable Morion. I do not believe there is in nature such a full-acornd Boar."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-114",
      "id": "num-footnote-8-114-back"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00020"
    }
  }, [_vm._v("Could not write to purpose for thick coming fancies."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-9-115",
      "id": "num-footnote-9-115-back"
    }
  }, [_vm._v("33")])]), _vm._v(" The wheel would not turn easily and cannot be forced.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00001"
    }
  }, [_c('p', [_vm._v("My spinning wheel is auld and stiff")]), _vm._v(" "), _c('p', [_vm._v("    The rock o’t winna stand Sir.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00021"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_c('p', [_vm._v("To keep the temper-pin in tiff")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("   Employs aft my hand Sir."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-116",
      "id": "num-footnote-1-116-back"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00002"
    }
  }, [_vm._v("Went to dine at L— J— C—"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-117",
      "id": "num-footnote-2-117-back"
    }
  }, [_vm._v("35")])]), _vm._v(" as I thought by invitation but it was for tuesday se’en night. Returnd very well pleased not being exactly in the humour for company – and had a beefsteak. My appetite is surely excepting in quantity that of a farmer, for, eating moderately of anything, my epicurean pleasure is in the most simple diet. Wine I seldom taste when alone and use instead a little spirits and water. I have of late diminishd the quantity for fear of a weakness inductive to a diabetes, a disease which broke up my father’s health though one of the most temperate men who ever lived. I smoke a couple of segars instead which operates equally as a sedative –\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00003"
    }
  }, [_c('p', [_vm._v("Just to drive the cold winter away")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("And drown the fatigues of the day."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-118",
      "id": "num-footnote-3-118-back"
    }
  }, [_vm._v("36")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00022"
    }
  }, [_vm._v("I smoked a good deal about twenty years ago when at Ashestiel"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-119",
      "id": "num-footnote-4-119-back"
    }
  }, [_vm._v("37")])]), _vm._v(" but coming down one morning to the parlour I found as the room was small and confind that the smell was unpleasant and laid aside the use of the "), _c('i', [_vm._v("Nicotian weed")]), _vm._v(" for many years, but was again led to use it by the example of my son a Hussar officer, and my son-in-law an Oxford Student. I could lay it aside tomorrow – I laugh at the dominion of custom in this and many things.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00004"
    }
  }, [_c('p', [_vm._v("We make the giants first and then – "), _c('i', [_vm._v("do not")]), _vm._v(" kill them."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-120",
      "id": "num-footnote-5-120-back"
    }
  }, [_vm._v("38")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00003"
    }
  }, [_vm._v("23 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" On comparing notes with Moore I was confirmd in one or two points which I had always laid down in considering poor Byron’s [peculiarities]. One was that like Rousseau he was apt to be very suspicious, and a plain downright steadiness of manner was the true mode to maintain his good opinion. Will: Rose"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-121",
      "id": "num-footnote-6-121-back"
    }
  }, [_vm._v("39")])]), _vm._v(" told me that "), _c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("once while sitting with Byron he fixd insensibly his eyes on his feet, one of which it must be rememberd was deformd. Looking up suddenly he saw Byron regarding him with a look of concentrated and deep displeasure which wore off when he observed no consciousness or embarassment in the countenance of Rose. Murray"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-122",
      "id": "num-footnote-1-122-back"
    }
  }, [_vm._v("40")]), _vm._v(" afterwards explaind this by telling Rose that Lord Byron was very jealous of having this personal imperfection noticed or attended to. In another point Moore confirmd my previous opinion. Namely that Byron loved mischiefmaking. Moore had written to him cautioning him against the project of establishing the paper called the "), _c('i', [_vm._v("Liberal")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-123",
      "id": "num-footnote-2-123-back"
    }
  }, [_vm._v("41")])]), _vm._v(" in communion with such men as P. B. Shelley and Hunt on whom he said the World had set its mark. Byron shewd this to the parties. Shelley wrote a modest and rather affecting expostulation to Moore."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-124",
      "id": "num-footnote-3-124-back"
    }
  }, [_vm._v("42")])]), _vm._v(" These two peculiarities of extreme suspicion and love of mischief are both shades of the malady which certainly tinctured some part of the character of this mighty genius and, without some tendency towards which, genius – I mean that kind which depends on the imaginative power – perhaps cannot exist to great extent. The wheels of a machine to play rapidly must not fit with the utmost exactness else the attrition diminishes the Impetus.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00003"
    }
  }, [_vm._v("Another of Byron’s peculiarities was the love of mystifying which indeed may be referd to that of mischief. There was no knowing how much or how little to believe of his narratives. Instance. Mr. Bankes"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-125",
      "id": "num-footnote-4-125-back"
    }
  }, [_vm._v("43")])]), _vm._v(" expostulating with him upon a dedication which he had written in extravagant terms of praise to Cam Hobhouse, Byron told him that Cam had teased him into the dedication till he had said ‘Well; it shall be so – providing you will write the dedication yourself’ – and affirmd that Cam Hobhouse did write the high-colourd dedication accordingly. I mentiond this to Murray, having the report from Will Rose to whom Bankes had mentiond it. Murray in reply assured me that the dedication was written by Lord Byron himself and shewd it me in his own hand. I wrote to Rose to mention the thing to Bankes as it might have made mischief had the story got into the circle.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00023"
    }
  }, [_vm._v("Byron was disposed to think all men of imagination were addicted to mix fiction or poetry with their prose. He used to say he dared believe the celebrated courtezan of Venice about whom Rousseau makes so piquante a story was if one could see her a draggled taild wench enough. I believe that he embellishd his own amours considerably and that he was in many respects "), _c('i', [_vm._v("Le fanfaron des vices qu’il")]), _vm._v(" "), _c('i', [_vm._v("n’avait pas")]), _vm._v(". He loved to be thought awful mysterious and gloomy and sometimes hinted at strange causes. I believe the whole to have been the creation and sport of a wild and powerful fancy. In the same manner he "), _c('i', [_vm._v("cram’d")]), _vm._v(" people as it is termd about duels and what [not] which never existed or were much exaggerated.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00025"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("Constable has been here as lame as a duck upon his legs but his heart and courage as firm as a cock. He has convinced me we will do well to support the London House."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-126",
      "id": "num-footnote-1-126-back"
    }
  }, [_vm._v("44")]), _vm._v(" He has sent them about "), _c('i', [_vm._v("£")]), _vm._v("5000 and proposes we should borrow on our joint security "), _c('i', [_vm._v("£")]), _vm._v("5000 for their accomodation. J. B. and R. Cadell"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-127",
      "id": "num-footnote-2-127-back"
    }
  }, [_vm._v("45")])]), _vm._v(" present. I must be guided by them and hope for the best. Certainly to part company would be to incur an awful risque.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00026"
    }
  }, [_vm._v("What I liked about Byron besides his boundless genius was his generosity of Spirit as well as purse and his utter contempt of all the affectations of literature from the School-magisterial stile to the lackadaisical.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00027"
    }
  }, [_vm._v("Byron’s example has formed a sort of Upper House of poetry. There is Lord Leveson Gower a very clever young man. Lord Porchester too, nephew to Mrs Scott of Harden, a young man who lies on the carpet and looks poetical and dandyish – fine lad too – But")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00005"
    }
  }, [_c('p', [_vm._v("There be many peers")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Ere such another Byron."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-128",
      "id": "num-footnote-3-128-back"
    }
  }, [_vm._v("46")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Talking of Abbotsford it begins to be haunted by too much company of every kind. But especially foreigners. I do not like them. I hate fine waistcoats and breast pins upon dirty shirts. I detest the impudence that pays a stranger compliments and harangues about his works in the Author’s house, which is usually ill breeding. Moreover they are seldom long of making it evident that they know nothing about what they are talking of excepting having seen the "), _c('i', [_vm._v("Lady")]), _vm._v(" "), _c('i', [_vm._v("of the Lake")]), _vm._v(" at the Opera.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00005"
    }
  }, [_vm._v("Dined at Saint Catherine’s with Lord Advocate,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-129",
      "id": "num-footnote-4-129-back"
    }
  }, [_vm._v("47")])]), _vm._v(" with Lord and \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("Lady Mellville, Lord Justice Clerk, Sir Archd. Campbell of Succoth,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-130",
      "id": "num-footnote-1-130-back"
    }
  }, [_vm._v("48")]), _vm._v(" all class companions and acquainted well for more than 40 years. All excepting Lord J. C. were at Fraser’s class High School. Boyle joined us at college. There are besides, Sir Adam Fergusson,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-131",
      "id": "num-footnote-2-131-back"
    }
  }, [_vm._v("49")])]), _vm._v(" Colin Mackenzie,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-132",
      "id": "num-footnote-3-132-back"
    }
  }, [_vm._v("50")])]), _vm._v(" James Hope, Dr. James Buchan, Claud Russell,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-133",
      "id": "num-footnote-4-133-back"
    }
  }, [_vm._v("51")])]), _vm._v(" and perhaps two or three more of and about the same period. But\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00006"
    }
  }, [_c('p', [_c('i', [_vm._v("Rari apparent nantes in gurgite vasto")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-134",
      "id": "num-footnote-5-134-back"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00004"
    }
  }, [_vm._v("24"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" THURSDAY")]), _vm._v(" Talking of Strangers, London held some four or five years since one of those animals who are lions at first but by transmutation of two seasons become in regular course Boars. Ugo Foscolo"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-135",
      "id": "num-footnote-6-135-back"
    }
  }, [_vm._v("53")])]), _vm._v(" by name, a haunter of Murray’s Shop and of literary parties. Ugly as a baboon and intolerably conceited, he splutterd blusterd and disputed without even knowing the principles upon which men of sense render a reason and screamd all the while like a pig when they cut his throat.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00028"
    }
  }, [_vm._v("Another such Animalaccio is a brute of a Sicilian Marquis de Salvo"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-136",
      "id": "num-footnote-7-136-back"
    }
  }, [_vm._v("54")])]), _vm._v(" who wrote something about Byron. He inflicted two days on us at Abbotsford and they never know what to make of themselves in the forenoon; but sit tormenting the women to play at proverbs and such trash.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00006"
    }
  }, [_vm._v("Foreigner of a different caste. Count Olonym (Olonyne that’s it) son of the President of the Royal Society and a Capt. in the Imperial Guards. He is mean looking and sickly but has much sense, candour and general information.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00007"
    }
  }, [_vm._v("There was at Abbotsford and is here for education just now a young Count Davidow with a tutor Mr. Colyar. He is a nephew of the famous Orlows. It is quite surprizing how much sense and sound thinking this youth has at the early age of sixteen without the least self-conceit or forwardness. On the contrary he seems kind, modest and ingenuous. Yet to questions which I askd about the state of Russia he answerd with the precision and accuracy of twice his years. He is but sixteen. I should be sorry the saying were verified in him")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00029"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("So wise and young they say never live long."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-137",
      "id": "num-footnote-1-137-back"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00030"
    }
  }, [_vm._v("Saw also at Abbotsford two Frenchmen whom I liked, friends of Miss Dumergue."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-138",
      "id": "num-footnote-2-138-back"
    }
  }, [_vm._v("56")])]), _vm._v(" One calld Le Noir"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-139",
      "id": "num-footnote-3-139-back"
    }
  }, [_vm._v("57")])]), _vm._v(" is the author of a tragedy which he had the grace never to quote and which I, though poked by some malicious persons, had not the grace even to hint at. They were disposed at first to be complimentary but I convinced them it was not the custom here and they took it well and were agreeable.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00031"
    }
  }, [_vm._v("A little bilious this morning for the first time these six months. It cannot be the London matters which stick on my stomach for that is mending and may have good effects on myself and others.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00032"
    }
  }, [_vm._v("Dined with Robert Cockburn."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-140",
      "id": "num-footnote-4-140-back"
    }
  }, [_vm._v("58")])]), _vm._v(" Company Lord Melville and family, Sir John and Lady Hope, Lord and Ly. R. Kerr"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-141",
      "id": "num-footnote-5-141-back"
    }
  }, [_vm._v("59")])]), _vm._v(" and so furth. Combination of Coalliers general and coals up to double price. The men will not work "), _c('i', [_vm._v("although")]), _vm._v(" or rather "), _c('i', [_vm._v("because")]), _vm._v(" they can make from 30/-to 40/-per week. L. R. K. told us that he had a letter from Lord Forbes (son of Earl Granard, Ireland) that he was asleep in his house at Castle Forbes when awaked by a sense of suffocation which deprived him of the power of stirring a limb yet left him the consciousness that the house was on fire. At this moment and while his apartment was in flames his large dog jumpd on the bed, seized his shirt and dragd him to the stair-case where the fresh air restored his powers of exertion and of escape. This is very different from most cases of preservation of life by the canine race, when the animal generally jumps into the water in which he has force and skill. That of fire is as hostile to him as to mankind.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00033"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00003"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("25"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" FRIDAY")]), _vm._v(" Read Jeffrey’s neat and well intended address to the Mechanics upon their combinations."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-142",
      "id": "num-footnote-1-142-back"
    }
  }, [_vm._v("60")]), _vm._v(" Will it do good? – Umph. It takes only the hand of a Liliputian to light a fire but would require the diuretic powers of Gulliver to extinguish it."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-143",
      "id": "num-footnote-2-143-back"
    }
  }, [_vm._v("61")])]), _vm._v(" The Whigs will live and die in the heresy that the world is ruled by little pamphlets and speeches and that if you can sufficiently demonstrate that a line of conduct is most consistent with men’s interest you have therefore and thereby demonstrate [d] that they will at length after a few speeches on the subject adopt it of course. In this case we would have [no] need of laws or churches for I am sure there is no difficulty of proving that moral, regular, steady habits conduce to Men’s best interest and that vice is not sin merely but folly. But of these individuals each has passions and prejudices the gratification of which he prefers not only to the general weal but to that of himself as an individual. Under the action of these wayward impulses a man drinks to-day though he is sure of starving tomorrow – he murders tomorrow though [he] is sure to be hanged on Wednesday and people are so slow to believe that which makes against their own predominant passions that mechanics will combine to raise the price for one week though they destroy the manufacture for ever. The best remedy seems to be the probable supply of labourers from other trades. Jeffrey proposes each mechanic shall learn some other trade than his own and so have two strings to his bow. He does not consider the length of a double apprenticeship. To make a man a good weaver and a good tailor would require as much time as the patriarch served for his two wives. After all he would be but a poor workman at either craft. Each mechanic has indeed a second trade for he can dig and work rustic labour. Perhaps the best reason for breaking up the associations will prove to be the expenditure of the money which they have been simple enough to levy from the industrious to the support of the idle. How much provision for the sick and the aged, the widow and the orphan, have been expended in the attempt to get wages which the manufacturer cannot afford them at any profitable chance of selling his commodity.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00008"
    }
  }, [_vm._v("I had a bad fall last night coming home: there were unfinishd houses at the east end of Athole place and as I was on foot I crossd the street to avoid the material which lay about. But deceived by the moonlight I slippd ancle deep into a sea of mud (honest earth and water thank God) and fell on my hands. Never was there such a representative of "), _c('i', [_vm._v("Wall")]), _vm._v(" in Pyramus and Thisbe. I was absolutely rough cast. Luckily Lady S. had retired when I came home so I enjoyd my tub of water without either remonstrance or condoleances. Cockburn’s hospitality will get the benefit and renown of my downfall and yet has no claim to it. In future though I must take a coach at night. A controul on one’s freedom but it must be submitted to.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00034"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_110265-00001"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("N.B")]), _vm._v(". Within eight weeks after recording this graceful act of submissiom I found I was unable to keep a carriage\n            ")])])]), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("I found a letter from R. C."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-144",
      "id": "num-footnote-1-144-back"
    }
  }, [_vm._v("62")]), _vm._v(" giving a cheer-ing account of things in London. Their correspondent"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-145",
      "id": "num-footnote-2-145-back"
    }
  }, [_vm._v("63")])]), _vm._v(" is getting into his"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-146",
      "id": "num-footnote-3-146-back"
    }
  }, [_vm._v("64")])]), _vm._v(" strength. Three days ago I would have been contented to buy this "), _c('i', [_vm._v("consola")]), _vm._v(", as Judy says,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-147",
      "id": "num-footnote-4-147-back"
    }
  }, [_vm._v("65")])]), _vm._v(" dearer than by a dozen falls in the mud – for had the great Constable fallen\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00008"
    }
  }, [_c('p', [_vm._v("O my countrymen what a fall were there!"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-148",
      "id": "num-footnote-5-148-back"
    }
  }, [_vm._v("66")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00035"
    }
  }, [_vm._v("Mrs. Coutts"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-149",
      "id": "num-footnote-6-149-back"
    }
  }, [_vm._v("67")])]), _vm._v(" with the Duke of Saint Albans and Lady Charlotte Beauclerk"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-150",
      "id": "num-footnote-7-150-back"
    }
  }, [_vm._v("68")])]), _vm._v(" calld to take leave of us. When at Abbotsford his suit\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("throve but coldly. She made me I believe her confident in sincerity. She had refused him twice and decidedly he was merely on the footing of friendship. I urged it was akin to Love. She allowd she might marry the Duke only she had at present the least intention that way. Is this frank admission more favourable for the Duke than an absolute protestation against the possibility of such a marriage? I think not. It is the fashion to attend Mrs. Coutts’ parties and to abuse her."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-151",
      "id": "num-footnote-1-151-back"
    }
  }, [_vm._v("69")]), _vm._v(" I have always found her a kind friendly woman without either affectation or insolence in the display of her wealth and most willing to do good if the means be shewn to her. She can be very entertaining too as she speaks without scruple of her stage life. So much wealth can hardly be enjoyd without some ostentation but what then? If the Duke marries her he ensures an immense fortune. If she marries him she has the first rank. If he marries a woman older than himself by twenty years She marries a man younger in wit by twenty degrees. I do not think he will dilapidate her fortune – he seems quiet and gentle. I do not think that she will abuse his softness – of disposition shall I say or of heart – The disparity of ages concerns no one but themselves – So they have my consent to marry if they can get each other’s. Just as this is written enter my Lord of Saint Albans and Lady Charlotte to beg I would recommend a book of sermons to Mrs. Coutts – much obliged for her good opinion – recommended Logan’s"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-152",
      "id": "num-footnote-2-152-back"
    }
  }, [_vm._v("70")])]), _vm._v(" – One poet should always speak for another – The mission I suppose was a little display on the part of good Mrs. Coutts of authority over her high aristocratic Suitor. I do not suspect her of turning Dévote and retract my consent given as above unless she remains ‘lively brisk and jolly.’\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00036"
    }
  }, [_vm._v("Dined quiet with Wife and daughter.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00037"
    }
  }, [_vm._v("R. Cadell lookd in in the evening on business. I here register my purpose to practise oeconomies. I have little temptation to do otherwise. Abbotsford is all that I can make it and too large for the property so I resolve –")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00038"
    }
  }, [_vm._v("No more Building")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00039"
    }
  }, [_vm._v("No purchases of Land till times are quite safe")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00040"
    }
  }, [_vm._v("No buying books or expensive trifles – I mean to any extent. And Clearing off encumbrances with the returns of this year’s labour:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00042"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("Which resolutions with health and my habits of industry will make me ‘Sleep in spite of thunder.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-153",
      "id": "num-footnote-1-153-back"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00043"
    }
  }, [_vm._v("After all it is hard that the vagabond Stock-jobbing Jews should for their own purposes make such a shake of credit as now exists in London and menace the credit of men trading on sure funds like H. and R. It is just like a set of pickpockets who raise a mob in which honest folks are knocked down and plunderd that they may pillage safely in the midst of the confusion they have excited.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00004"
    }
  }, [_c('p')]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_110265-00002"
    }
  }, [_c('p', [_vm._v("I was obliged to give this up in consequence of my own misfortunes.")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00006"
    }
  }, [_vm._v("26"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" SATURDAY")]), _vm._v(" The court met late and sate till "), _c('i', [_vm._v("one")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-154",
      "id": "num-footnote-2-154-back"
    }
  }, [_vm._v("72")])]), _vm._v(" Detaind from that hour till four o’clock being engaged in the perplexd affairs of Mr. James Stewart of Brugh. This young gentleman is heir to a property of better than "), _c('i', [_vm._v("£")]), _vm._v("1000 a year in Orkney. His mother married very young and was wife mother and widow in the course of the first year. Being unfortunately under the direction of a careless perhaps an unfaithful agent She was unlucky enough to embarass her own affairs by money transactions with this person. I was askd to accept the situation of one of his curators and trust to clear out his affairs and hers – at least I will not fail for want of application. I have lent her "), _c('i', [_vm._v("£")]), _vm._v("300 on a second (and therefore doubtful) security over her house in Newington"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-155",
      "id": "num-footnote-3-155-back"
    }
  }, [_vm._v("73")])]), _vm._v(" bought for "), _c('i', [_vm._v("£")]), _vm._v("1000 and on which "), _c('i', [_vm._v("£")]), _vm._v("600 is already secured. I have no connection with the family except that of compassion and [may] not be rewarded even by thanks when the young man comes of age. I have known my father often so treated by those whom he had labourd to serve. But if we do not run some hazard in our attempts to do good where is the merit of them? So I will bring through my Orkney Laird if I can.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00044"
    }
  }, [_vm._v("Dined at home quiet with Lady S. and Anne.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00005"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00045"
    }
  }, [_vm._v("27"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" SUNDAY")]), _vm._v(" Some time since John Murray enterd into a contract with my son in law John G. Lockhart giving him on certain ample conditions the Management and Editorship of the "), _c('i', [_vm._v("Quarterly Review")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-156",
      "id": "num-footnote-4-156-back"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }, [_vm._v("for which they could certainly scarcely find a fitter person both from talents and character. It seems that Barrow"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-157",
      "id": "num-footnote-1-157-back"
    }
  }, [_vm._v("75")]), _vm._v(" and one or two stagers have taken alarm at Lockhart’s character as a satirist and his supposed accession to some of the freaks in Blackwood’s magazine"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-158",
      "id": "num-footnote-2-158-back"
    }
  }, [_vm._v("76")])]), _vm._v(" and down comes young D’Israeli"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-159",
      "id": "num-footnote-3-159-back"
    }
  }, [_vm._v("77")])]), _vm._v(" to Scotland imploring Lockhart to make interest with my friends in London to remove objections and so forth. I have no idea of telling all and sundry that my son in law is not a slanderer or a silly thoughtless lad although [he] was six or seven years ago engaged in some light satires. I only wrote to Heber"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-160",
      "id": "num-footnote-4-160-back"
    }
  }, [_vm._v("78")])]), _vm._v(" and to Southey"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-161",
      "id": "num-footnote-5-161-back"
    }
  }, [_vm._v("79")])]), _vm._v(" – the first upon the subject of the reports which had startled Murray (the most timorous as Byron calld him of all God’s booksellers) and such a letter as he may show Barrow if he judges proper – To Southey I wrote more generally acquainting him of my son’s appointment to the Editorship and mentioning his qualifications, touching at the same time on his very slight connection with "), _c('i', [_vm._v("Blackwd Magazine")]), _vm._v(" and his innocence as to those gambades which may have offended himself and Southey"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-162",
      "id": "num-footnote-6-162-back"
    }
  }, [_vm._v("80")])]), _vm._v(" and which I fear they may ascribe too truly to an eccentric neighbour of their own."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-163",
      "id": "num-footnote-7-163-back"
    }
  }, [_vm._v("81")])]), _vm._v(" I also mentiond that I heard nothing of the affair untill the month of October. I am concernd that Southey should know this for having been at the Lakes in September"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-164",
      "id": "num-footnote-8-164-back"
    }
  }, [_vm._v("82")])]), _vm._v(" I would not have him suppose that I \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v(" had been using interest with Canning"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-165",
      "id": "num-footnote-1-165-back"
    }
  }, [_vm._v("83")]), _vm._v(" or Ellis"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-166",
      "id": "num-footnote-2-166-back"
    }
  }, [_vm._v("84")])]), _vm._v(" to supersede young Mr. Coleridge"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-167",
      "id": "num-footnote-3-167-back"
    }
  }, [_vm._v("85")])]), _vm._v(" their Editor and place my Son [in] law in the situation. Indeed I was never more surprized than when this proposal came upon us. I suppose it had come from Canning originally as he was sounding Anne when at Colonel Bolton’s"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-168",
      "id": "num-footnote-4-168-back"
    }
  }, [_vm._v("86")])]), _vm._v(" about Lockhart’s views <he> etc. To me he never hinted anything on the Subject. Other views are held out to Lockhart which may turn to great advantage. Only one person (John Cay"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-169",
      "id": "num-footnote-5-169-back"
    }
  }, [_vm._v("87")])]), _vm._v(" of Charlton) knows their object and truly I wish it had not been confided to any one. Yesterday I had a letter from Murray in answer to one I had written in something a determined stile for I had no idea of permitting him to start from the course after my son giving up his situation and profession merely because a contributor or two chose to suppose gratuitously that Lockhart was too imprudent for the situation. My physic has wrought well for it brought a letter from Murray saying all was right,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-170",
      "id": "num-footnote-6-170-back"
    }
  }, [_vm._v("88")])]), _vm._v(" that D’Israeli was sent to me not to Lockhart, and that I was only invited to write two confidential letters, and other incoher-encies which intimate his fright has got into another quarter. It is interlined and franked by Barrow"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-171",
      "id": "num-footnote-7-171-back"
    }
  }, [_vm._v("89")])]), _vm._v(" which shows that all is well and that John’s induction in to his office will be easy and pleasant. I have not the least fear of his success. His talents want only a worthy sphere of exertion. He must learn however to despize petty adversaries. No good sportsman ought to shoot at crows unless for some special purpose. To take notice of such men as Hazlitt and Hunt in the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" would be to introduce them into a world which is scarce conscious of their existence. It is odd enough that many years since I had the principal share in erecting this Review which has been since  \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("so prosperous and now it is placed under management of my Son in Law upon the most honourable principle of "), _c('i', [_vm._v("detur digniori")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-172",
      "id": "num-footnote-1-172-back"
    }
  }, [_vm._v("90")]), _vm._v(" Yet there are sad drawbacks so far as family comfort is concernd. To-day is Sunday when they always dined with us and generally met a family friend or two. But we are no longer to expect them – In the country where their little cottage was within a mile or two of Abbotsford we shall miss their society still more for Chiefswood was the perpetual object of our walks, rides and drives. Lockhart is such an excellent family man so fond of his wife and child that I hope all will go well.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00046"
    }
  }, [_vm._v("A letter from Lockhart in the evening."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-173",
      "id": "num-footnote-2-173-back"
    }
  }, [_vm._v("91")])]), _vm._v(" All safe as to his unanimous reception in London. His predecessor young [Coleridge] handsomely and like a gentleman offers his assistance as a contributor etc.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00006"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00047"
    }
  }, [_vm._v("28"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" MONDAY")]), _vm._v(" I have the less dread or rather the less anxiety about the consequences of this migration that I repose much confidence in Sophia’s tact and good sense. Her manners are good and have the appearance of being perfectly natural. She is quite conscious of the limited range of her musical talents and never makes them common or produces them out of place – a rare virtue – Moreover she is proud enough and will not be easily netted and patronized by any of that class of Ladies who may be calld Lion-providers for town and country. She is domestic besides and will not be disposed to gad about. Then she seems an oeconomist and on "), _c('i', [_vm._v("£")]), _vm._v("3000, living quietly, there should be something to save."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-174",
      "id": "num-footnote-3-174-back"
    }
  }, [_vm._v("92")])]), _vm._v(" Lockhart must be liked where his good qualities are known and where his fund of information has room to be displayd. But notwithstanding a handsome exterior and face I am not sure he will succeed in London Society. He sometimes reverses the proverb and gives the "), _c('i', [_vm._v("volte strette e pensiere sciolti")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-175",
      "id": "num-footnote-4-175-back"
    }
  }, [_vm._v("93")])]), _vm._v(" – withdraws his attention from the company or attaches himself to some individual, gets into a corner and seems to be quizzing the rest. \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("This is the want of early habits of being in society and a life led much at College. Nothing is however so popular and so deservedly so as to take an interest in whatever is going forward in Society. A wise man always finds his account in it and will receive information and fresh views of life even in the Society of Fools. Abstain from society altogether when you are not able to play some part in it. This reserve and a sort of Hidalgo air joind to his character as a satirist have done the best humourd fellow in the world some injury in the opinion of Edinburgh folks."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-176",
      "id": "num-footnote-1-176-back"
    }
  }, [_vm._v("94")]), _vm._v(" In London it is of less consequence whether he please in general society or not since if he can establish himself as a genius it will only be calld ‘pretty Fanny’s way.’\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00048"
    }
  }, [_vm._v("People make me the oddest requests. It is not unusual for an Oxonian or Cantab who has out-run his allowance and of whom I know nothing to apply to me for the loan of "), _c('i', [_vm._v("£")]), _vm._v("20–"), _c('i', [_vm._v("£")]), _vm._v("50 or "), _c('i', [_vm._v("£")]), _vm._v("100. A Captain of the Danish naval service wrote to me that being in distress for a sum of money by which he might transport himself to Columbia to offer his services in assisting to free that province he had dreamd I generously made him a present of it. I can tell him his dream by contraries. I begin to find like Joseph Surface that too good a character is inconvenient."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-177",
      "id": "num-footnote-2-177-back"
    }
  }, [_vm._v("95")])]), _vm._v(" I don’t know what I have done to gain so much credit for generosity but I suspect I owe it to being supposed, as Puff says, one of ‘those whom Heaven has blessed with afluence.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-178",
      "id": "num-footnote-3-178-back"
    }
  }, [_vm._v("96")])]), _vm._v(" Not too much of that neither, my dear petitioners, though I may thank myself that your ideas are not correct.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00049"
    }
  }, [_vm._v("Dined at Melville Castle whither I went through a snow storm. I was glad to find myself once more in a place connected with many happy days."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-179",
      "id": "num-footnote-4-179-back"
    }
  }, [_vm._v("97")])]), _vm._v(" Met Sir R. Dundas and my old friend George now Lord Abercrombie"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-180",
      "id": "num-footnote-5-180-back"
    }
  }, [_vm._v("98")])]), _vm._v(" with his lady and a beautiful girl his daughter. He is what he always was, the best humourd man living, and our meetings now more rare than usual [this] was seasond with many a recollection of old frolics and old friends. I am entertaind to see him just the same he has always been, never yielding up his own opinion\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("in fact and yet in words acquiescing in all that could be said against it. George was always like a willow; he never offerd resistance to the breath of argument but never moved from his rooted opinion, blow as it listed.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110265-00050"
    }
  }, [_vm._v("Exaggeration might make these peculiarities highly dramatic. Conceive a man who always seems to be acquiescing in your sentiments yet never changes his own and this with a sort of bonhommie which shows there is not a particle of deceit intended. He is only desirous to spare you the trouble of contradiction.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00007"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00051"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("29 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" A letter from Southey, malcontent about Murray having accomplishd the change in the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" without speaking to him and quoting the twaddle of some old woman, male or female, about Lockhart’s earlier"), _c('i', [_vm._v(" jeux d’esprit")]), _vm._v(" but concluding most kindly that in regard to my daughter and me he did not mean to withdraw. That he has done yeoman’s service to the Review is certain – and his genius, his universal reading, his powers of regular industry and at the outset a name which though less generally popular than it deserves is still too respectable to be withdrawn without injury. I could not in reply point out to him what is the truth, that his rigid Toryism and high-church prejudices renderd him an unsafe coun-= sellor in a matter where the spirit of the age must be consulted. But I pointed out to him what I am sure is true that Murray, apprehensive of his displeasure, had not ventured to write to him out of mere timidity and not from any [depreciatory feeling]. I treated his old woman’s apprehensions and cautions and all that gossip about friends and enemies to which a splendid number or two will be a sufficient answer. And I accepted with due acknowlegment his proposal of continued support. I cannot say I was afraid of his withdrawing – Lockhart will have hard cards with him for great as Southey’s powers are he has not the art to make them work popularly. He is often diffuse and frequently sets much value on minute and unimportant facts and useless pieces of abstruse knowlege. Living too exclusively in a circle where he is idolized both for his genius and the excellence of his disposition he has acquired strong prejudices, though all of an upright and honourable cast. He rides his high church hobby too hard and it will not do to run a tilt upon it against all the world. Gifford"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-181",
      "id": "num-footnote-1-181-back"
    }
  }, [_vm._v("99")]), _vm._v(" used to crop his articles considerably and they bear marks of it being sometimes "), _c('i', [_vm._v("décousues")]), _vm._v(". Southey said that Gifford cut out his "), _c('i', [_vm._v("middle joints")]), _vm._v(". When\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v(" Johncomes to use the carving knife I fear Dr. Southey will not be so tractable. "), _c('i', [_vm._v("Nous")]), _vm._v(" "), _c('i', [_vm._v("verrons")]), _vm._v(". I will not shew Southey’s letter to J. Lockhart for there is to him personally no friendly tone and it would startle the Hidalgo’s pride. It is to be wishd they may draw kindly together."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-182",
      "id": "num-footnote-1-182-back"
    }
  }, [_vm._v("100")]), _vm._v(" Southey says most truly that even those who most undervalue his reputation would were he to withdraw from the review exaggerate the loss it would thereby sustain. The bottom of all these feuds, though not named, is "), _c('i', [_vm._v("Blackwood’s")]), _vm._v(" "), _c('i', [_vm._v("Magazine")]), _vm._v("; all the squibs of which, which have sometimes exploded among the Lakers, Lockhart is renderd accountable for. He must now exert himself at once with spirit and prudence – He has good backing. Canning, Bishop Bloomfield,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-183",
      "id": "num-footnote-2-183-back"
    }
  }, [_vm._v("101")])]), _vm._v(" Gifford, Wright,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-184",
      "id": "num-footnote-3-184-back"
    }
  }, [_vm._v("102")])]), _vm._v(" Croker,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-185",
      "id": "num-footnote-4-185-back"
    }
  }, [_vm._v("103")])]), _vm._v(" Will Rose, and is there not besides the Douglas? An excellent plot, excellent friends, and full of preparations."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-186",
      "id": "num-footnote-5-186-back"
    }
  }, [_vm._v("104")])]), _vm._v(" It was no plot of my making I am sure. Yet men will say and believe that I, who never heard a word of the matter till first a hint from Wright and then the formal proposal of Murray to Lockhart announcd [it to me, was the maker of it]. I believe Canning and Charles Ellis were the prime movers. I will puzzle my brains no more about it.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00052"
    }
  }, [_vm._v("Dined at Justice Clk’s. The presidt,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-187",
      "id": "num-footnote-6-187-back"
    }
  }, [_vm._v("105")])]), _vm._v(" Capt Smollet etcaetera. Our new Commander in Chief or Commanding in Chief Honble Sir Robert O’Callaghan,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-188",
      "id": "num-footnote-7-188-back"
    }
  }, [_vm._v("106")])]), _vm._v(" brother to Earl of Lismore, a fine soldierly looking man with orders and badges. His brother an Agreeable and deserving the name whom I met at Lowther Castle"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-189",
      "id": "num-footnote-8-189-back"
    }
  }, [_vm._v("107")])]), _vm._v(" this season. He composes his own musick and sings his own poetry, has much \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("humour enhanced by a strong touch of national dialect which is always a rich sauce to an Irishman’s good things. Dandyish but not offensively, and seems to have a warm feeling for the credit of his country rather inconsistent with the trifling and selfish quietude of a mere man of society.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00008"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00053"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("30 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" I am come to the time when those who look out at the windows shall be darkend."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-190",
      "id": "num-footnote-1-190-back"
    }
  }, [_vm._v("108")]), _vm._v(" I must now wear spectacles constantly in reading and writing, though till this winter I have made a shift by using only their occasional assistance. Although my health cannot be better I feel my lameness becomes sometimes painful and often inconvenient. Walking on the pavement or causeway gives me trouble and I am glad when I have accomplishd my return on foot from the Parliament House to Castle Street"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-191",
      "id": "num-footnote-2-191-back"
    }
  }, [_vm._v("109")])]), _vm._v(" though I can (taking a competent time as old "), _c('i', [_vm._v("Braxie")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-192",
      "id": "num-footnote-3-192-back"
    }
  }, [_vm._v("110")])]), _vm._v(" said on another occasion) walk five or six miles in the country with pleasure. Well – such things must come and be received with cheerful submission. My early lameness"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-193",
      "id": "num-footnote-4-193-back"
    }
  }, [_vm._v("111")])]), _vm._v(" considerd, it was impossible for a man labouring under a bodily impediment to have been stronger or more active than I have been, and that for twenty or thirty years. Seams will slit and elbows will out quoth the tailor"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-194",
      "id": "num-footnote-5-194-back"
    }
  }, [_vm._v("112")])]), _vm._v(" – and as I was fifty four on 15 August last my mortal vestments are none of the newest. Then Walter, Charles and Lockhart are as active and handsome young fellows as you can see and while they enjoy strength and activity I can hardly be said to want it. I have perhaps all my life set an undue value on these gifts. Yet it does appear to me that high and independent feelings are naturally though not uniformly or inseparably connected with bodily advantages. Strong men are usually goodhumourd and active men often display the same elasticity of mind as of body. These are superiorities however that are often misused. But even for these things God shall call us to judgement."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-195",
      "id": "num-footnote-6-195-back"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00055"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("Some months since I joind with other literary folks in subscribing a petition for a pension to Mrs. G—of L—n"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-196",
      "id": "num-footnote-1-196-back"
    }
  }, [_vm._v("114")]), _vm._v(" which we thought was a tribute merited by her works as an authoress and in my opinion much more by the firmness and elasticity of mind with which she had borne a succession of great domestic calamity. Unhappily there was only about "), _c('i', [_vm._v("£")]), _vm._v("100 open on the pension list and this the ministers assigned in equal portions to Mrs. G—and a distressd Lady, grand daughter of a forfeited Scottish nobleman. Mrs. G—, proud as a Highland woman, vain as a poetess and absurd as a Blue Stocking, has taken this partition "), _c('i', [_vm._v("in malam partem")]), _vm._v(" and written to Lord Melville about her merits, and that her friends do not consider her claims as being fairly canvassd, with something like a demand that her petition be submitted to the King. This is not the way to make her "), _c('i', [_vm._v("plack a bawbee")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-197",
      "id": "num-footnote-2-197-back"
    }
  }, [_vm._v("115")])]), _vm._v(" and Lord M. a little "), _c('i', [_vm._v("miffd")]), _vm._v(" in turn sends the whole correspondence to me to know whether Mrs. G. will accept the "), _c('i', [_vm._v("£")]), _vm._v("50 or not. Now hating to deal with ladies when they are in an unreasonable humour I have got the goodhumourd Man of Feeling"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-198",
      "id": "num-footnote-3-198-back"
    }
  }, [_vm._v("116")])]), _vm._v(" to find out the lady’s mind and I take on myself the task of making her peace with Lord M— There is no great doubt how it will end for your scornful dog will always eat your dirty pudding. After all the poor lady is greatly to be pitied. Her sole remaining daughter, deep and far gone in a decline, has been seized with alienation of mind.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00056"
    }
  }, [_vm._v("Dined with my cousin R. R."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-199",
      "id": "num-footnote-4-199-back"
    }
  }, [_vm._v("117")])]), _vm._v(" being the first invitation since my uncle’s death. Our Cousin Lt. Col. Russell"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-200",
      "id": "num-footnote-5-200-back"
    }
  }, [_vm._v("118")])]), _vm._v(" of Ashestiel with his sister Anne, the former newly returnd from India. A fine gallant fellow and distinguishd as a cavalry officer. He came overland from India and has observed a good deal. General L— of L— "), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-201",
      "id": "num-footnote-6-201-back"
    }
  }, [_vm._v("119")])]), _vm._v(", in Logan’s orthography a "), _c('i', [_vm._v("fowl")]), _vm._v(","), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-202",
      "id": "num-footnote-7-202-back"
    }
  }, [_vm._v("120")])]), _vm._v(" Sir William Hamilton,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-203",
      "id": "num-footnote-8-203-back"
    }
  }, [_vm._v("121")])]), _vm._v(" Miss Peggy\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("Swinton,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-204",
      "id": "num-footnote-1-204-back"
    }
  }, [_vm._v("122")]), _vm._v(" William Keith and others. Knight Marischal"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-205",
      "id": "num-footnote-2-205-back"
    }
  }, [_vm._v("123")])]), _vm._v(" not well so unable to attend this convocation of kith and kin.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00009"
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "rw-h2_110265-00002"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("DECEMBER")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00057"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Colonel R. told me that the European government had discoverd an ingenious mode of diminishing the number of burnings of widows. It seems the Shaster"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-206",
      "id": "num-footnote-3-206-back"
    }
  }, [_vm._v("124")])]), _vm._v(" positively enjoins that the pile shall be so constructed that if the victim should repent even at the moment when it is set on fire she may still have the means of saving herself. The Bramins soon found it was necessary to assist the resolution of the sufferers by means of a little pit into which they contrive to let the poor widow sink so as to prevent her reaping any benefit from a late repentance. But the Government has brought them back to the rigour of their law and only permit the burning to go on when the pile is constructed with full opportunity of a "), _c('i', [_vm._v("locus penitentiae")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-207",
      "id": "num-footnote-4-207-back"
    }
  }, [_vm._v("125")])]), _vm._v(". Yet the widow is so degraded if she dare to survive that the number of burnings is still great. The quantity of female children destroyed by the Rajahpout tribes Col. R. describes as very great indeed. They are strangled by the mother. The principle is the aristocratic pride of these high castes who breed up no more daughters than they can reasonably hope to find matches for in their own tribe. Singular how artificial systems of feeling can be made to overcome that love of offspring which seems instinctive in the females not of the human race only but of the lower animals. This is the reverse of our system of increasing game by shooting the old cock-birds. It is a system would aid Malthus rarely."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-208",
      "id": "num-footnote-5-208-back"
    }
  }, [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00058"
    }
  }, [_c('i', [_vm._v("Nota Bene")]), _vm._v(" the day before yesterday I signed the Bond for "), _c('i', [_vm._v("£")]), _vm._v("5000 with Constable for relief of Robinson’s House. I am to be secured by good bills.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00059"
    }
  }, [_vm._v("I think this Journal will suit me well; if I can coax myself into an idea that is purely voluntary it may go on – "), _c('i', [_vm._v("Nulla dies sine linea")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-209",
      "id": "num-footnote-6-209-back"
    }
  }, [_vm._v("127")])]), _vm._v(" But never a being from my infancy upwards hated task-work as I hate it –\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v(" And yet I have done a great deal in my day. It is not that I am idle in my nature neither. But propose to me to do one thing and it is inconceivable the desire I have to do something else, not that it is more easy or more pleasant but just because it is escaping from an imposed task. I cannot trace this love of contradiction to any distinct source but [it] has haunted me all my life. I could almost suppose it was mechanical and that the imposition of a piece of duty-labour operated on me like the mace of a bad billiard player, which gives an impulse to the ball indeed but sends it off at a tangent different from the course designed by the player. Now if I expend such eccentrick movements on this journal it will be turning this wretched propensity to some tolerable account. If I had thus employd the hours and half hours which I have while’d away in putting off something that must needs be done at last, My Conscience,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-210",
      "id": "num-footnote-1-210-back"
    }
  }, [_vm._v("128")]), _vm._v(" I should have had a journal with a witness.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00060"
    }
  }, [_vm._v("Sophia and Lockhart came to Edinr to-day and dined with us, meeting Hector Macdonald Buchanan,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-211",
      "id": "num-footnote-2-211-back"
    }
  }, [_vm._v("129")])]), _vm._v(" his Lady and Missy (familiarly so called) – James Skene"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-212",
      "id": "num-footnote-3-212-back"
    }
  }, [_vm._v("130")])]), _vm._v(" and his Lady – Lockhart’s friend Cay – etc.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00061"
    }
  }, [_vm._v("They are lucky to be able to assemble so many real friends whose good wishes I am sure will follow them in their new undertaking.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00010"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00062"
    }
  }, [_vm._v("2 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Rather a blank day for the Gurnal."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-213",
      "id": "num-footnote-4-213-back"
    }
  }, [_vm._v("131")])]), _vm._v("Correcting proofs in the morning – Court from ½ past ten till two – poor dear Colin Mackenzie, one of the wisest kindest and best men of his time, in the country – I fear with very indifferent health"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-214",
      "id": "num-footnote-5-214-back"
    }
  }, [_vm._v("132")])]), _vm._v(" – from two till five transacting business with J. B. All seems to go smoothly.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00063"
    }
  }, [_vm._v("Sophia dined with us alone, Lockhart being gone to the West to bid farewell to his father and brothers. Evening spent in talking with Sophia on their future prospects. God bless her, poor girl. She never gave me a moment’s reason to complain of her. But O my God that "), _c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("poor delicate child,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-215",
      "id": "num-footnote-1-215-back"
    }
  }, [_vm._v("133")]), _vm._v(" so clever, so animated, yet holding by this earth with so fearfully slight a tenure – Never out of his mother’s thoughts, almost never out of his father’s arms when he has but a single moment to give to anything. "), _c('i', [_vm._v("Deus providebit")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-216",
      "id": "num-footnote-2-216-back"
    }
  }, [_vm._v("134")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00011"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00064"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" R. P. G."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-217",
      "id": "num-footnote-3-217-back"
    }
  }, [_vm._v("135")])]), _vm._v("came to call last night to excuse himself from dining with Lockhart’s friends to-day. I really fear he is near an actual stand-still. He has been extremely improvident. When I first knew him he had an excellent estate and now he is deprived I fear of the whole reversion of the price. And this from no vice or extreme except a wasteful mode of buying pictures and other costly trifles at high prices and selling them again for nothing, besides an extravagant house-keeping and profuse hospitality. An excellent disposition with a considerable fund of acquired knowledge would have renderd him an agreeable companion had he not affected singularity and renderd himself accordingly singularly affected. He was very near being a poet but a miss is as good as a mile and he always fell short of the mark. I knew him first many years ago when he was desirous of my acquaintance but he was too poetical for me or I was not poetical enough for him so that we continued only ordinary acquaintance with goodwill on either side, which R. P. G. really deserves as a more friendly generous creature never lived. Lockhart hopes to get something done for him, being sincerely attachd to him, but says he has no hopes till he is utterly ruind. That point I fear is not far distant but what Lockhart can do for him then I cannot guess. His last effort faild owing to a curious reason. He had made some translations from the German which he does extremely [well],"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-218",
      "id": "num-footnote-4-218-back"
    }
  }, [_vm._v("136")])]), _vm._v(" for give him ideas and he never wants choice of good words, and Lockhart had got Constable to offer some sort of terms for them. R. P. G. has always, though possessing a beautiful power of handwriting, had some whim or other about imitating that of some other person and has written for months in the imitation of one or\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("other of his friends. Now at present he has renounced this amusement and chuses to write with a brush upon large cartridge paper somewhat in the Chinese fashion. So when his work which was only to extend to one or two volumes arrived on the shoulders of two porters in immense bales our jolly Bibliopolist backd out of the treaty and would have nothing more to do with R. P."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-219",
      "id": "num-footnote-1-219-back"
    }
  }, [_vm._v("137")]), _vm._v(" He is a creature that is or would be thought of imagination all compact"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-220",
      "id": "num-footnote-2-220-back"
    }
  }, [_vm._v("138")])]), _vm._v(" and is influenced by strange whims. But he is a kind, harmless, friendly soul and I fear has been cruelly plunderd of money which he now wants sadly.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00065"
    }
  }, [_vm._v("Dined with Lockhart’s friends, about fifty in number, who gave him a parting entertainment. John Hope Solicitor Genl."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-221",
      "id": "num-footnote-3-221-back"
    }
  }, [_vm._v("139")])]), _vm._v(" in the chair and Robert Dundas"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-222",
      "id": "num-footnote-4-222-back"
    }
  }, [_vm._v("140")])]), _vm._v(" Croupier. The company most highly respectable and any man might be proud of such an indication of the interest they take in his progress in life. Tory principles rather too violently upheld by some speakers. I came home about ten. The party sate late.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00012"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00066"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Lockhart and Sophia with his brother William dined with us"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-223",
      "id": "num-footnote-5-223-back"
    }
  }, [_vm._v("141")])]), _vm._v(" and talkd over our separation and the mode of their settling in London"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-224",
      "id": "num-footnote-6-224-back"
    }
  }, [_vm._v("142")])]), _vm._v(" and other family topics.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00013"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00067"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" This morning Lockhart and Sophia left us early and without leave-taking. When I arose at eight o’clock they were "), _c('i', [_vm._v("Gone")]), _vm._v(". This was very right. I hate red eyes and blowing of noses. "), _c('i', [_vm._v("Agere et pati")]), _vm._v(" "), _c('i', [_vm._v("Romanum est")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-225",
      "id": "num-footnote-7-225-back"
    }
  }, [_vm._v("143")])]), _vm._v(" Of all schools commend me to the Stoicks. We cannot indeed overcome our affections nor ought we if we could, but we repress them within due bounds and avoid coaxing them to make fools of those who should be their masters. I have lost some of the \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("comforts to which I chiefly lookd for enjoyment – well – I must make the more of such as remain. God bless them.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110265-00068"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("And so I will unto my holy work again"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-226",
      "id": "num-footnote-1-226-back"
    }
  }, [_vm._v("144")]), _vm._v(" which at present is the description of that "), _c('i', [_vm._v("heilige Kleeblat")]), _vm._v(" – that worshipful triumvirate Danton, Robespierre and Marat."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-227",
      "id": "num-footnote-2-227-back"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00069"
    }
  }, [_vm._v("I cannot conceive what possesses me over every person besides to mislay papers. I received a letter Saturday at e’en enclosing a bill for "), _c('i', [_vm._v("£750 no deaf nuts")]), _vm._v(" – well I read it and note the contents, and this day as if it had been a wind bill in the literal sense of the words I search every-where and lose three hours of my morning – turn over all my confusion in the writing desk – break open one or two letters lest I should have enclosed the sweet and quickly convertible document in them by mistake – send for a joiner and disorganize my scrutoire lest it should have fallen aside by mistake – I find it at last – the place where is of little consequence. But this trick must be amended.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00070"
    }
  }, [_vm._v("Dined at the Royal Society Club where as usual was a pleasant meeting of from 20 of 25. It is a very good institution. We pay two guineas only for six dinners in the year present or absent. Dine at 5 or rather ½ past five at the Royal hotel where we have an excellent dinner with soups fish etc. and all in good order, port and Sherry till half past seven then coffee and we go to the Society."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-228",
      "id": "num-footnote-3-228-back"
    }
  }, [_vm._v("146")])]), _vm._v(" This has great influence in keeping up the attendance, it being found that this preface of a good dinner to be paid for whether you partake or not brings out many a philosopher who might not otherwise have attended the Society.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00071"
    }
  }, [_vm._v("Harry Mackenzie now in his eighty second or third year read part of an Essay on Dreams."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-229",
      "id": "num-footnote-4-229-back"
    }
  }, [_vm._v("147")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00072"
    }
  }, [_vm._v("Supd at Dr. Russell’s usual party"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-230",
      "id": "num-footnote-5-230-back"
    }
  }, [_vm._v("148")])]), _vm._v(" – which shall serve for one while.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00014"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00073"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" A rare thing this literature or love of fame or notoriety which accompanies it. Here is Mr. H. M."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-231",
      "id": "num-footnote-6-231-back"
    }
  }, [_vm._v("149")])]), _vm._v(" on the very brink of human dissolution as actively anxious about it as if the curtain must not soon be closed on that and every thing else. He calls me his literary confessor and I am sure I am glad to return the kindnesses which he shewd me long since in George’s Square. No man is less known from his writings. We would suppose a retired, modest, somewhat affected man with a white handkerchief and a sigh ready for every sentiment. No such thing. H. M. is alert as a contracting tailor’s needle in every sort of business, a politician and a sportsman, shoots and fishes in a sort even to this day, and is the life of the company with anecdote and fun. Sometimes his daughter tells me he is in low spirits at home but really I never see anything of it in Society.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00075"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("There is a maxim almost universal in Scotland which I would like much to see contrould. Every youth of every temper and almost every description of character is sent either to study as a lawyer or to a Writer’s office as an apprentice. The Scottish seem to conceive Themis the most powerful of Goddesses. Is a lad stupid the Law will sharpen him – Is he too mercurial the law will make him sedate. Has he an estate he may get a sherrifdom – is he poor the richest Lawyers have emerged from poverty – Is he a Tory – he may become a Depute Advocate. Is he a Whig he may with far better hope expect to become in reputation at least ‘that rising counsel’ Mr.— when in fact he only rises at tavern dinners. Upon some such wild views lawyers and writers multiply till there is no life for them and men give up the chase hopeless and exhausted and go into the army at five and twenty instead of eighteen with a turn for expence perhaps – almost certainly for profligacy and with a heart embitterd against the loving parents or friends who compelld them to lose six or seven years in dusting the rails of the stove with their black gowns or scribbling nonsense for twopence a page all day and laying out twice their earnings at night in whisky punch. Here is R. L."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-232",
      "id": "num-footnote-1-232-back"
    }
  }, [_vm._v("150")]), _vm._v(" now – four or five years ago from certain indications I assured his friends L— would never be a writer – goodnatured lad too when Bacchus is out the question but at other times so pugnacious that it was evident he could only be properly placed where fighting was to be a part of his duty regulated by time and place and paid for accordingly. Well – time money and instruction have been thrown away, and now after fighting two regular boxing matches and a duel with pistols in the course of one week, he tells them roundly he will be no writer, which common sense might have told them before. He has now perhaps acquired habits of insubordination unfitting him for the army where he might have been tamed at an earlier period. He is too old for the Navy and so he must go to India, a Guinea-pig on board a Chinaman\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("– with what hope or view it is melancholy to guess. J. G. L. did all man could to get his friends to consent to his going into the army in time. The Lad has goodhumour, courage and most gentlemanlike feelings. But he is incurably dissipated I hear, so goes to die in youth in a foreign land.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110265-00076"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("Thank God I let Walter take his own way and I trust he will be a useful honourd soldier, being for his time high in the service, whereas at home he would probably have been a wine-bibbing, moorfowl shooting, fox hunting Fife Squire living at Lochore"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-233",
      "id": "num-footnote-1-233-back"
    }
  }, [_vm._v("151")]), _vm._v(" without either aim or end – And well if he were no worse. Dined at home with L. S. and Anne. Wrote in the Evening.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00015"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00077"
    }
  }, [_vm._v("7 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Teind day"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-234",
      "id": "num-footnote-2-234-back"
    }
  }, [_vm._v("152")])]), _vm._v(" at home of course. Wrote answers to [one] or two letters which have [been] lying on my desk like snakes hissing at me for my dilatoriness. Bespoke a ton of Palm oil from Sir John Tobin."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-235",
      "id": "num-footnote-3-235-back"
    }
  }, [_vm._v("153")])]), _vm._v(" Received a letter from Sir W. Knighton"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-236",
      "id": "num-footnote-4-236-back"
    }
  }, [_vm._v("154")])]), _vm._v(" mentioning that the King acquiesced in my proposal that Constable’s "), _c('i', [_vm._v("Miscellany")]), _vm._v(" should be dedicated to him."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-237",
      "id": "num-footnote-5-237-back"
    }
  }, [_vm._v("155")])]), _vm._v(" Enjoind however not to make this public till the drat. of dedication shall be approved. This letter tarried so long I thought some one had insinuated the proposal was "), _c('i', [_vm._v("infra dig")]), _vm._v(". I don’t think so. The purpose is to bring all the standard works both in sciences and the liberal arts within the reach of the lower classes and enable them thus to use with advantage the education which is given them at every hand. To make boys learn to read and then place no good books within their reach is to give men an appetite and leave nothing in the pantry save unwholesome and poisonous food which depend upon it they will eat rather than starve. Sir William it seems has been in Germany.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00079"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("Mighty dark this morning: it is past ten and I am using my lamp. The vast number of houses built beneath us to the North"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-238",
      "id": "num-footnote-1-238-back"
    }
  }, [_vm._v("156")]), _vm._v(" certainly render our street darker during the days when frost or haze prevents the smoke from rising. After all it may be my older eyes. I remember two years ago when Ld. H— "), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-239",
      "id": "num-footnote-2-239-back"
    }
  }, [_vm._v("157")])]), _vm._v(" began to fail somewhat in his limbs he observed that Ld. S— "), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-240",
      "id": "num-footnote-3-240-back"
    }
  }, [_vm._v("158")])]), _vm._v(" came to court at a more early hour than usual, whereas it was he himself who took longer time to walk the usual distance betwixt his house and the Parlt. Square. I suspect old gentlemen often make such mistakes.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00080"
    }
  }, [_vm._v("A letter from Southey"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-241",
      "id": "num-footnote-4-241-back"
    }
  }, [_vm._v("159")])]), _vm._v(" in a very pleasant strain as to Lockhart and myself – of Murray he has perhaps ground to complain, as well for consulting him late in the business as for the manner in which he intimated [it] to young Coleridge who had no reason to think himself handsomely treated though he has acquiesced in the arrangement in a very gentleman-like tone. With these matters we of course have nothing to do, having no doubt that the situation was vacant when M— offerd it as such. Southey says, in alteration of Byron’s phrase, that M. is the most timorous not of God’s but of the Devil’s booksellers. The truth I take to be that Murray was pushd in the change of editor (which was really become necessary) probably by Gifford, Canning, Ellis etc. and when he had fixd with Lockhart by their advice his constitutional nervousness made him delay entering upon a full explanation with Coleridge. But it is all settled now. I hope Lockhart will be able to mitigate their high-church bigotry – it is not for the present day, savouring too much of "), _c('i', [_vm._v("Jure divino")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-242",
      "id": "num-footnote-5-242-back"
    }
  }, [_vm._v("160")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00081"
    }
  }, [_vm._v("Dined quiet with Lady S. and Anne. Anne is practizing Scots songs which I take as a kind compliment to my own taste as hers leads her chiefly to foreign music. I think the good girl sees that I want and must miss her sister’s peculiar talent in singing the airs of our native country which, imperfect as my musical ear is, make and always have made the most pleasing impression on me – and so if she puts a constraint on herself for my sake, I can only say in requital God Bless Her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00083"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("I have much to comfort me in the present aspect of my family. My eldest son independent in fortune united to an affectionate wife – and of good hopes in his profession. My second with a good deal of talent and in the way I trust of cultivating it to good purpose. Anne an honest downright good Scots lass in whom I would only wish to correct a spirit of satire – And Lockhart is Lockhart to whom I can most willingly confide the happiness [of the] daughter who chose him, and whom he has chosen.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110265-00084"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("My dear wife, the partner of early cares and successes, is I fear frail in health – though I trust and pray she may see me out. Indeed if this troublesome complaint goes on – it bodes no long existence – My brother"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-243",
      "id": "num-footnote-1-243-back"
    }
  }, [_vm._v("161")]), _vm._v(" was affected with the same weakness which before he was fifty brought on mortal symptoms. The poor Major had been rather a free liver. But my father, the most abstemious of men save when the duties of hospitality required him to be very moderately free with his bottle and that was very seldom, had the same weakness of the powers of retention which now annoy me and he I think was not above seventy when cut off. Square the odds and goodnight Sir Walter about sixty. I care not, if I leave my name unstaind and my family properly settled. "), _c('i', [_vm._v("Sat est vixisse")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-244",
      "id": "num-footnote-2-244-back"
    }
  }, [_vm._v("162")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00016"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00085"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Talking of the "), _c('i', [_vm._v("Vixisse")]), _vm._v(" it may not be impertinent to notice that Knox,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-245",
      "id": "num-footnote-3-245-back"
    }
  }, [_vm._v("163")])]), _vm._v(" a young poet of considerable talent, died here a week or two since. His father was a respectable yeoman and he himself succeeding to good farms under the Duke of Buccleuch became too soon his own Master and plunged into dissipation and ruin. His poetical talent – a very fine one – then shewd itself in a fine strain of pensive poetry calld I think the "), _c('i', [_vm._v("Lonely Hearth")]), _vm._v(", far superior to those of Michael Bruce,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-246",
      "id": "num-footnote-4-246-back"
    }
  }, [_vm._v("164")])]), _vm._v(" whose "), _c('i', [_vm._v("consumptition")]), _vm._v(" by the way has been the life of his verses. But poetry, nay good poetry, is a drug in the present day. I am a wretched patron – I cannot go about with a subscription\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("paper like a pocket pistol about me and draw unawares on some honest country gentleman who has as much alarm as if I had used the phrase Stand and Deliver, and parts with his money with a grimace indicating some suspicion that the crown-piece thus levied goes ultimately into the Collector’s own pocket. This I see daily done and I have seen such collectors when they have exhausted Papa and Mamma continue their trade among the Misses and conjure out of their pockets those little funds which should carry them to a play or an assembly. It is well people will go through this – it does some good I suppose and they have great merit who can sacrifice their pride so far as to attempt it in this way. For my part I am a bad promoter of subscriptions but I wishd to do what I could for this lad whose talent I really admired, and I am not addicted to admire heaven-born poets or poetry that is reckond very good "), _c('i', [_vm._v("considering")]), _vm._v(". I had him, Knox, at Abbotsford about ten years ago but found him unfit for that sort of society. I tried to help him but there were temptations he could never resist. He scrambled on writing for the booksellers and magazines and living like the Otways and Savages and Chattertons of former days though I do not know that he was in actual want. His connection with me terminated in begging a subscription or a guinea now and then. His last works were Spiritual hymns and which he wrote very well. In his own line of Society he was said to exhibit infinite humour but all his works are grave and pensive a stile, perhaps like Master Stephen’s melancholy affected for the nonce."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-247",
      "id": "num-footnote-1-247-back"
    }
  }, [_vm._v("165")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00086"
    }
  }, [_vm._v("Mrs. G. of L."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-248",
      "id": "num-footnote-2-248-back"
    }
  }, [_vm._v("166")])]), _vm._v(" intimates that she will take her pudding – her pension I mean (See 30 November) – and is contrite as H. M."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-249",
      "id": "num-footnote-3-249-back"
    }
  }, [_vm._v("167")])]), _vm._v(" vouches. I am glad the stout old girl is not foreclosed, faith. Cabbing a pension in these times is like hunting a pig with a soap’d tail, monstrous apt to slip through your fingers.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00087"
    }
  }, [_vm._v("Dined at home with Lady S. and Anne.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00017"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("9 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Yesterday I read and wrote the whole day and evening. To-day I shall not be so happy having Gas Light Coy to attend at two. I must be brief in journalising.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00088"
    }
  }, [_vm._v("The gay world has been kept in hot water lately by the impudent publication of the celebrated Harriet Wilson."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-250",
      "id": "num-footnote-4-250-back"
    }
  }, [_vm._v("168")])]), _vm._v(" W—n from earliest possibility I suppose <who> lived with half the gay world at hack and manger; and now obliges such as will not pay hush-money with a history of whatever she knows or can invent about them. She must\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("have been assisted in the stile spelling and diction though the attempt at wit is very poor – that at pathos sickening. But there is some good retailing of conversations in which the stile of the speakers so far as known to me is exactly imitated, and some things told as said by individuals of each other which will sound unpleasantly in each other’s ears. I admire the address ofL—d A—y,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-251",
      "id": "num-footnote-1-251-back"
    }
  }, [_vm._v("169")]), _vm._v(" himself very severely handled from time to time. Someone asked him if H. W. had been pretty correct on the whole – ‘Why faith’ he replied ‘I believe so’ – when, raising his eyes, he saw Quentin Dick whom the little jilt had treated atrociously. ‘What concerns the present company always excepted you know’ added LordA—ywith infinite presence of mind. As he was "), _c('i', [_vm._v("in pari casu")]), _vm._v(" with Q. D. no more could be said. After all H. W. beats Con Philips, Anne Bellamy and all former demireps out and out. I think I suppd once inher company more than twenty years since atMat Lewis’s in Argyle Street where the Company, as the Duke says to Lucio, chanced to be fairer than honest."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-252",
      "id": "num-footnote-2-252-back"
    }
  }, [_vm._v("170")])]), _vm._v(" She was far from beautiful if it be the same "), _c('i', [_vm._v("chiffonne")]), _vm._v(" but a smart saucy girl with good eyes and dark hair and the manners of a wild schoolboy. I am glad this accidental meeting has escaped her memory – or perhaps is not accurately recorded in mine – for being a sort of French Faulkner who hawk at all they see"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-253",
      "id": "num-footnote-3-253-back"
    }
  }, [_vm._v("171")])]), _vm._v(" I might have had a distinction which I am far from deserving.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00089"
    }
  }, [_vm._v("Dined at Sir John Hay’s"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-254",
      "id": "num-footnote-4-254-back"
    }
  }, [_vm._v("172")])]), _vm._v(" – a large party. Skenes there – the Newenhams"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-255",
      "id": "num-footnote-5-255-back"
    }
  }, [_vm._v("173")])]), _vm._v(" and others, strangers. In the morning a meeting of O. Gas Committee. The concern lingers a little.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00009"
    }
  }, [_c('p', [_vm._v("It may do weel for ought it’s done yet")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("But only – it’s no just begun yet."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-256",
      "id": "num-footnote-6-256-back"
    }
  }, [_vm._v("174")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00090"
    }
  }, [_vm._v("10 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" A stormy and rainy day – walkd from the court through the rain. I don’t dislike this – Egad, I rather like it – for no man that ever stepd on heather has less dread than I of Le catch-cold and I seem to regain in buffetting with the wind a little of the high spirit with which in younger days I used to enjoy a Tam-of-Shanter ride through darkness wind and rain, the boughs groaning and cracking over my head, the good horse free to the road and impatient for home and feeling the weather as little as I did.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00091"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_c('p', [_vm._v("The storm around might roar and rustle")])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("We didna mind the storm a whistle."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-257",
      "id": "num-footnote-1-257-back"
    }
  }, [_vm._v("175")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Answerd two letters – One answer to a schoolboy who writes himself Captain of Giggleswick School (a most imposing title) entreating the youngster not to commence editor of a Magazine to be entitled the "), _c('i', [_vm._v("Yorkshire Muffin")]), _vm._v(" I think at seventeen years old. 2do. to a soldier of the 79th. shewing why I cannot oblige him by getting his discharge, and exhorting him rather to bear with the wickedness and profanity of the service than take the very "), _c('i', [_vm._v("precarious step of deser")]), _c('i', [_vm._v("tion")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-258",
      "id": "num-footnote-2-258-back"
    }
  }, [_vm._v("176")])]), _vm._v(" This is the old receipt of Durandarte Patience cousin and shufle "), _c('i', [_vm._v("the cards")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-259",
      "id": "num-footnote-3-259-back"
    }
  }, [_vm._v("177")])]), _vm._v(" and I suppose the correspondents will think I have been too busy in offering my counsel where I was askd for assistance.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00092"
    }
  }, [_vm._v("A third rogue writes to tell me, rather of the latest if the matter was of consequence, that he approves of the first three volumes of the "), _c('i', [_vm._v("H. of")]), _vm._v(" "), _c('i', [_vm._v("Midlothian")]), _vm._v(" but totally condemns the fourth."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-260",
      "id": "num-footnote-4-260-back"
    }
  }, [_vm._v("178")])]), _vm._v(" Doubtless he thinks his opinion worth the sevenpence Sterling which his letter costs. However an author should be reasonably well pleased when three fourths of his works are acceptable to the reader. The Knave demands of me in a postscript to get back the sword of Sir W. Wallace from England where it was carried from Dunbarton Castle. I am not Mr. Genl of the Ordnance that I know. It was wrong however to take away that and Mons Meg. If I go to town this spring I will renew my negotiation with the Great Duke for recovery of Mons Megs."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-261",
      "id": "num-footnote-5-261-back"
    }
  }, [_vm._v("179")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00094"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("There is no theme more awful than to attempt to cast a glance among the clouds and mists which hide the broken extremity of the celebrated Bridge of Mirza"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-262",
      "id": "num-footnote-1-262-back"
    }
  }, [_vm._v("180")]), _vm._v(" – yet when every day brings us nearer that termination one would almost think that our views should become clearer as the regions we are approaching are brought nigher – Alas it is not so – there is a curtain to be withdrawn, a veil to be rent, before we shall see things as they really are. There are few I trust who disbelieve the existence of a God – nay I doubt if at all times and in all moods any single individual ever adopted that hideous creed though some have professd it. With the belief of a Deity that of the Immortality of the soul and of the State of future rewards and punish-ments is indissolubly linked. More we are not to know but neither are we prohibited from our attempts however vain to pierce the solemn sacred gloom. The expressions used in scripture are doubtless smoking metaphorical, for penal fires and heavenly melody are only applicable to bodies endowd with senses, and at least till the period of the resurrection of the body the spirits of men, whether entering into the perfection of the just or committed to the regions of punishment, are incorporeal. Neither is [it] to be supposed that the glorified bodies which shall arise on [the] last day will be capable of the same gross indulgences with which they are now solaced. That the idea of Mahomet’s paradise is inconsistent with the purity of our heavenly religion will be readily granted, and see XII Mark 27 verse."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-263",
      "id": "num-footnote-2-263-back"
    }
  }, [_vm._v("181")])]), _vm._v(" Harmony is obviously chosen as the least corporeal of all gratifications of the sense and as the type of love, unity and a state of peace and of perfect happiness. But they have a poor idea of the Deity and the rewards which are destined for the Just made perfect who can only adopt the literal sense of an eternal concert – a never-ending Birthday Ode. I rather suppose there should be understood some commission from the Highest, some duty to discharge with the applause of a satisfied conscience – that the Deity who himself must be supposed to feel love and affection for the beings he has calld into existence should delegate a portion of those powers I for one cannot conceive altogether so wrong a conjecture. We would then find reality in Milton’s sublime machinery desired by Milton of the Guardian Saints or genii of Kingdoms. Nay, we would approach to the Catholic idea of the employment of Saints, though without approaching the absurdity of Saint-worship which degrades their religion. There would be, we must suppose, in these employments difficulties to be overcome and exertions to be made, for all which the Celestial beings employd would have certain appropriate powers. I cannot help thinking that a life of active benevolence is more consistent with my ideas than an eternity of music. But it is all speculation and it is impossible even to guess what we shall [do] unless we could ascertain the equally difficult previous question what we are to be. But there is a God and a just God – a judgement and a future life – and all who own so much let them act according to the faith that is in them. I would [not] of course limit the range of my genii to this confined earth – There is the universe with all its endless extent of worlds.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00096"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_41"
    }
  }, [_vm._v("Company at home Sir Adam Fergusson and his Lady. Colonel and Miss Russells, Count Davidoff and Mr. Collyar – By the bye I observe that all men whose name is obviously derived from some mechanical trade all endeavour to disguize and antiquate as it were their names by spelling them after some quaint manner or other. Thus we have Collyar – Smythe – Tailleure – as much as to say ‘My ancestor was indeed a mechanic but it was a world of time ago when the word was spelld very unlike the modern’ – then we had young Whitebank"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-264",
      "id": "num-footnote-1-264-back"
    }
  }, [_vm._v("182")]), _vm._v(" and Will: Allan the artist,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-265",
      "id": "num-footnote-2-265-back"
    }
  }, [_vm._v("183")])]), _vm._v(" a very agreeable, simple mannerd and pleasant man.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00018"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00097"
    }
  }, [_vm._v("11 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" A touch of the "), _c('i', [_vm._v("morbus eruditorum")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-266",
      "id": "num-footnote-3-266-back"
    }
  }, [_vm._v("184")])]), _vm._v(" to which I am as little subject as most folks and have it less now than when young. It is a tremor of the heart the pulsation of which becomes painfully sensible – a disposition to causeless alarm – much lassitude – and decay of vigour of mind and activity of intellect. The reins feel weary and painful and the mind is apt to receive and encourage gloomy apprehensions and causeless fears. Fighting with this fiend is not always the best way to conquer him – I have always found exercize and the open air better than reasoning. But such weather as is now without doors does not encourage "), _c('i', [_vm._v("La petitte guerre")]), _vm._v(" so we must give him battle in form; by letting both mind and body know that supposing one the House of Commons and the other the House of Peers, my will is Sovereign over both. There is a fine description of this species of mental weakness in the fine play of Beaumont and Fletcher calld "), _c('i', [_vm._v("The Lover’s Progress")]), _vm._v(" where [a] man warnd that his death is approaching works himself into an agony of fear and calls for assistance though there is no apparent danger. The apparition of the Innkeeper’s ghost in the same play hovers between the ludicrous and [the uncanny]. To me the touches of the former quality which it contains seem to augment the effect of the latter – they seem to give reality to the supernatural as being circumstance [s] with which an inventor would hardly have garnishd his story.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00099"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_42"
    }
  }, [_vm._v("Will Clerk says he has a theory on the vitrified forts."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-267",
      "id": "num-footnote-1-267-back"
    }
  }, [_vm._v("185")]), _vm._v(" I wonder if he and I agree. I think accidental conflagration is the cause.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00019"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00100"
    }
  }, [_vm._v("12 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Hogg"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-268",
      "id": "num-footnote-2-268-back"
    }
  }, [_vm._v("186")])]), _vm._v(" came to breakfast this morning, having taken and brought for his companion the Galashiels bard David Thompson"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-269",
      "id": "num-footnote-3-269-back"
    }
  }, [_vm._v("187")])]), _vm._v(" as to a meeting of huzz Tividale poets. The honest grunter opines with a delightful naïveté that Moore’s verses are far "), _c('i', [_vm._v("owre")]), _vm._v(" sweet – answerd by Thompson that Moore’s ears or notes, I forget which, were finely strung. ‘They are far owre finely strung’ replied He of the forest ‘for mine are just reeght’ – It reminded me of Queen Bess when questioning Melville"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-270",
      "id": "num-footnote-4-270-back"
    }
  }, [_vm._v("188")])]), _vm._v(" sharply and closely whether Queen [Mary was] taller than her and extracting an answer in the affirmative she replied ‘Then your Queen is too tall for I am just the proper height.’\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00101"
    }
  }, [_vm._v("Was engaged the whole day with Sheriff Court processes. There is something sickening in seeing poor devils drawn into great expence about trifles by interested attorneys. But too cheap access to litigation has its evils on the other hand, for the proneness of the lower class to gratify spite and revenge in this way would be a dreadful evil were they able to endure the expence. Very few cases come before the Sheriff Court of Selkirkshire that ought to come anywhere – wretched wranglings about a few pounds, begun in spleen and carried on from obstinacy, and at length from fear of the conclusion to the banquet of illhumour ‘D—n—n of expences’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-271",
      "id": "num-footnote-5-271-back"
    }
  }, [_vm._v("189")])]), _vm._v(" – I try to check it as well as I can. ‘But so ’twill be when I am gone.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-272",
      "id": "num-footnote-6-272-back"
    }
  }, [_vm._v("190")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00103"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_43"
    }
  }, [_vm._v("Dined at home and spent the evening in writing. Anne and Lady Scott at the theatre to see Mathews"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-273",
      "id": "num-footnote-1-273-back"
    }
  }, [_vm._v("191")]), _vm._v(" – A very clever man my friend Mathews but it is tiresome to be funny for a whole evening, so I was content and stupid at home.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00104"
    }
  }, [_vm._v("An odd optical delusion has amused me these two last nights. I have been of late for the first time condemnd to the constant use of spectacles. Now when I have laid them aside to step into a room dimly lighted out of the strong light which I use for writing I have seen or seemd to see through the rims of the same spectacles which I have left behind me. At first the impression was so lively that I put my hand to my eyes believing I had the actual spectacles on at the moment. But what I saw was only the Eidolon or image of said useful servants. This fortifies some of Dr. Hibbert’s positions about spectral appearances."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-274",
      "id": "num-footnote-2-274-back"
    }
  }, [_vm._v("192")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00020"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00105"
    }
  }, [_vm._v("13 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Letter from Lady Stafford, kind and friendly after the wont of Banzu-Mohr-ar-chat."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-275",
      "id": "num-footnote-3-275-back"
    }
  }, [_vm._v("193")])]), _vm._v(" That is wrong spelld I know. Her countenance is something for Sophia whose company should be, as Ladies are said to chuse their liquor, little and good –To be acquainted with persons of mere "), _c('i', [_vm._v("ton")]), _vm._v(" is a nuisance and a scrape – to be known to persons of real fashion and fortune is in London a very great advantage. She is besides sure of the hereditary and constant friendship of the Buccleuch ladies"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-276",
      "id": "num-footnote-4-276-back"
    }
  }, [_vm._v("194")])]), _vm._v(" as well as those of Montagu"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-277",
      "id": "num-footnote-5-277-back"
    }
  }, [_vm._v("195")])]), _vm._v(" and of the Harden family,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-278",
      "id": "num-footnote-6-278-back"
    }
  }, [_vm._v("196")])]), _vm._v(" of the Marchss. of Northampton,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-279",
      "id": "num-footnote-7-279-back"
    }
  }, [_vm._v("197")])]), _vm._v(" Lady Melville and others, also the Miss Ardens upon whose kind offices I have some claim"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-280",
      "id": "num-footnote-8-280-back"
    }
  }, [_vm._v("198")])]), _vm._v(" and would count upon them whether such claim existed or no. So she is well enough establishd among the Right Hand file"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-9-281",
      "id": "num-footnote-9-281-back"
    }
  }, [_vm._v("199")])]), _vm._v(" which is very necessary in London where second-rate fashion is like false jewels.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_44"
    }
  }, [_vm._v("Went to the yearly Court of the Edinr. Assurance Company"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-282",
      "id": "num-footnote-1-282-back"
    }
  }, [_vm._v("200")]), _vm._v(" to which I am one of those graceful and useless appendages calld Directors Extraordi [na] ry – an extraordinary director I should prove had they made me an ordinary one – there were there Moneyers and great Oneyers"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-283",
      "id": "num-footnote-2-283-back"
    }
  }, [_vm._v("201")])]), _vm._v(" – men of metal – Discounters and counters – Sharp grave prudential faces, eyes weak with cyphering by lamplight. Men who say to gold ‘Be thou paper’ and to paper ‘Be thou turnd into fine gold’ – Many a bustling sharp-faced keen eyed writer too – some perhaps speculating with their clients’ property. My reverend seigniors"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-284",
      "id": "num-footnote-3-284-back"
    }
  }, [_vm._v("202")])]), _vm._v(" had expected a motion for printing their contract which I as a piece of light artillery was brought down and got into battery to oppose. I should certainly have done this on the general ground that while each partner could at any time obtain sight of the contract at a call on the Directors or Managers it would be absurd to print it for the use of the company, and that exposing it to the world at large was in all respects unnecessary and might teach rival companies to avail themselves of our rules and calculations, if false for the purpose of exposing our errors, if correct for the purpose of improving their own schemes on our model. But my eloquence was not required, no one renewing the motion under question. So off I came my ears still ringing with the sounds of thousands and tens of thousands and my eyes dazzled with the golden gleam effused by so many capitalists.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00012"
    }
  }, [_vm._v("Walkd home with the Solicitor,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-285",
      "id": "num-footnote-4-285-back"
    }
  }, [_vm._v("203")])]), _vm._v(" decidedly the most hopeful young man of his time. High connexion – great talent – spirited ambition – a ready and prompt elocution with a good voice and dignified manner, prompt and steady courage, vigilant and constant assiduity, popularity with the young men and the good opinion of the old, will if I mistake not carry him as [far as] any man who has been since the days of old Hal Dundas."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-286",
      "id": "num-footnote-5-286-back"
    }
  }, [_vm._v("204")])]), _vm._v(" He is hot though and rather hasty. This should be amended – they who would play at single-stick must bear with patience a rap over the knuckles. Dined quietly with Lady Scott and Anne.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00107"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_45"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_45"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00021"
    }
  })]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_45"
    }
  }, [_vm._v("14 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Affairs very bad in the money market in London. It must come here and I have far too many engagements not to feel it. To cut the matter at once I intend to borrow "), _c('i', [_vm._v("£")]), _vm._v("10,000 with which my son’s marriage contract allows me to charge my estate – At Whitsunday and Marts I will have enough to pay up the incumbrance of "), _c('i', [_vm._v("£")]), _vm._v("3000 due to old Moss’s daughter and "), _c('i', [_vm._v("£")]), _vm._v("5000 to Misses Fergusson in whole or part."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-287",
      "id": "num-footnote-1-287-back"
    }
  }, [_vm._v("205")]), _vm._v(" This will enable us to dispense in a great measure with Bank assistance and sleep in spite of thunder."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-288",
      "id": "num-footnote-2-288-back"
    }
  }, [_vm._v("206")])]), _vm._v(" I do not know whether it is this business which makes me a little bilious or rather the want of exercize during the season of late and change of the weather to too much heat. Thank God my circumstances are good, upon a fair balance which I have are <not> certainly not less than "), _c('i', [_vm._v("£")]), _vm._v("40,000 or nearby "), _c('i', [_vm._v("£")]), _vm._v("50,000 above the world. But the Sun and Moon shall dance on the green ere carelessness or hope of gain or facility of getting cash shall make me go too deep again, were it but for the disquiet of the thing.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00013"
    }
  }, [_vm._v("Dined Ly. Scott and Anne quietly.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00022"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00108"
    }
  }, [_vm._v("15 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" R. P. G. came"), _c('i', [_vm._v(" sicut mos est")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-289",
      "id": "num-footnote-3-289-back"
    }
  }, [_vm._v("207")])]), _vm._v(" at five o’clock to make me confident of the extremities of his distress. It is clear all he has to do is to make the best agreement he can with his creditors. I remember many years since the poor fellow told me he thought there was something interesting in having difficulties – Poor lad he will have enough of them now. He talks about writing translations for the booksellers from the German to the amount of "), _c('i', [_vm._v("£")]), _vm._v("500 and "), _c('i', [_vm._v("£")]), _vm._v("600 but this is like a man proposing to run a whole day at top-speed. Yet if he had good subjects R. P. G. is one of the best translators I know, and something must be done for him certainly though I fear it will be necessary to go to the bottom of the ulcer – palliatives won’t do. Heis terribly imprudent, yet a worthy and benevolent creature – a great bore withal –\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00014"
    }
  }, [_vm._v("Dined alone with family. I am determined not to stand mine host to all Scotland and England as I have done. This shall be a saving since it must be a borrowing year – We heard from Sophia they are got safe to town but as Johnie had a little bag of meal with him to make his porridge on the road the whole Inn-yard assembled to see the operation. Junor his maid was of opinion that England was an awfu’ country to make parritch in. God bless the poor baby and restore his perfect health.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00109"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_46"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_46"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00023"
    }
  })]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_46"
    }
  }, [_vm._v("16 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" R. P. G. and his friend Robt. Wilson"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-290",
      "id": "num-footnote-1-290-back"
    }
  }, [_vm._v("208")]), _vm._v(" came, the former at five as usual, the latter at three as appointed. R. W. frankly said that R. P. G.’ s case was quite desperate – that he was insolvent and that any attempt to save him at present would be just so much cash thrown away. God knows at this moment I have none to throw away uselessly. For poor Gillies there was a melancholy mixture of pathos and affectation in his statement which really affected me while it told me that it would be useless to help him to money on such very empty plans. I endeavourd to persuade him to make a virtue of necessity, resign all to his creditors, and begin the world on a new leaf. I offerd him Chiefswood"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-291",
      "id": "num-footnote-2-291-back"
    }
  }, [_vm._v("209")])]), _vm._v(" for a temporary retirement. Lady Scott thinks I was wrong, and no body could less desire such a neighbour, all his affectations being caviare to me. But then the wife and children –\n         ")]), _vm._v(" "), _c('p', [_vm._v("Went again to the Solicitor on a wrong night – being askd for tomorrow. Lady Scott undertakes to keep my engagements recorded in future. "), _c('i', [_vm._v("Sed quis custodiat ipsam custodem?")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-292",
      "id": "num-footnote-3-292-back"
    }
  }, [_vm._v("210")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00024"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00110"
    }
  }, [_vm._v("17 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Dined with the Solicitor, Ld Ch. Baron,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-293",
      "id": "num-footnote-4-293-back"
    }
  }, [_vm._v("211")])]), _vm._v(" Sir William Boothby, nephew of old Sir Brooke the dandy poet. Annoyd with anxious presentiments which the night’s post must dispel or confirm. All in London as bad as possible.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00025"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00111"
    }
  }, [_vm._v("18 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Ballantyne calld on me this morning. "), _c('i', [_vm._v("Venit illa suprema")]), _vm._v(" dies."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-294",
      "id": "num-footnote-5-294-back"
    }
  }, [_vm._v("212")])]), _vm._v(" My extremity is come. Cadell has received letters from London which all but positively announce the failure of Hurst and Robinson so that Constable and Coy must follow and I must go with poor\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("James Ballantyne for company. I suppose it will involve my all. But if they leave me "), _c('i', [_vm._v("£")]), _vm._v("500 I can still make it "), _c('i', [_vm._v("£")]), _vm._v("1000 or "), _c('i', [_vm._v("£")]), _vm._v("1200 a year. And if they take my salaries of "), _c('i', [_vm._v("£")]), _vm._v("1300 and "), _c('i', [_vm._v("£")]), _vm._v("300"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-295",
      "id": "num-footnote-1-295-back"
    }
  }, [_vm._v("213")]), _vm._v(" they cannot but give me something out of them. I have been rash in anticipating funds to buy land. But then I made from "), _c('i', [_vm._v("£")]), _vm._v("5000 to "), _c('i', [_vm._v("£")]), _vm._v("10,000 a year, and land was my temptation. I think no body can lose a penny, that is one comfort – Men will think pride has had a fall. Let them indulge their own pride in thinking that my fall makes them higher or seem so at least. I have the satisfaction to recollect that my prosperity has been of advantage to many and that some at least will forgive my transient wealth on account of the innocence of my intentions and my real wish to do good to the poor. This news will make sad hearts at Darnick"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-296",
      "id": "num-footnote-2-296-back"
    }
  }, [_vm._v("214")])]), _vm._v(" and in the cottages of Abbotsford which I do not nourish the least hope of preserving. It has been my Dalilah and so I have often termd it – and now – the recollection of the extensive woods I have planted and the walks I have formed from which strangers must derive both the pleasure and profit will excite feelings likely to sober my gayest moments. I have half resolved never to see the place again – how could I tread my hall with such a diminishd crest? How live a poor indebted man where I was once the wealthy – the honourd? My children are provided – thank God for that. I was to have gone there on Saturday in joy and prosperity to receive my friends –my dogs will wait for me in vain – it is foolish – but the thoughts of parting from these dumb creatures have moved me more than any of the painful reflections I have put down – poor things I must get them kind masters. There may be yet those who loving me may love my dog because it has been mine. I must end this or I shall lose the tone of mind with which men should meet distress. I find my dogs’ feet on my knees – I hear them whining and seeking me everywhere – this is nonsense but it is what they would do could they know how things are – poor Will Laidlaw"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-297",
      "id": "num-footnote-3-297-back"
    }
  }, [_vm._v("215")])]), _vm._v(" – poor Tom Purdie"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-298",
      "id": "num-footnote-4-298-back"
    }
  }, [_vm._v("216")])]), _vm._v(" – this will be news to wring \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("your heart and many a poor fellow’s besides to whom my prosperity was daily bread.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110265-00112"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("Ballantyne behaves like himself and sinks his own ruin in con-templating mine. I tried to enrich him indeed and now all – all is gone. He will have the "), _c('i', [_vm._v("Journal")]), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-299",
      "id": "num-footnote-1-299-back"
    }
  }, [_vm._v("217")]), _vm._v(" still, that is a comfort, for sure they cannot find a better Editor – "), _c('i', [_vm._v("They")]), _vm._v(" – alas who will "), _c('i', [_vm._v("they")]), _vm._v(" be? the "), _c('i', [_vm._v("unbekanten Obern")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-300",
      "id": "num-footnote-2-300-back"
    }
  }, [_vm._v("218")])]), _vm._v(" who are to dispose of my all as they will? Some hard-eyed banker – some of those men of millions whom I described."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-301",
      "id": "num-footnote-3-301-back"
    }
  }, [_vm._v("219")])]), _vm._v(" Cadell shewd more kind and personal feeling to me than I thought he had possessd. He says there are some properties of works that will revert to me, the copy money not being paid. But it cannot be any very great matter I should think. Another person"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-302",
      "id": "num-footnote-4-302-back"
    }
  }, [_vm._v("220")])]), _vm._v(" did not afford me all the sympathy I expected, perhaps because I seemd to need little support – Yet that is not her nature which is generous and kind. She thinks I have been imprudent trusting men so far – perhaps so – but whatsoever I do I must sell my books to some one and these folks gave me the largest price. If they had kept their ground I could have brought myself round fast enough by the plan of 14 Decemr. I now view matters at the very worst and suppose that my all must go to supply the deficiencies of Constable. I fear it must be so. His connections with Hurst and Robinson have been so intimate that they must be largely involved. This is the worst of the concern; our own is comparatively plain sailing.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00113"
    }
  }, [_vm._v("Poor Gillies calld yesterday to tell me he was in extremity. God knows I had every cause to have returnd him the same answer. I must think his situation worse than mine as through his incoherent miserable tale I could see that he had exhausted each access to credit, and yet fondly imagines that bereft of all his accustomd indulgences he can work with a literary zeal unknown to his happier days. I hope he may labour enough to gain the mere support of his family. For myself the magic wand of the Unknown is shiverd in his grasp. He must henceforth be termd the Too well Known."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-303",
      "id": "num-footnote-5-303-back"
    }
  }, [_vm._v("221")])]), _vm._v(" The feast of fancy is over with the feeling of independence. I can no longer have the delight of waking in the morning with bright ideas in my mind,\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("haste to commit them to paper, and count them monthly as the means of planting such groves and purchasing such wastes, replacing my dreams’ fiction by other prospective visions of walks by\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_c('p', [_vm._v("Fountain-heads and pathless groves")])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("Places which pale passion loves"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-304",
      "id": "num-footnote-1-304-back"
    }
  }, [_vm._v("222")]), _vm._v(" –\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_110265-00003"
    }
  }, [_c('p', [_vm._v("Turn back to p. 41–42. I turnd the page accidentally and the partner of a Bankrupt concern ought not to waste two leaves of paper.")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00007"
    }
  }, [_vm._v("This cannot be – But I may make substantial husbandry – write history and such substantial concerns. They will not be received with the same enthusiasm– at least I much doubt the general knowlege that an author must write for his bread, at least for improving his pittance, degrades him and his productions in the public eye. He falls into the secondrate rank of estimation.")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00012"
    }
  }, [_c('p', [_vm._v("While the harness sore galls and the spurs his sides goad")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("The high mettled racer’s a hack on the road."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-305",
      "id": "num-footnote-2-305-back"
    }
  }, [_vm._v("223")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00008"
    }
  }, [_vm._v("It is a bitter thought, but if tears start at it let them flow. I amso much of this mind that if any one would now offer to relieve all my embarassments on condition I would continue the exertions which brought it there, dear as the place is to me, I hardly think I could undertake the labour on which I enterd with my usual alacrity only this morning; though not without a boding feeling of my exertions proving useless. Yet to save Abbotsford I would attempt all that was possible. My heart clings to the place I have created. There is scarce a tree on it that does not owe its being to me and the pain of leaving it is greater than I can tell. I have about "), _c('i', [_vm._v("£")]), _vm._v("10,000 of Constable’s for which I am bound to give literary value. But if I am obliged to pay other debts for him I will take leave to retain this sum at his credit. We shall have made some "), _c('i', [_vm._v("kittle")]), _vm._v(" questions of literary property, amongst us."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-306",
      "id": "num-footnote-3-306-back"
    }
  }, [_vm._v("224")])]), _vm._v(" Once more ‘Patience cousin and shuffle the cards.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-307",
      "id": "num-footnote-4-307-back"
    }
  }, [_vm._v("225")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00114"
    }
  }, [_vm._v("I have endeavourd at times to give vent to thoughts naturally so painful by writing these notices – partly to keep them at bay by busying myself with [the] history of the French Convention."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-308",
      "id": "num-footnote-5-308-back"
    }
  }, [_vm._v("226")])]), _vm._v(" I thank God I can do both with reasonable composure. I wonder how Anne will bear this afliction? She is passionate but stout-hearted and courageous in important matters though irritable in trifles. I am glad Lockhart and his wife are gone – Why? – I cannot tell but I "), _c('i', [_vm._v("am")]), _vm._v(" pleased to be left to my own regrets without being melted by condoleances though of the most sincere and affectionate kind.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00116"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_50"
    }
  }, [_vm._v("Anne bears her misfortune gallantly and well with a natural feeling no doubt of the rank and consideration she is about to lose. Lady Scott is incredulous and persists in cherishing hope where there is no ground for hope. I wish it may not bring on the Gloom of Spirits which has given me such distress. If she were the active person she once was that would not be. Now I fear it more than what Constable or Cadell will tell me this evening – To that my mind is made up.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_50"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110265-00117"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_50"
    }
  }, [_vm._v("Oddly enough it happend. Mine honest friend Hector"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-309",
      "id": "num-footnote-1-309-back"
    }
  }, [_vm._v("227")]), _vm._v(" came in before dinner to ask a copy of my seal of arms, with a sly kindliness of intimation that it was for some agreeable purpose.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00118"
    }
  }, [_c('i', [_vm._v("Half past eight")]), _vm._v(". I closed this book under the consciousness of impending ruin. I open it an hour after, thanks be to God!, with the strong hope that matters may be got over safely and honourably in a mercantile sense. Cadell came at eight to communicate a letter from Hurst and Robinson intimating they had stood the storm and, though clamourous for assistance from Scotland, saying they had prepared their strongholds without need of the Banks. This is all so far well. But I will not borrow any money on my estate till I see things reasonably safe. Stocks have risen from 42 to 46,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-310",
      "id": "num-footnote-2-310-back"
    }
  }, [_vm._v("228")])]), _vm._v(" a strong proof that confidence is restored. But I will yield to no delusive hopes. And fall back fall edge my resolutions hold. Whitaker the rascally bookseller whose slip for "), _c('i', [_vm._v("£")]), _vm._v("200,000 or thereabouts has brought ruin nearly on the trade kept seven hunters and be damnd to him. He must have ridden a fine weight to be sure with "), _c('i', [_vm._v("£")]), _vm._v("200,000 of honest people’s cash about him. I shall always think the better of Cadell for this – not merely because his feet are beautiful on the mountains who brings good tidings"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-311",
      "id": "num-footnote-3-311-back"
    }
  }, [_vm._v("229")])]), _vm._v(" but because he shewd feeling – deep feeling, poor fellow – he who I thought had no more than his numeration table and who if he had had his whole compting-house full of sensibility had yet his wife and children to bestow it upon. I will not forget this if I get through. I love the virtues of rough and round men. The others are apt to escape in salt rheum, sal volatile and a white pocket handkerchief. An odd thought strikes me. When I die will the journal of these day [s] be taken out of the Ebony cabinet at Abbotsford and read as the transient pout of a man worth "), _c('i', [_vm._v("£")]), _vm._v("60,000 with wonder that the well seeming Baronet should ever have experienced such a hitch? Or will it be found in some obscure lodginghouse where the decayd son of chivalry has hung up his scutcheon for some 20/-a week and where one or two old friends will look grave and whisper to each other, ‘poor gentleman’ – ‘a well meaning man’ – ‘nobody’s enemy but his own’ – ‘thought his parts could never wear out’ – ‘family poorly left’, ‘pity he took that foolish title’? Who can answer this question?\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00120"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_51"
    }
  }, [_vm._v("What a life mine has been. Half educated, almost wholly neglected or left to myself – stuffing my head with most nonsensical trash and undervalued in society for a time by most of my companions – getting forward and held a bold and clever fellow, contrary to the opinion of all who thought me amere dreamer – Broken-hearted for two years"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-312",
      "id": "num-footnote-1-312-back"
    }
  }, [_vm._v("230")]), _vm._v("–My heart handsomely pieced again"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-313",
      "id": "num-footnote-2-313-back"
    }
  }, [_vm._v("231")])]), _vm._v(" – but the crack will remain till my dying day – Rich and poor four or five times – Once at the verge of ruin yet opend new sources of wealth almost overflowing"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-314",
      "id": "num-footnote-3-314-back"
    }
  }, [_vm._v("232")])]), _vm._v(" – now taken in my pitch of pride and nearly winged (unless the good news hold) because London chuses to be in an uproar and in the tumult of bulls and bears a poor inoffensive lion like myself is pushd to the wall – And what is to be the end of it? God knows and so ends the chatechism."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-315",
      "id": "num-footnote-4-315-back"
    }
  }, [_vm._v("233")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00026"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00121"
    }
  }, [_vm._v("19 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Ballantyne here before breakfast. He looks on Caddel’s last night’s news with more confidence than I do. But I must go to work be my thoughts sober or lively. Constable came in and sate an hour. The old gentleman is firm as a rock and scorns the idea of Hurst and Robinson stopping. He talks of going up to London next week and making sales of our interest in "), _c('i', [_vm._v("W—k")]), _vm._v(" and "), _c('i', [_vm._v("Boney")]), _vm._v(" which would put a hedge round his finances. He is a very clever fellow and will I think bear us through.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00122"
    }
  }, [_vm._v("Dined at Lord Chief Baron’s – Ld. Justice Clerk, Lord President, Captn Scarlett, a gentlemanlike young man, the son of the great counsell"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-316",
      "id": "num-footnote-5-316-back"
    }
  }, [_vm._v("234")])]), _vm._v(" and a friend of my son Walter. Lady Charlotte Hope"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-317",
      "id": "num-footnote-6-317-back"
    }
  }, [_vm._v("235")])]), _vm._v(" and\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_52"
    }
  }, [_vm._v("other woman kind."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-318",
      "id": "num-footnote-1-318-back"
    }
  }, [_vm._v("236")]), _vm._v(" R. Dundas, Arnistoun, and his pleasant and good-humourd little wife whose quick intelligent look pleases me more, though her face be very plain, than a hundred mechanical Beauties.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00027"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00123"
    }
  }, [_vm._v("20 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Smoke the New pen."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-319",
      "id": "num-footnote-2-319-back"
    }
  }, [_vm._v("237")])]), _vm._v(" Oho-a-"), _c('i', [_vm._v("Swift")]), _vm._v(". The ordinary Bramahs become execrable so the knave puts the extras upon us. I like Ch: Ba: Shepherd very much – as much I think as any man I have learnd to know of late years. There [is] a neatness and precision, a closeness and truth, in the tone of [his] conversation which shows what a lawyer he must have been. Perfect goodhumour and suavity of manner with a little warmth of temper on suitable occasions. His great deafness alone prevented him from being Lord Chief Justice. I never saw a man so patient under such a malady. He loves society and converses excellently yet is often obliged in a mixd company particularly to lay aside his trumpet, retire into himself and withdraw from the talk. He does this with an expression of patience on his countenance which touches one much. He has occasion for patience otherwise I should think, for Lady S. is fine and fidgetty and too anxious to have everything point device.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00124"
    }
  }, [_vm._v("Constable’s licence for the dedication"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-320",
      "id": "num-footnote-3-320-back"
    }
  }, [_vm._v("238")])]), _vm._v(" is come which will make him happy.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00028"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00125"
    }
  }, [_vm._v("21 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Dined with James Ballantyne and met my old friend Matthews the Comedian with his son,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-321",
      "id": "num-footnote-4-321-back"
    }
  }, [_vm._v("239")])]), _vm._v(" now grown up a clever, rather forward lad who makes songs in the stile of John Smith"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-322",
      "id": "num-footnote-5-322-back"
    }
  }, [_vm._v("240")])]), _vm._v(" or Colman"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-323",
      "id": "num-footnote-6-323-back"
    }
  }, [_vm._v("241")])]), _vm._v(" and sings them with spirit. Rather lengthy though.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00127"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("There has been odd associations attending my two last meetings with Matthews. The last time I saw [him] before yesterday evening he dined with me in company with poor Sir Alexander Boswell who was killd within two or three months"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-324",
      "id": "num-footnote-1-324-back"
    }
  }, [_vm._v("242")]), _vm._v(" – I never saw Sir Alex. more. The time before was in 1815 when John Scott of Gala and I were returning from France and passd through London when we brought Matthews down as far as Leamington. Poor Byron lunchd with us or rather made an early dinner at Long’s and a most brilliant day we had of it. I never saw Byron so full of fun frolic wit and whim. He was as playful as a kitten – Well – I never saw him again – So this Man of mirth with his merry meetings has brought me no luck. I like better that he should throw in his talent of mimicry and humour into the present current tone of the Company than that he should be required to give this that or t’other "), _c('i', [_vm._v("bitt")]), _vm._v(" selected from his public recitations – They are good certainly – excellent – But then you "), _c('i', [_vm._v("must")]), _vm._v(" laugh and that is always severe to me. When I do laugh in sincerity the joke must be or seem unpremeditated. I could not help thinking in the midst of the glee what late gloom was over the minds of three of the company, Cadell, J. B., and the Journalist’s. What a strange scene if the surge of conversation could suddenly ebb like the tide and [shew] us the state of people’s real minds. Savary"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-325",
      "id": "num-footnote-2-325-back"
    }
  }, [_vm._v("243")])]), _vm._v(" might have been gay in such a party with all his forgeries in his heart.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00013"
    }
  }, [_c('p', [_vm._v("No eye the rocks discover")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Which lurk beneath the deep."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-326",
      "id": "num-footnote-3-326-back"
    }
  }, [_vm._v("244")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00009"
    }
  }, [_vm._v("Life could not be endured were it seen in reality.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00128"
    }
  }, [_vm._v("Things are mending in town and H. and R. write with confidence and are it would seem strongly supported by wealthy friends. Cadell and Constable are confident of their making their way through the storm and the impression of their stability is general in London. I hear the same from Lockhart. Indeed I now believe that they wrote gloomy letters to Constable chiefly to get as much money out of them as they possibly could. But they had well nigh over done it. This being Teind Wednesday must be a day of leisure and labour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00015"
    }
  }, [_vm._v("Sophia has got a house, 25 Pall-Mall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00016"
    }
  }, [_vm._v("Dined at home with Lady Scott and Anne.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00129"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00029"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00130"
    }
  }, [_vm._v("22 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" I wrote six of my close pages yesterd [ay] which is about twenty four pages in print. What is more I think it comes off twangingly. The story is so very interesting in itself that there is no fear of the book answering. Superficial it must be but I do not disown the charge. Better a superficial book which brings well and strikingly together the known and acknowleged facts than a dull boring narrative pausing to see further into a mill stone at every moment than the nature of the Mill stone admits. Nothing is so tiresome as walking through some beautiful scene with a minute philosopher, a botanist or pebble gatherer who is eternally calling your attention from the grand features of the natural scenery to look at grasses and chucky stones. Yet in their way they give useful information and so does the minute historian – Gad, I think that will look well in the preface.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00131"
    }
  }, [_vm._v("My bile is quite gone. I really believe it arose from mere anxiety. What a wonderful connexion between the mind and body.")])]), _c('p', {
    attrs: {
      "id": "rw-p_110265-00132"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("The air of ‘Bonnie Dundee’ running in my head to-day I [wrote] a few verses to it before dinner, taking the key-note from the story of Claverse leaving the Scottish Convention of Estates in 1688–9. I wonder if they are good – Ah poor Will: Erskine,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-327",
      "id": "num-footnote-1-327-back"
    }
  }, [_vm._v("245")]), _vm._v(" thou couldst and wouldst have told me. I must consult J. B. who is as honest as was W. E. But then though he has good taste too there is a little of "), _c('i', [_vm._v("Big Bow")]), _vm._v("-"), _c('i', [_vm._v("wow")]), _vm._v(" about it. Can’t say what made me take a frisk so uncommon of late years as to write verses of free will. I suppose the same impulse which makes birds sing when [a] storm seems blown over.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00133"
    }
  }, [_vm._v("Dined at Lord Minto’s."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-328",
      "id": "num-footnote-2-328-back"
    }
  }, [_vm._v("246")])]), _vm._v(" There were Lord and Lady Ruthven, Will: Clerk and Tho. Thomson,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-329",
      "id": "num-footnote-3-329-back"
    }
  }, [_vm._v("247")])]), _vm._v(" a right choice party. There was also my very old friend Mrs. Brydone,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-330",
      "id": "num-footnote-4-330-back"
    }
  }, [_vm._v("248")])]), _vm._v(" the relict of the traveller and\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_55"
    }
  }, [_vm._v("daughter of Principal Robertson and really worthy of such a connection, Lady Minto who is also peculiarly agreeable and her sister Mrs. Admiral Adam"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-331",
      "id": "num-footnote-1-331-back"
    }
  }, [_vm._v("249")]), _vm._v(" in the evening.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00030"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00134"
    }
  }, [_vm._v("23 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" The present Lord Minto is a very agreeable, well-informd and sensible man but he possesses neither the high breeding, ease of manner or eloquence of his father the first Earl."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-332",
      "id": "num-footnote-2-332-back"
    }
  }, [_vm._v("250")])]), _vm._v(" That Sir Gilbert was indeed a man among a thousand. I knew him very intimately in the beginning of the century and, which was very agreeable, was much at his house on very easy terms. He loved the Muses and worshipd them in secret and used to read some of [his] poetry which was but middling. One upon a walk with his lady which involved certain conclusions (most delicately couchd) but which it is not usual to allude [to]. Singu [l] ar that the wish to show what he thought and what perhaps was a clever thing was stronger than the feelings which induced to secrecy. Oh Vanity, where will you lead us poor authors. Tom Campbell"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-333",
      "id": "num-footnote-3-333-back"
    }
  }, [_vm._v("251")])]), _vm._v(" lived at Minto but it was in a state of dependence which he brookd very ill. He was kindly treated but would not see it in the right view and suspected slights and so on where no such thing was meant. There was a turn of Savage"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-334",
      "id": "num-footnote-4-334-back"
    }
  }, [_vm._v("252")])]), _vm._v(" about Tom though without his blackguardism – a kind of waywardness of mind and irritability that must have made a man of his genius truly unhappy.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00017"
    }
  }, [_vm._v("Lord Minto, with the mildest manners, was very tenacious of his opinions although he changed them twice in the crises of politics. He was the early friend of Fox and made a figure towards the end of the Americain war or during the struggles betwixt Fox and Pitt. Then came the Revolution and he joined the Anti Gallican party so keenly that he declared against Addington’s peace with France and was for a time I believe a Wyndamite. He was reconciled to the Whigs on the Fox and Grenville coalition but I have heard that Fox contrary to his wont retaind such personal feelings as led him [to] object to Sir Gilbert Elliot having a seat in the Cabinet. So he was sent Governor General to India – a better thing I take it for his fortune. He died shortly after his return at Hatfield or Barnet on his way down to his native country. He was a most pleasing and amiable man: I was very "), _c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("sorry for his death though I do not know how we should have met, for the contested election in 1805"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-335",
      "id": "num-footnote-1-335-back"
    }
  }, [_vm._v("253")]), _vm._v(" had placed some coldness betwixt the present Lord and me. I was certainly anxious for Sir Alexr. Don"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-336",
      "id": "num-footnote-2-336-back"
    }
  }, [_vm._v("254")])]), _vm._v(" both as friend of my most kind friend Charles Duke of Buccleuch"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-337",
      "id": "num-footnote-3-337-back"
    }
  }, [_vm._v("255")])]), _vm._v(" and on political accounts, and these thwartings are what men in public life do not like to endure. After a cessation of friendship for some years we have come about again – We never had the slightest personal dispute or disagreement. But politics are the blowpipe beneath whose influence the best cemented friendships too often disseve [r] and ours after all was only a very familiar acquaintance.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00135"
    }
  }, [_vm._v("It is very odd that the common people at Minto and the neighbourhood will not believe at this hour that the first Earl is dead. They think he had done some thing in India which he could not answer for – that the house was rebuilt on a scale unusually large to give him a suite of secret apartments and that he often walks about the woods and crags of Minto at night with a white night-cap and long white beard. The circumstance of his having died on the road down to Scotland is the sole foundation of this absurd legend which shows how willing the vulgar are to gull themselves when they can find no one else to take the trouble. I have seen people who could read write and cypher shrug their shoulders and look mysterious when this subject was mentiond. One very absurd addition was made on occasion of a great ball at Minto House which it was said was given to draw all people away from the grounds that the conceald Earl might have leisure for his exercize. This was on the principle in the German play"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-338",
      "id": "num-footnote-4-338-back"
    }
  }, [_vm._v("256")])]), _vm._v(" where to hide their conspiracy the Associates join in a chorus song.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00136"
    }
  }, [_vm._v("We dined at home. Mr. Davidoff and his tutor kept an engagement with us to dinner notwithstanding the death of the Emperor Alexander."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-339",
      "id": "num-footnote-5-339-back"
    }
  }, [_vm._v("257")])]), _vm._v(" They went to the play with the women kind. I staid at home to write.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00031"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00137"
    }
  }, [_vm._v("24 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Wrote Walter and Jane"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-340",
      "id": "num-footnote-6-340-back"
    }
  }, [_vm._v("258")])]), _vm._v(" – and gave [the] former an accompt of how things had been borne through in the money market and of the loan of "), _c('i', [_vm._v("£")]), _vm._v("10,000 – Constable has a scheme of publishing\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("the works of the Author of W—y in a superior stile at "), _c('i', [_vm._v("£")]), _vm._v("1.1. volume."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-341",
      "id": "num-footnote-1-341-back"
    }
  }, [_vm._v("259")]), _vm._v(" He says he will answer for making "), _c('i', [_vm._v("£")]), _vm._v("20,000 of this and liberally offerd me any share of the profit. I have no great claim to any as I have only to contribute the Notes which are light work, yet a few thousands coming in will be a good thing, besides the P. Office."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-342",
      "id": "num-footnote-2-342-back"
    }
  }, [_vm._v("260")])]), _vm._v(" Constable, though valetudinary and cross with his partner, is certainly as good a pilot in these rough seas as ever man put faith in. His rally put me in mind of the old song.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00014"
    }
  }, [_c('p', [_vm._v("The tailor raise and shook his duds")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("He gar’d the "), _c('i', [_vm._v("bills")]), _vm._v(" flee aff in cluds\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("And they that staid gat fearfu’ thuds")]), _vm._v(" "), _c('p', [_vm._v("    The Tailor proved a man O."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-343",
      "id": "num-footnote-3-343-back"
    }
  }, [_vm._v("261")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00010"
    }
  }, [_vm._v("We are for Abbotsford to-day with a light heart – ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00032"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "rw-p_110265-00138"
    }
  }, [_vm._v("Abbotsford.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00033"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    staticStyle: {
      "text-align": "justify"
    },
    attrs: {
      "id": "rw-p_110265-00139"
    }
  }, [_vm._v("25 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Arrived here last night at Seven. Our halls are silent compared to last year but let us be thankful when we think how near the chance appeard but a week since that these halls would have been ours no longer – "), _c('i', [_vm._v("Barbarus has segetes?")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-344",
      "id": "num-footnote-4-344-back"
    }
  }, [_vm._v("262")])]), _vm._v(" – "), _c('i', [_vm._v("Nullum numen abest si sit")]), _vm._v(" "), _c('i', [_vm._v("prudentia")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-345",
      "id": "num-footnote-5-345-back"
    }
  }, [_vm._v("263")])]), _vm._v(" There shall be no lack of wisdom – But come – "), _c('i', [_vm._v("il faut cultiver")]), _vm._v(" "), _c('i', [_vm._v("notre jardin")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-346",
      "id": "num-footnote-6-346-back"
    }
  }, [_vm._v("264")])]), _vm._v(" – Let us see – I will write out ‘The bonnets of Bonny Dundee’. I will sketch a preface to "), _c('i', [_vm._v("La Rochejacquelin")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-347",
      "id": "num-footnote-7-347-back"
    }
  }, [_vm._v("265")])]), _vm._v(" for Constable’s "), _c('i', [_vm._v("Miscellany")]), _vm._v(" and try about a specimen of notes for the W—y novels. If together with letters and by-business it will be a good day’s work.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00015"
    }
  }, [_c('p', [_vm._v("I make a vow")]), _vm._v(" "), _c('p', [_vm._v("And keep it true"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-348",
      "id": "num-footnote-8-348-back"
    }
  }, [_vm._v("266")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_58"
    }
  }, [_vm._v("I will take no invitation excepting for dinner only save to Newton Don and Mertoun tomorrow instead of Christmas Day."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-349",
      "id": "num-footnote-1-349-back"
    }
  }, [_vm._v("267")]), _vm._v(" On this day of General Devotion I have a particular call for gratitude!!.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00034"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00012"
    }
  }, [_vm._v("26 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" My God! what poor creatures we are. After all my fair proposals yesterday I was seized with a most violent pain in the right kidney and parts adjacent which, joind to deadly sickness which it brought on, forced me instantly to go to bed and send for Clarkson."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-350",
      "id": "num-footnote-2-350-back"
    }
  }, [_vm._v("268")])]), _vm._v(" He came and engineerd, pronouncing the complaint to be gravel augmented by bile – I was in great agony till about two o’clock but awaked with the pain gone. I got up, had a fire in my dressing closet, and had Dalgleish"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-351",
      "id": "num-footnote-3-351-back"
    }
  }, [_vm._v("269")])]), _vm._v(" to shave me – two trifles which I only mention because they [are] contrary to my hardy and independent personal habits. But although a man cannot be a heroe to his valet, his valet in sickness becomes of great use to him. I cannot expect that this first will be the last visit of this cruel complaint but shall we receive good at the hand of God and not receive evil?"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-352",
      "id": "num-footnote-4-352-back"
    }
  }, [_vm._v("270")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00035"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00141"
    }
  }, [_vm._v("27 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Slept twelve hours at a stretch being much exhausted with pain of last night and the action of the medicine. Totally without pain to-day but uncomfortable with the effects of calomel, which with me at least is like the assistance of an auxiliary army, just one degree more tolerable than the enemy it chases away. Calomel contempla-tions are not worth recording.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00142"
    }
  }, [_vm._v("I wrote an introduction and a few notes to the "), _c('i', [_vm._v("Memoirs of Made La")]), _vm._v(" "), _c('i', [_vm._v("Rochejacquelin")]), _vm._v(","), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-353",
      "id": "num-footnote-5-353-back"
    }
  }, [_vm._v("271")])]), _vm._v(" being all that I was equal to.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00143"
    }
  }, [_vm._v("Sir Adam Fergusson came over"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-354",
      "id": "num-footnote-6-354-back"
    }
  }, [_vm._v("272")])]), _vm._v(" and tried to marry my verses to the tune of ‘Bonnie Dundee.’ They seem well adapted to each other.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00144"
    }
  }, [_vm._v("Dined with Lady Scott and Anne.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00145"
    }
  }, [_vm._v("Worked at Pepys in the evening with the purpose of review for "), _c('a', {
    attrs: {
      "id": "pb-rw_59"
    }
  }, [_vm._v("Lockhart."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-355",
      "id": "num-footnote-1-355-back"
    }
  }, [_vm._v("273")]), _vm._v(" Notwithstanding the depressing effects of the calomel I feel the pleasure of being alone and uninterrupted. Few men leading a quiet life and without any strong or highly varied change of circumstances have seen more variety of Society than I – few have enjoyd it more or been "), _c('i', [_vm._v("bored")]), _vm._v(" as it [is] calld less by the company of tiresome people. I have rarely if ever found any one out of whom I could not extract amusement or edification and were I obliged to account for hints afforded on such occasions I should make an ample deduction from my inventive powers. Still however, from the earliest time I can remember, I preferd the pleasures of being alone to waiting for visitors, and have often taken a bannock and a bit of cheese to the wood or hill to avoid dining with company. As I grew from boyhood to manhood I saw this would not do and that to gain a place in men’s esteem I must mix and bustle with them. Pride and an excitation of spirits supplied the real pleasure which others seem to feel in society and certainly upon many occasions it was real. Still if the question was eternal company without the power of retiring within yourself or Solitary confinement for life I should say ‘Turnkey, Lock the cell.’ My life, though not without its fits of waking and strong exertion, has been a sort of dream spent in\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00016"
    }
  }, [_c('p', [_vm._v("Chewing the cud of sweet and bitter fancy."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-356",
      "id": "num-footnote-2-356-back"
    }
  }, [_vm._v("274")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00146"
    }
  }, [_vm._v("I have worn a wishing cap the power of which has been to divert present griefs by a touch of the wand of imagination and gild over the future prospect by prospects more fair than can ever be realized. Somewhere it is said that this castle building – this wielding of the aerial trowel – is fatal to exertions in actual life. I cannot tell – I have not found it so – I cannot indeed say like Made. Genlis that in the imaginary scenes in which I have acted a part I ever prepared myself for anything which actually befell me. But I have certainly fashiond out much that made the present hour pass pleasantly away and much that has enabled me to contribute to the amusement of the public. Since I was five years old I cannot remember the time when I had not some ideal part to play for my own solitary amusement.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-000002"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00013"
    }
  }, [_vm._v("28 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Some how I think the attack on Christmas day has been of a critical kind and having gone off so well may be productive\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_60"
    }
  }, [_vm._v("rather of health than continued indisposition. If one is to get a renewal of health in his fifty fourth year he must look to pay fine for it. Last night George Thompson"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-357",
      "id": "num-footnote-1-357-back"
    }
  }, [_vm._v("275")]), _vm._v(" came to see how I was, poor fellow. He has talent, is well informd, and has an excellent heart, but there is an eccentricity about him that defies description. I wish to God I saw him provided in a country kirk. That with a rational wife, that is if there is such a thing to be gotten for him, would I think bring him to a steady temper. At present he is between the tyning"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-358",
      "id": "num-footnote-2-358-back"
    }
  }, [_vm._v("276")])]), _vm._v(" and the winning. If I could get him to set to any hard study he would do something clever.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00147"
    }
  }, [_c('i', [_vm._v("How to make a critic")]), _vm._v(" – A sly rogue sheltering himself under the generick name of Mr. Campbell requested me through the penny post the loan of "), _c('i', [_vm._v("£")]), _vm._v("50 for two years, having an impulse as he said to make this demand. As I felt no corresponding impulse I beggd to decline a demand which might have been as reasonably made by any Campbell on earth and another impulse has determined the Man of fifty pounds to send me anonymous abuse of my works and temper and selfish disposition. The severity of the joke lies in 14d. for postage,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-359",
      "id": "num-footnote-3-359-back"
    }
  }, [_vm._v("277")])]), _vm._v(" to avoid which his next epistle shall go back to the clerks of the Post Office as not for S. W. S."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-360",
      "id": "num-footnote-4-360-back"
    }
  }, [_vm._v("278")])]), _vm._v(" How the severe rogue would be disappointed if he knew I never lookd at more than the first and last line of his satirical effusions.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00018"
    }
  }, [_vm._v("When I first saw that a literary profession was to be my fate I endeavourd by all efforts of stoicism to divest myself of that irritable degree of sensibility – or to speak plainly of Vanity – which makes the poetical race miserable and ridiculous. The anxiety of a poet for praise and for compliments I have always endea [vourd to avoid].")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00148"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00036"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00014"
    }
  }, [_c('span', [_vm._v("29 ")]), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Base feeling this same Calomel gives one. Mean poor and abject – a wretch as Will Rose says.\n         ")])]), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00017"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_c('p', [_vm._v("Fie fie on silly coward man")])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("That he should be the slave o’t."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-361",
      "id": "num-footnote-1-361-back"
    }
  }, [_vm._v("279")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00015"
    }
  }, [_vm._v("Then it makes one sinfully dogged and snappish, as Dr. Rutt [y] the Quaker says in his "), _c('i', [_vm._v("gurnal")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-362",
      "id": "num-footnote-2-362-back"
    }
  }, [_vm._v("280")])]), _vm._v(" Sent Lockhart four pages on Sheridan’s plays"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-363",
      "id": "num-footnote-3-363-back"
    }
  }, [_vm._v("281")])]), _vm._v(" – not very good I think but the demand came sudden. Must go to "), _c('i', [_vm._v("W—k")]), _vm._v(" yet am vexd by that humour of contradiction which makes me incline to do anything else in presence. Commenced preface for New Edition novels."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-364",
      "id": "num-footnote-4-364-back"
    }
  }, [_vm._v("282")])]), _vm._v(" The city of Cork send my freedom in a silver box."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-365",
      "id": "num-footnote-5-365-back"
    }
  }, [_vm._v("283")])]), _vm._v(" I thought I was out of their grace for going to see Blarney rather than the cove"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-366",
      "id": "num-footnote-6-366-back"
    }
  }, [_vm._v("284")])]), _vm._v(" for which I was attackd and defended in the papers when in Ireland. I am sure they are so civil that I would have gone wherever they wishd me to go if I had had any one to have told me what I ought to be most inquisitive about\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00018"
    }
  }, [_c('p', [_vm._v("For if I should as Lion come in strife")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Into such place ’twere pity of my life."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-367",
      "id": "num-footnote-7-367-back"
    }
  }, [_vm._v("285")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00016"
    }
  }, [_vm._v("30 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Spent at home and in labour – with the weight of unpleasant news from Edinburgh. J. B. is like to be pinched next week unless the loan can be brought forward. I must and have endeavourd to supply him. At present the result of my attempts are uncertain. I am even more anxious about C. and Coy unless they can get assistance from their London friends to whom they gave much. All is in God’s hands. The worst can only be what I have before anticipated. But I must I think renounce the Segars. They brought back (using two this evening) the irritation of which I had no feelings while abstaining from them. \n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00150"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_62"
    }
  }, [_vm._v("Dined alone with Gordon,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-368",
      "id": "num-footnote-1-368-back"
    }
  }, [_vm._v("286")]), _vm._v(" Lady S. and Anne.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00151"
    }
  }, [_vm._v("James Curle,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-369",
      "id": "num-footnote-2-369-back"
    }
  }, [_vm._v("287")])]), _vm._v(" Melrose, has handsomely lent me "), _c('i', [_vm._v("£")]), _vm._v("600. He has done kindly. I have served him before and will again if in my power.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00037"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00152"
    }
  }, [_vm._v("31 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Took a good sharp walk the first time since my illness and found myself the better in health and spirits. Being Hogmanae"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-370",
      "id": "num-footnote-3-370-back"
    }
  }, [_vm._v("288")])]), _vm._v(" there dined with us Colonel Russell and his sisters, Sir Adam Fergusson and Lady, Colonel Fergusson"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-371",
      "id": "num-footnote-4-371-back"
    }
  }, [_vm._v("289")])]), _vm._v(" with Mary and Margaret"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-372",
      "id": "num-footnote-5-372-back"
    }
  }, [_vm._v("290")])]), _vm._v(" – An auld-warld party who made themselves happy in the auld fashion. I felt so tired about eleven that I was forced to steal to Bed.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block footnotes"
  }, [_c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-83-back"
    }
  }, [_vm._v("1")])]), _vm._v(". For the members of Scott’s family, see Introduction, pp. xxxix—xli.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-84-back"
    }
  }, [_vm._v("2")])]), _vm._v(". The main purpose of Scott’s tour the previous July and August was to visit Walter and Jane, newly married, and quartered in Dublin. Lockhart and Anne were of the party. They went also to Maria Edgeworth at Edgeworthstown, and on the return journey passed some days at Storrs, on Lake Windermere, where Colonel Bolton was entertaining Canning. Wordsworth escorted them as far as Lowther Castle by way of Rydal Mount and Southey’s house at Keswick. "), _c('i', [_vm._v("Life")]), _vm._v(", viii. 1–52.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-85-back"
    }
  }, [_vm._v("3")])]), _vm._v(". See Introduction, p. xliv.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-86-back"
    }
  }, [_vm._v("4")])]), _vm._v(". "), _c('i', [_vm._v("An Essay on Naval Tactics, etc")]), _vm._v("., by John Clerk, 1790, reputed to have inspired Nelson’s tactics at Trafalgar.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-87-back"
    }
  }, [_vm._v("5")])]), _vm._v(". ‘Itch for argument’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-88-back"
    }
  }, [_vm._v("6")])]), _vm._v(". C. K. Sharpe (1781–1851), antiquary, artist, cynic, and dilettante, first met Scott in Oxford in 1802. He was living now at 93 Princes Street with his mother. Some of his characteristics are given to Sir Mungo Malagrowther in "), _c('i', [_vm._v("The Fortunes of Nigel")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-89-back"
    }
  }, [_vm._v("7")])]), _vm._v(". "), _c('i', [_vm._v("Secret and True History of the Church of Scotland from the Restoration to")]), _vm._v(" "), _c('i', [_vm._v("the year 1678")]), _vm._v(", 1817.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-90-back"
    }
  }, [_vm._v("8")])]), _vm._v(". Sir Robert Douglas’s "), _c('i', [_vm._v("Peerage of Scotland")]), _vm._v(", revised by John Philp Wood, 1813.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-91-back"
    }
  }, [_vm._v("9")])]), _vm._v(". Laetitia Matilda Hawkins’s "), _c('i', [_vm._v("Anecdotes, Biographical Sketches, and")]), _vm._v(" "), _c('i', [_vm._v("Memoirs")]), _vm._v(", 1822, pp. 91–117.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-92-back"
    }
  }, [_vm._v("10")])]), _vm._v(". Jemima, the tall, cheerful, noisy daughter of Hector Macdonald Buchanan, Scott’s fellow Clerk of Session. She was a frequent visitor and Scott was fond of her although he thought the Buchanan girls ‘accustomd to racket about a little too much’. "), _c('i', [_vm._v("Letters")]), _vm._v(", x. 506.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-93-back"
    }
  }, [_vm._v("11")])]), _vm._v(". This story goes the rounds as ‘a good anecdote by Sir Walter Scott’ and is heard in London three years later by Puckler Muskau. "), _c('i', [_vm._v("A")]), _vm._v(" "), _c('i', [_vm._v("Regency Visitor")]), _vm._v(", ed. E. M. Butler, 1957, p. 289.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-94-back"
    }
  }, [_vm._v("12")])]), _vm._v(". Clermont in Co. Louth.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-95"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-95-back"
    }
  }, [_vm._v("13")])]), _vm._v(". The Edinburgh Oil Gas Light Coy., of which Scott had been chairman since 1823, was never commercially successful. It struggled until 1828, when it sold out to its older rival the Edinburgh Gas Light Coy. For some account of the affairs of the company see Note 1, pp. 805–6. Abbotsford was one of the first houses in Scotland to be lit by gas.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-96-back"
    }
  }, [_vm._v("14")])]), _vm._v(". Sir Robert Dundas of Beechwood (1761–1836), Scott’s fellow Clerk of Session, with whose family the Scotts had lived on terms of great intimacy.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-97"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-97-back"
    }
  }, [_vm._v("15")])]), _vm._v(". Robert Saunders Dundas, second Viscount Melville (1771–1851), son of the great Lord Melville and a school friend of Scott’s, was at this time First Lord of the Admiralty and a powerful source of patronage in Scotland.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-98"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-98-back"
    }
  }, [_vm._v("16")])]), _vm._v(". David McCulloch, a Bengal merchant who had now retired to Cheltenham, and James McCulloch of Ardwall, near Gatehouse-of-Fleet in Kirkcudbrightshire, were brothers of Scott’s sister-in-law, Mrs. Thomas Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-99"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-99-back"
    }
  }, [_vm._v("17")])]), _vm._v(". Thomas Moore (1779–1852), the Irish poet and biographer, whose visit to Abbotsford earlier in the autumn is described by Lockhart in his "), _c('i', [_vm._v("Life")]), _vm._v(", viii. 65–72. Moore’s "), _c('i', [_vm._v("Life of Byron")]), _vm._v(", which appeared in 1830, was dedicated to Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-100"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-100-back"
    }
  }, [_vm._v("18")])]), _vm._v(". Matthew Lewis (1775–1818), author of "), _c('i', [_vm._v("The Monk")]), _vm._v(", whom Scott first met in Edinburgh in 1798. Lewis was the first man of letters to show him some attention and Scott contributed to his "), _c('i', [_vm._v("Tales of Wonder")]), _vm._v(", 1801.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-101"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-101-back"
    }
  }, [_vm._v("19")])]), _vm._v(". Henry, third Duke of Buccleuch (1746–1812).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-102"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-102-back"
    }
  }, [_vm._v("20")])]), _vm._v(". For an account of Scott’s meetings with Byron in 1815 see Lockhart’s "), _c('i', [_vm._v("Life")]), _vm._v(", v. 38–45 and 88. Byron, who had attacked Scott in "), _c('i', [_vm._v("English Bards and Scotch Reviewers")]), _vm._v(", made amends in "), _c('i', [_vm._v("Don Juan")]), _vm._v(", where he called him. ‘The Ariosto of the North’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-103"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-103-back"
    }
  }, [_vm._v("21")])]), _vm._v(". Boswell’s "), _c('i', [_vm._v("Life of Johnson")]), _vm._v(", iv. 193.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-104"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-104-back"
    }
  }, [_vm._v("22")])]), _vm._v(". John Cam Hobhouse (1786–1869), statesman and author, the early friend and travelling companion of Lord Byron, and his literary executor.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-105"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-105-back"
    }
  }, [_vm._v("23")])]), _vm._v(". ‘Deep night will cover it.’ Horace’s Odes, 1. iv. 16.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-106"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-106-back"
    }
  }, [_vm._v("24")])]), _vm._v(". At the Edinburgh Theatre there werèshouts, cheers, bravo, and applause’ when Scott, Moore, Lockhart, and Sophia entered in time to see "), _c('i', [_vm._v("The Abbot")]), _vm._v("; and Moore, ‘though modestly reluctant, at last yielded, and bowed, hand on heart, with graceful animation’. Dibdin, pp. 317–18.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Scott’s arrival in the theatre in Dublin the previous July had been greeted by ‘a perfect cataract and thunder of roaring’ which had brought the play to a standstill. "), _c('i', [_vm._v("Life")]), _vm._v(", viii. 21.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-107"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-107-back"
    }
  }, [_vm._v("25")])]), _vm._v(". "), _c('i', [_vm._v("Twelfth Night")]), _vm._v(", iii. 4.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-108"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-108-back"
    }
  }, [_vm._v("26")])]), _vm._v(". Hurst, Robinson and Co., the London booksellers whose fall brought on the failure of Constable and ultimately Scott’s ruin.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-109"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-109-back"
    }
  }, [_vm._v("27")])]), _vm._v(". James Ballantyne.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-110"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-110-back"
    }
  }, [_vm._v("28")])]), _vm._v(". The failure of his venture into publishing as John Ballantyne & Coy. "), _c('i', [_vm._v("Life")]), _vm._v(", iv. 73–123.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-111"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-111-back"
    }
  }, [_vm._v("29")])]), _vm._v(". To bolster confidence in Constable & Coy., Scott agreed with Cadell on this day to advertise that "), _c('i', [_vm._v("Woodstock")]), _vm._v(" would be published on 25 January. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 301. In fact it did not appear until the following April.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-112"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-112-back"
    }
  }, [_vm._v("30")])]), _vm._v(". Scott’s charity always fails him when he has to mention Sir John Sinclair of Ulbster (1754–1835). A Highland landowner, with advanced ideas on farming, he had been President of the Board of Agriculture and supervised "), _c('i', [_vm._v("The Statistical Account of Scotland")]), _vm._v(". At this time he held the sinecure of Commissioner of Excise. For a later impertinence see the Entry for 13 September 1826.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-113"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-113-back"
    }
  }, [_vm._v("31")])]), _vm._v(". Alexander Adam’s "), _c('i', [_vm._v("Roman Antiquities")]), _vm._v(", 1791. Adam had been Scott’s headmaster.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-114"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-114-back"
    }
  }, [_vm._v("32")])]), _vm._v(". An allusion to "), _c('i', [_vm._v("Cymbeline")]), _vm._v(", ii. 4.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-9-115"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-9-115-back"
    }
  }, [_vm._v("33")])]), _vm._v(". "), _c('i', [_vm._v("Macbeth")]), _vm._v(", v. 3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-116"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-116-back"
    }
  }, [_vm._v("34")])]), _vm._v(". ‘My Jo Janet’ in Allan Ramsay’s "), _c('i', [_vm._v("Tea-Table Miscellany")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-117"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-117-back"
    }
  }, [_vm._v("35")])]), _vm._v(". The Lord Justice-Clerk, the Rt. Hon. David Boyle (1772–1853).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-118"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-118-back"
    }
  }, [_vm._v("36")])]), _vm._v(". From ‘Come, come, my Hearts of Gold’ with and ‘Every man take a glass in his hand’. "), _c('i', [_vm._v("The Vocal Miscellany")]), _vm._v(", i. 163 and 103.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-119"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-119-back"
    }
  }, [_vm._v("37")])]), _vm._v(". From 1804 to 1812, the year in which he moved to Abbotsford, Scott rented Ashestiel from his cousin Colonel Russell who was at that time in India.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-120"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-120-back"
    }
  }, [_vm._v("38")])]), _vm._v(". Adapted from Fielding’s"), _c('i', [_vm._v(" Tom Thumb the Great")]), _vm._v(", i. 5.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-121"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-121-back"
    }
  }, [_vm._v("39")])]), _vm._v(". William Stewart Rose (1775–1843), poet and translator of Ariosto, who until 1824 was Reading-Clerk in the House of Lords. Scott first met him in London in 1803. He, as well as Lady Louisa Stuart, wrote introducing Morritt to Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-122"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-122-back"
    }
  }, [_vm._v("40")])]), _vm._v(". John Murray (1778–1843) of Albemarle Street. He was Constable’s London agent until 1813 and publisher of the "), _c('i', [_vm._v("Quarterly")]), _vm._v(". He introduced Scott to Byron.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-123"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-123-back"
    }
  }, [_vm._v("41")])]), _vm._v(". A quarterly magazine of which only four numbers appeared, remembered chiefly for Byron’s "), _c('i', [_vm._v("Vision of Judgment")]), _vm._v(" (1822) in the first number.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-124"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-124-back"
    }
  }, [_vm._v("42")])]), _vm._v(". See Moore’s "), _c('i', [_vm._v("Life of Byron")]), _vm._v(", v. 313–21.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-125"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-125-back"
    }
  }, [_vm._v("43")])]), _vm._v(". William John Bankes (d. 1855), the traveller, wit, and friend of Byron.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-126"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-126-back"
    }
  }, [_vm._v("44")])]), _vm._v(". Hurst, Robinson.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-127"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-127-back"
    }
  }, [_vm._v("45")])]), _vm._v(". For Robert Cadell see Introduction, p. xlii.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-128"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-128-back"
    }
  }, [_vm._v("46")])]), _vm._v(". An allusion to "), _c('i', [_vm._v("Cymbeline")]), _vm._v(", iii. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-129"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-129-back"
    }
  }, [_vm._v("47")])]), _vm._v(". Sir William Rae, Bart. (1769–1842). His house of St. Catherine’s lay three miles south of Princes Street.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-130"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-130-back"
    }
  }, [_vm._v("48")])]), _vm._v(". Raised to the bench as Lord Succoth in 1809.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-131"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-131-back"
    }
  }, [_vm._v("49")])]), _vm._v(". See Introduction, pp. xliv–xlv.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-132"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-132-back"
    }
  }, [_vm._v("50")])]), _vm._v(". Colin Mackenzie of Portmore, W. S. (1770–1830), a fellow Clerk of Session and a close friend.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-133"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-133-back"
    }
  }, [_vm._v("51")])]), _vm._v(". Prominent in Edinburgh as Writer to the Signet, doctor, and accountant respectively.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-134"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-134-back"
    }
  }, [_vm._v("52")])]), _vm._v(". Virgil’s "), _c('i', [_vm._v("Aeneid")]), _vm._v(", i. 118, with the first two words transposed: ‘Here and there they appear swimming in the wide whirlpool.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-135"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-135-back"
    }
  }, [_vm._v("53")])]), _vm._v(". He came to London from Italy in 1816, ‘a very singular man, uniting opposite qualities, and generally very pleasing in the early part of an acquaintance’. Redding’s "), _c('i', [_vm._v("Memoirs of Thomas Campbell")]), _vm._v(", i. 192. He stimulated the fashionable interest in Italian literature by his lectures and critical writings.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-136"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-136-back"
    }
  }, [_vm._v("54")])]), _vm._v(". Carlo, Marchese di Salvo, author of "), _c('i', [_vm._v("Lord Byron en Italie et en Grèce")]), _vm._v(", 1825, whom Scott refers to in a letter as ‘a very accomplished and well informed man’. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 237.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-137"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-137-back"
    }
  }, [_vm._v("55")])]), _vm._v(". "), _c('i', [_vm._v("Richard III")]), _vm._v(", iii. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-138"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-138-back"
    }
  }, [_vm._v("56")])]), _vm._v(". Lady Scott’s friend. See the Entry for 18 October 1826 and note.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-139"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-139-back"
    }
  }, [_vm._v("57")])]), _vm._v(". Pierre Lebrun, author of two tragedies ("), _c('i', [_vm._v("Marie Stuart")]), _vm._v(", 1820, and "), _c('i', [_vm._v("Le")]), _vm._v(" "), _c('i', [_vm._v("Cid d’Andalousie")]), _vm._v(", 1825). Scott made the same mistake about his name in Paris the following year, ‘demandant par une erreur amusante ‘‘M. Lenoir”’. Margaret Bain’s"), _c('i', [_vm._v(" Les Voyageurs français en")]), _vm._v(" "), _c('i', [_vm._v("Écosse")]), _vm._v(", 1931. It is probably Lebrun’s visit which is described in Mrs "), _c('i', [_vm._v("Hughes’s Recollections")]), _vm._v(", p. 208.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-140"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-140-back"
    }
  }, [_vm._v("58")])]), _vm._v(". Robert Cockburn, a wine-merchant who lived at 7 Atholl Crescent. He was a brother of Lord Cockburn and an old Yeomanry friend of Scott’s.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-141"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-141-back"
    }
  }, [_vm._v("59")])]), _vm._v(". Lord Robert Kerr was Assistant Adjutant-General of the forces in Scotland.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-142"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-142-back"
    }
  }, [_vm._v("60")])]), _vm._v(". Francis Jeffrey (1773–1850) was editor of the "), _c('i', [_vm._v("Edinburgh Review")]), _vm._v(" and a prominent Whig advocate. In 1829 he became Dean of the Faculty and in 1830 Lord Advocate. The pamphlet referred to is "), _c('i', [_vm._v("Combinations of Workmen, etc")]), _vm._v("., Constable, 1825.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-143"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-143-back"
    }
  }, [_vm._v("61")])]), _vm._v(". Swift’s "), _c('i', [_vm._v("Gulliver’s Travels")]), _vm._v(", pt. 1, ch. 5.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-144"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-144-back"
    }
  }, [_vm._v("62")])]), _vm._v(". Robert Cadell.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-145"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-145-back"
    }
  }, [_vm._v("63")])]), _vm._v(". Robinson of Hurst, Robinson.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-146"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-146-back"
    }
  }, [_vm._v("64")])]), _vm._v(". However, Lady Scott could not do without. ‘We are to œconomize in order to keep the carriage’, Scott writes to Sophia on 17 February 1826. ‘Now this matter of the carriage is of great consequence as a daily drive about two is really essential to Mamas health and spirits.’ "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 427. It had always meant much to her. After the success "), _c('i', [_vm._v("of Waverley")]), _vm._v(", ‘Mrs. Scott set up a carriage, a Barouche landau built in London, and which from the time she got it she was seldom out of’. Mrs. Grant’s "), _c('i', [_vm._v("Memoirs of a Highland Lady")]), _vm._v(", ii. 72.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-147"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-147-back"
    }
  }, [_vm._v("65")])]), _vm._v(". ‘This alludes to a strange old woman, keeper of a public-house among the Wicklow mountains, who, among a world of oddities, cut short every word ending in tion, by the omission of the termination. Consola for consolation – "), _c('i', [_vm._v("bothera")]), _vm._v(" for botheration, etc. Lord Plunkett had taken care to parade Judy and all her peculiarities.’ J. G. L. (This and the other notes by Lockhart are taken from the "), _c('i', [_vm._v("Life")]), _vm._v(", in which much of the "), _c('i', [_vm._v("Journal")]), _vm._v(" was published for the first time.)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-148"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-148-back"
    }
  }, [_vm._v("66")])]), _vm._v(". "), _c('i', [_vm._v("Julius Caesar")]), _vm._v(", iii. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-149"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-149-back"
    }
  }, [_vm._v("67")])]), _vm._v(". Mrs. Coutts, described by Benson Hill as ‘a fat, bare-“necked”, downy-chinned, rouged, elderly dame, in velvet and ermine’ (Dibdin, p. 317), had been an actress in her youth and was now the very wealthy widow of Thomas Coutts the banker, to whom Scott was distantly related. She married the Duke of St. Albans in 1827. ‘I daresay the marriage will turn out very well,’ Anne Scott writes to Miss Millar, ‘for, though he is a great fool, yet he is very good-natured.’ "), _c('i', [_vm._v("Letters from Scott’s Family")]), _vm._v(", p. 128.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-150"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-150-back"
    }
  }, [_vm._v("68")])]), _vm._v(". His sister.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-151"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-151-back"
    }
  }, [_vm._v("69")])]), _vm._v(". Even her visit to Abbotsford was not passed without some incivility from Scott’s other guests. See "), _c('i', [_vm._v("Life")]), _vm._v(", viii. 72–6.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-152"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-152-back"
    }
  }, [_vm._v("70")])]), _vm._v(". John Logan (1748–88), a versatile but unlucky man of letters, who was tutor to Sir John Sinclair and later minister of South Leith church. His poems were published in 1781, and two volumes of sermons posthumously.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-153"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-153-back"
    }
  }, [_vm._v("71")])]), _vm._v(". "), _c('i', [_vm._v("Macbeth")]), _vm._v(", iv. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-154"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-154-back"
    }
  }, [_vm._v("72")])]), _vm._v(". For Scott’s duties as a Clerk of Session see Introduction, pp. xxvii–xxviii.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-155"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-155-back"
    }
  }, [_vm._v("73")])]), _vm._v(". A fashionable southern suburb of Edinburgh, which began to be built in the 1820s. This loan was never recovered either by Scott or his Trustees, owing to the continued embarrassment of her affairs and the falling value of property. Sederunt Book, ii. 61.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-156"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-156-back"
    }
  }, [_vm._v("74")])]), _vm._v(". Scott had been instrumental in founding the Quarterly in 1809. As its new editor Lockhart was to receive ‘from "), _c('i', [_vm._v("£")]), _vm._v("1250 to "), _c('i', [_vm._v("£")]), _vm._v("1,500 per annum’. Lockhart, 27 November 1825, Abbots.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-157"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-157-back"
    }
  }, [_vm._v("75")])]), _vm._v(". John Barrow (1764–1848), the explorer and geographer, a self-made man who was at this time a Secretary at the Admiralty under Lord Melville. He was an indefatigable writer and contributed more than two hundred articles to the "), _c('i', [_vm._v("Quarterly")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-158"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-158-back"
    }
  }, [_vm._v("76")])]), _vm._v(". Lockhart was one of the original contributors to the Tory "), _c('i', [_vm._v("Blackwood’s Magazine")]), _vm._v(" founded in 1817, and was suspected of being part-author of the ‘Chaldee Manuscript’ which offended many Edinburgh notabilities.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-159"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-159-back"
    }
  }, [_vm._v("77")])]), _vm._v(". Benjamin Disraeli was twenty-one at this time. He published "), _c('i', [_vm._v("Vivian")]), _vm._v(" "), _c('i', [_vm._v("Grey")]), _vm._v(" the following year, entered Parliament in 1837, and became Prime Minister in 1868.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-160"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-160-back"
    }
  }, [_vm._v("78")])]), _vm._v(". Richard Heber (1773–1833), the book-collector and M. P. for Oxford University. He first met Scott in Constable’s shop when he spent the winter of 1800 in Edinburgh, and he assisted him with the "), _c('i', [_vm._v("Minstrelsy")]), _vm._v(". In 1826 he resigned his seat after a homosexual scandal.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-161"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-161-back"
    }
  }, [_vm._v("79")])]), _vm._v(". Southey was a principal contributor to the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" and a friend of John Taylor Coleridge, the previous editor. Scott was anxious to assure him that when they discussed the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" in August he did not then know that Lockhart was to be offered the editorship. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 297.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-162"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-162-back"
    }
  }, [_vm._v("80")])]), _vm._v(". A slip for ‘Wordsworth’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-163"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-163-back"
    }
  }, [_vm._v("81")])]), _vm._v(". Professor John Wilson (1785–1854), better known as ‘Christopher North’, who lived at Elleray near Windermere.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-164"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-164-back"
    }
  }, [_vm._v("82")])]), _vm._v(". A slip for ‘August’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-165"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-165-back"
    }
  }, [_vm._v("83")])]), _vm._v(". George Canning (1770–1827) had been a friend of Scott’s since Ellis had introduced them in 1805, and they were associated in founding the "), _c('i', [_vm._v("Quarterly")]), _vm._v(". At this time Canning was Foreign Secretary. He became Prime Minister a few months before his death in 1827.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-166"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-166-back"
    }
  }, [_vm._v("84")])]), _vm._v(". Charles Ellis (1771–1845), M. P. for Seaford, cousin of Scott’s friend George Ellis, and Canning’s second in his duel with Castlereagh. He was created Baron Seaford in 1826.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-167"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-167-back"
    }
  }, [_vm._v("85")])]), _vm._v(". Not the poet, but his nephew John Taylor Coleridge, who had edited the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" since 1824.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-168"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-168-back"
    }
  }, [_vm._v("86")])]), _vm._v(". At Storrs, Windermere, during the journey home from Ireland.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-169"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-169-back"
    }
  }, [_vm._v("87")])]), _vm._v(". John Cay (1790–1865), of Charlton in Northumberland, at this time Sheriff of Linlithgow.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-170"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-170-back"
    }
  }, [_vm._v("88")])]), _vm._v(". Scott enclosed Murray’s letter in one written to Lockhart the previous day. Murray writes that ‘There is nothing to apprehend’. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 302–3 and note.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-171"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-171-back"
    }
  }, [_vm._v("89")])]), _vm._v(". The interlineation reads ‘No one has any ill will against Mr. Lockhart!!!’ "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 303 n.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-172"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-172-back"
    }
  }, [_vm._v("90")])]), _vm._v(". ‘Let it be given to the more deserving.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-173"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-173-back"
    }
  }, [_vm._v("91")])]), _vm._v(". Scott replied at once, promising a review of Pepys for the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" and inviting Lockhart to come the following Sunday to discuss ‘the few ideas which occur to me about your new and important task’. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 308.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-174"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-174-back"
    }
  }, [_vm._v("92")])]), _vm._v(". ‘I am sure it will please you to hear’, writes Sophia on 1 February 1826, ‘we have been most prudent with regard to money matters since we came here… From the first I determined against a carriage till we see how we get on and pay our household servants every week.’ Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-175"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-175-back"
    }
  }, [_vm._v("93")])]), _vm._v(". In a letter Scott translates "), _c('i', [_vm._v("Volto sciolto e pensiere strett")]), _vm._v("i as ‘ “An open countenance & close thoughts.” There is no occasion to let anyone see what you exactly think of him.’ "), _c('i', [_vm._v("Letters")]), _vm._v(", v. 449–50.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-176"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-176-back"
    }
  }, [_vm._v("94")])]), _vm._v(". In London, however, he ‘really takes pains to make himself agreeable in society’. Sophia, 1 February 1826, Walpole\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-177"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-177-back"
    }
  }, [_vm._v("95")])]), _vm._v(". Sheridan’s "), _c('i', [_vm._v("School for Scandal")]), _vm._v(", ii. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-178"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-178-back"
    }
  }, [_vm._v("96")])]), _vm._v(". Sheridan’s "), _c('i', [_vm._v("Critic")]), _vm._v(", i. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-179"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-179-back"
    }
  }, [_vm._v("97")])]), _vm._v(". As the boyhood friend of the second Viscount Melville, Scott had been a frequent visitor in the days of the great Lord Melville.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-180"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-180-back"
    }
  }, [_vm._v("98")])]), _vm._v(". George Abercromby (1770–1843), another boyhood friend, was married to Lord Melville’s sister. He was the eldest son of General Sir Ralph Abercromby (1738–1801) and inherited the barony from his mother, who had been created Baroness Abercromby of Aboukir in recognition of her husband’s victory against the French at Alexandria in 1801\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-181"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-181-back"
    }
  }, [_vm._v("99")])]), _vm._v(". William Gifford (1756–1826), who edited the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" from its inception until 1824, a little, bitter, deformed man, known as a translator and satirist as well as reviewer.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-182"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-182-back"
    }
  }, [_vm._v("100")])]), _vm._v(". Sheridan’s "), _c('i', [_vm._v("Rivals")]), _vm._v(", i. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-183"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-183-back"
    }
  }, [_vm._v("101")])]), _vm._v(". Charles James Blomfield (1786–1857), Bishop of Chester (and later of London), contributor to the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" on classical subjects.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-184"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-184-back"
    }
  }, [_vm._v("102")])]), _vm._v(". William Wright of Lincoln’s Inn.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-185"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-185-back"
    }
  }, [_vm._v("103")])]), _vm._v(". John Wilson Croker (1780–1857), M. P. for Downpatrick and Secretary at the Admiralty, the friend of Wellington and Peel, and a frequent contributor to the "), _c('i', [_vm._v("Quarterly")]), _vm._v(". His caustic tongue made him some enemies, but he retained Scott’s friendship despite an attack on his "), _c('i', [_vm._v("Letters of Malachi")]), _vm._v(". See the Entries for 17 and 28 March 1826.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-186"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-186-back"
    }
  }, [_vm._v("104")])]), _vm._v(". An allusion to Hotspur’s plot in 1 "), _c('i', [_vm._v("Henry IV")]), _vm._v(", ii. 3. ‘The Douglas’ is Scott himself.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-187"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-187-back"
    }
  }, [_vm._v("105")])]), _vm._v(". The Lord President of the Court of Session, the Rt. Hon. Charles Hope of Granton (1763–1851), who had held the offices of Lord Advocate and Lord Justice-Clerk before becoming Lord President in 1811. He was the father of John Hope, the Solicitor-General.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-188"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-188-back"
    }
  }, [_vm._v("106")])]), _vm._v(". Major-General the Hon. Sir Robert William O’Callaghan (1770– 1840) commanded the forces at Edinburgh until 1830. Will Clerk describes him as ‘a rich morceau when he becomes a little mellow’. 6 January 1829, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-189"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-189-back"
    }
  }, [_vm._v("107")])]), _vm._v(". During Scott’s return journey from Ireland.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-190"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-190-back"
    }
  }, [_vm._v("108")])]), _vm._v(". Ecclesiastes 12: 3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-191"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-191-back"
    }
  }, [_vm._v("109")])]), _vm._v(". A distance of just over half a mile.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-192"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-192-back"
    }
  }, [_vm._v("110")])]), _vm._v(". Robert MacQueen, Lord Braxfield (1722–99), the legendary hanging judge whose coarse jocularity is well described by Cockburn in chapter 2 of his "), _c('i', [_vm._v("Memorials")]), _vm._v(". Scott, who dedicated his thesis to the old man, liked to repeat the comment he is alleged to have made to a prisoner: ‘Ye’re a vera clever chiel’, man, but ye wad be nane the waur o’ a hanging.’ "), _c('i', [_vm._v("Life")]), _vm._v(", vi. 203.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-193"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-193-back"
    }
  }, [_vm._v("111")])]), _vm._v(". An attack of polio at the age of eighteen months left Scott with a limp for the rest of his life.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-194"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-194-back"
    }
  }, [_vm._v("112")])]), _vm._v(". Foote’s "), _c('i', [_vm._v("Maid of Bath")]), _vm._v(", i.1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-195"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-195-back"
    }
  }, [_vm._v("113")])]), _vm._v(". Ecclesiastes 11: 9.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-196"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-196-back"
    }
  }, [_vm._v("114")])]), _vm._v(". Mrs. Anne Grant, widow of the minister of Laggan, and author of "), _c('i', [_vm._v("Letters from the Mountains, Superstitions of the Highlands, andMemoirs of a")]), _vm._v(" "), _c('i', [_vm._v("Highland Lady")]), _vm._v(". She was now seventy years old, very poor and very lame.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-197"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-197-back"
    }
  }, [_vm._v("115")])]), _vm._v(". To make her farthing into a halfpenny.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-198"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-198-back"
    }
  }, [_vm._v("116")])]), _vm._v(". Henry Mackenzie (1745–1831), the aged but still active author of "), _c('i', [_vm._v("The Man of Feeling")]), _vm._v(" (1771).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-199"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-199-back"
    }
  }, [_vm._v("117")])]), _vm._v(". Robert Rutherford. W. S. (1790–1866).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-200"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-200-back"
    }
  }, [_vm._v("118")])]), _vm._v(". Later Major-General Sir James Russell (1781–1859). Anne Scott considered him a bore, ‘but it is a great advantage having the tweed between us for it is seldom fordable’. To Sophia, 29 September 1826, Abbots. Scott, however, enjoyed his company.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-201"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-201-back"
    }
  }, [_vm._v("119")])]), _vm._v(". Baron Lynedoch of Lynedoch (1748–1843), at this time Governor of the garrison at Dumbarton Castle.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-202"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-202-back"
    }
  }, [_vm._v("120")])]), _vm._v(". ‘The "), _c('i', [_vm._v("civilest")]), _vm._v(" way of caa’ing a man a "), _c('i', [_vm._v("guse")]), _vm._v(".’ Letters, v. 128.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-203"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-203-back"
    }
  }, [_vm._v("121")])]), _vm._v(". Sir William Hamilton (1788–1856), the Professor of Civil History at Edinburgh, a Balliol friend of Lockhart’s and a foe to the phrenologists.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-204"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-204-back"
    }
  }, [_vm._v("122")])]), _vm._v(". Scott was connected with the Swintons through his maternal grandmother.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-205"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-205-back"
    }
  }, [_vm._v("123")])]), _vm._v(". Sir Alexander Keith of Ravelston (1780–1833) had ridden as Knight Marischal in the procession during the King’s visit in 1822. William Keith was one of his younger brothers. Scott was connected with the family through his mother.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-206"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-206-back"
    }
  }, [_vm._v("124")])]), _vm._v(". ‘Any one of the sacred writings of the Hindus’. "), _c('i', [_vm._v("O. E. D")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-207"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-207-back"
    }
  }, [_vm._v("125")])]), _vm._v(". A phrase used in Scots Law meaning ‘opportunity for change of intention’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-208"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-208-back"
    }
  }, [_vm._v("126")])]), _vm._v(". Scott sent to Lockhart on 17 February a short article on the burnings for publication in the "), _c('i', [_vm._v("Representative. Letters")]), _vm._v(", ix. 427.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-209"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-209-back"
    }
  }, [_vm._v("127")])]), _vm._v(". ‘No day without a line’, a proverb quoted by Pliny.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-210"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-210-back"
    }
  }, [_vm._v("128")])]), _vm._v(". The catch-phrase of Bailie Nicol Jarvie in "), _c('i', [_vm._v("Rob Roy")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-211"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-211-back"
    }
  }, [_vm._v("129")])]), _vm._v(". A Clerk of Session since 1805 and intimate family friend. His Highland prejudices endeared him to Scott. He was the brother of Staffa and a kinsman of Napoleon’s Maréchal Macdonald. He adopted his wife’s name on marriage.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-212"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-212-back"
    }
  }, [_vm._v("130")])]), _vm._v(". See Introduction, p. xliv.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-213"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-213-back"
    }
  }, [_vm._v("131")])]), _vm._v(". ‘A hard word so spelld on Authority of Miss Scott Mrs. Lockhart’. Title-page of the "), _c('i', [_vm._v("Journal")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-214"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-214-back"
    }
  }, [_vm._v("132")])]), _vm._v(". Scott wrote to him while the Court sat, urging him to rest until January: ‘The business is very easy and you will really act very unwisely as well as unkindly if you do not leave us to manage it, but endanger your health so deservedly valued by your bretheren and many others.’ "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 313.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-215"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-215-back"
    }
  }, [_vm._v("133")])]), _vm._v(". His grandson John Lockhart (1821–31), the ‘Hugh Littlejohn’ of "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(". Scott dreaded the effect on him of London air: ‘Poor little fellow he is most likely to suffer by this change of residence.’ "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 319.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-216"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-216-back"
    }
  }, [_vm._v("134")])]), _vm._v(". ‘God will provide.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-217"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-217-back"
    }
  }, [_vm._v("135")])]), _vm._v(". Robert Pearce Gillies (1788–1858), a nephew of Scott’s friend the judge Lord Gillies. He was in dire financial straits as usual and about to remove to London, where he became the first editor of the "), _c('i', [_vm._v("Foreign Quarterly Review")]), _vm._v(". In 1840 he fled to Boulogne to elude his creditors, and on his return was imprisoned for two years. His relatively worthless "), _c('i', [_vm._v("Recollections of Sir Walter Scott")]), _vm._v(" was published in 1837.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-218"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-218-back"
    }
  }, [_vm._v("136")])]), _vm._v(". Scott owned his translation of Hoffmann’s "), _c('i', [_vm._v("The Devil’s Elixirs")]), _vm._v(", 1824.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-219"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-219-back"
    }
  }, [_vm._v("137")])]), _vm._v(". ‘Mr. Gillies was, however, warmly welcomed by another publisher in Edinburgh, who paid him "), _c('i', [_vm._v("£")]), _vm._v("100 for his bulky manuscripts, and issued the book in 1825 under the title of "), _c('i', [_vm._v("The Magic Ring")]), _vm._v(", 3 vols. Its failure with the public prevented a repetition of the experiment!’ Douglas.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-220"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-220-back"
    }
  }, [_vm._v("138")])]), _vm._v(". An allusion to ‘the lunatic, the lover, and the poet’ in "), _c('i', [_vm._v("A Midsummer")]), _vm._v(" "), _c('i', [_vm._v("Night’s Dream, v.i.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-221"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-221-back"
    }
  }, [_vm._v("139")])]), _vm._v(". John Hope (1794–1858), Solicitor-General for Scotland 1822–30. Dean of the Faculty of Advocates 1830, and later Lord Justice-Clerk. He was the eldest son of the Lord President, Charles Hope.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-222"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-222-back"
    }
  }, [_vm._v("140")])]), _vm._v(". Robert Dundas of Arniston (1797–1838), son of the Lord Chief Baron.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-223"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-223-back"
    }
  }, [_vm._v("141")])]), _vm._v(". ‘Consuming little meat and much small beer.’ "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 321.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-224"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-224-back"
    }
  }, [_vm._v("142")])]), _vm._v(". On the advice of Terry, Murray, and Disraeli, they decided ‘to rent for 6 months a handsome & convenient "), _c('i', [_vm._v("ready furnished")]), _vm._v(" house in the best possible situation’. Terry, 16 November 1825, Abbots.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-225"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-225-back"
    }
  }, [_vm._v("143")])]), _vm._v(". ‘To do and to suffer is Roman.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-226"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-226-back"
    }
  }, [_vm._v("144")])]), _vm._v(". A reminiscence of "), _c('i', [_vm._v("Richard III")]), _vm._v(", iii. 7.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-227"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-227-back"
    }
  }, [_vm._v("145")])]), _vm._v(". "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. ii, ch. 9.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-228"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-228-back"
    }
  }, [_vm._v("146")])]), _vm._v(". The Royal Society of Edinburgh, of which Scott was President. 1820–32.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-229"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-229-back"
    }
  }, [_vm._v("147")])]), _vm._v(". ‘A supplement to a Paper on Dreams formerly read to the Society.’ Royal Society Minutes.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-230"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-230-back"
    }
  }, [_vm._v("148")])]), _vm._v(". Dr. James Russell (1754–1836), Regius Professor of Clinical Surgery at Edinburgh University and Vice-president of the Royal Society, habitually held a supper party at 30 Abercromby Place after the fortnightly meetings of the Society.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-231"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-231-back"
    }
  }, [_vm._v("149")])]), _vm._v(". Henry Mackenzie who, according to Lockhart, had been consulting Sir Walter about collecting his own juvenile poetry, and who apparently intended Scott to write his life. Disc. ii. 227.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-232"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-232-back"
    }
  }, [_vm._v("150")])]), _vm._v(". Robert Lockhart, brother of Scott’s son-in-law.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-233"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-233-back"
    }
  }, [_vm._v("151")])]), _vm._v(". His wife Jane’s estate.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-234"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-234-back"
    }
  }, [_vm._v("152")])]), _vm._v(". See Introduction, p. xxvi.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-235"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-235-back"
    }
  }, [_vm._v("153")])]), _vm._v(". A Liverpool merchant who recommended it for making gas and sent Scott a trial cask in 1824. Walpole, 19 January 1824. He had been knighted in 1820 while Lord Mayor of Liverpool.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-236"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-236-back"
    }
  }, [_vm._v("154")])]), _vm._v(". Sir William Knighton (1776–1836), physician and private secretary to George IV. Scott first met him during the royal visit to Scotland in 1822, and the friendship was kept in good repair by correspondence.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-237"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-237-back"
    }
  }, [_vm._v("155")])]), _vm._v(". Scott had made the request in October. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 262. The Dedication, which was approved before 20 December, was in the following terms: ‘To His Majesty KING GEORGE IV, The generous Patron even of the most humble attempts towards the advantage of his subjects, THE MISCELLANY, designed to extend Useful Knowledge and Elegant Literature, by placing Works of standard merit within the attainment every class of Readers, is most humbly inscribed by his Majesty’s humble and devoted servant, ARCHIBALD CONSTABLE. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 327.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-238"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-238-back"
    }
  }, [_vm._v("156")])]), _vm._v(". The development north of Queen Street as far as Royal Circus and Great King Street took place between 1803 and 1823.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-239"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-239-back"
    }
  }, [_vm._v("157")])]), _vm._v(". George Fergusson of Hermand, who took the title of Lord Hermand when he succeeded Braxfield on the Bench in 1799. ‘He was fond of the pleasures, and not least the liquid ones, of the table’, says Cockburn ("), _c('i', [_vm._v("Memorials")]), _vm._v(", ch. 2), and was a man of decided and outspoken views.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-240"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-240-back"
    }
  }, [_vm._v("158")])]), _vm._v(". Sir Archibald Campbell, raised to the Bench in 1809 as Lord Succoth.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-241"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-241-back"
    }
  }, [_vm._v("159")])]), _vm._v(". See "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 309 n.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-242"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-242-back"
    }
  }, [_vm._v("160")])]), _vm._v(". ‘By divine right’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-243"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-243-back"
    }
  }, [_vm._v("161")])]), _vm._v(". Major John Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-244"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-244-back"
    }
  }, [_vm._v("162")])]), _vm._v(". ‘It is enough to have lived.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-245"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-245-back"
    }
  }, [_vm._v("163")])]), _vm._v(". William Knox, from Lilliesleaf near Melrose, who had died on 12 November, aged thirty-six. Lockhart’s note says: ‘His publisher (Mr. Anderson junior, of Edinburgh) remembers that Sir Walter occasionally wrote to Knox and sent him money – "), _c('i', [_vm._v("£")]), _vm._v("10 at a time.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-246"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-246-back"
    }
  }, [_vm._v("164")])]), _vm._v(". Michael Bruce (1746–67), the son of a Kinross-shire weaver. Scott probably had in mind his ‘Elegy – Written in Spring’, which is given added point by its author’s untimely death.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-247"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-247-back"
    }
  }, [_vm._v("165")])]), _vm._v(". An allusion to Ben Jonson’s "), _c('i', [_vm._v("Everyman in his Humour")]), _vm._v(", i. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-248"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-248-back"
    }
  }, [_vm._v("166")])]), _vm._v(". Mrs. Grant of Laggan.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-249"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-249-back"
    }
  }, [_vm._v("167")])]), _vm._v(". Henry Mackenzie.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-250"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-250-back"
    }
  }, [_vm._v("168")])]), _vm._v(". Harriet Wilson’s "), _c('i', [_vm._v("Memoirs")]), _vm._v(", 1825.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-251"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-251-back"
    }
  }, [_vm._v("169")])]), _vm._v(". Lord Alvanley (1789–1849), the spendthrift wit to whom Brummel’s famous remark about the Prince Regent was addressed: ‘Alvanley, who’s your fat friend?’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-252"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-252-back"
    }
  }, [_vm._v("170")])]), _vm._v(". "), _c('i', [_vm._v("Measure for Measure")]), _vm._v(", iv. 3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-253"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-253-back"
    }
  }, [_vm._v("171")])]), _vm._v(". "), _c('i', [_vm._v("Hamlet")]), _vm._v(", ii. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-254"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-254-back"
    }
  }, [_vm._v("172")])]), _vm._v(". Sir John Hay of Haystoun near Peebles, a fellow Director of the Edinburgh Academy.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-255"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-255-back"
    }
  }, [_vm._v("173")])]), _vm._v(". Probably the Newenhams of Coolmore near Cork to whom Mrs. Scott of Harden had introduced Walter and Jane. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 80. They had visited Scotland in 1823. "), _c('i', [_vm._v("Diaries of Helen Graham")]), _vm._v(", pp. 29–31.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-256"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-256-back"
    }
  }, [_vm._v("174")])]), _vm._v(". Burns’s ‘Dedication to Gavin Hamilton’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-257"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-257-back"
    }
  }, [_vm._v("175")])]), _vm._v(". Burn’s ‘Tam o’ Shanter’, ll. 51–2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-258"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-258-back"
    }
  }, [_vm._v("176")])]), _vm._v(". It appears from the Walpole Collection that the schoolboy was called George Woods and wanted ‘a few lines on any subject’ for his ‘Yorkshire Magazine and Provincial Repository’, a more modest demand than that of the soldier, Joseph Wallace: ‘All I request of you is to apply to the Commander in chief I dare to say that you may know him.’ 5 and 11 December 1825, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-259"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-259-back"
    }
  }, [_vm._v("177")])]), _vm._v(". Cervantes’ "), _c('i', [_vm._v("Don Quixote")]), _vm._v(", pt. ii, ch. 23.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-260"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-260-back"
    }
  }, [_vm._v("178")])]), _vm._v(". Since"), _c('i', [_vm._v(" The Heart of Mid-Lothian")]), _vm._v(" was extended from three to four volumes, to fulfil the contract for a four-volume second series of "), _c('i', [_vm._v("Tales of My Landlord")]), _vm._v(" (see Grierson, p. 164), the correspondent was a shrewder literary critic than Scott allows.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-261"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-261-back"
    }
  }, [_vm._v("179")])]), _vm._v(". The Great Duke is of course Wellington. Mons Meg, a huge fifteenth-century cannon, was returned to Edinburgh Castle in 1829 thanks to Scott’s efforts. See the Entry for 9 March 1829.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-262"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-262-back"
    }
  }, [_vm._v("180")])]), _vm._v(". See Addison’s "), _c('i', [_vm._v("Spectator")]), _vm._v(", no. 159.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-263"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-263-back"
    }
  }, [_vm._v("181")])]), _vm._v(". ‘He is not the God of the dead but the God of the living.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-264"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-264-back"
    }
  }, [_vm._v("182")])]), _vm._v(". Alexander Pringle junior, of Whytbank.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-265"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-265-back"
    }
  }, [_vm._v("183")])]), _vm._v(". William Allan (1782–1850), a ‘zealous cavalier & tory’ ("), _c('i', [_vm._v("Letters")]), _vm._v(", vii. 55) whose pictures on medieval and historical subjects Scott much admired. He became President of the Royal Scottish Academy in 1837, and was knighted in 1842.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-266"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-266-back"
    }
  }, [_vm._v("184")])]), _vm._v(". ‘The illness of the learned’, that is, depression, or ‘the Black Dog’ as Scott calls it elsewhere.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-267"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-267-back"
    }
  }, [_vm._v("185")])]), _vm._v(". ‘A hill-fort of a type occurring in Scotland… the stones of which have been converted into a vitreous substance by the action of fire.’ "), _c('i', [_vm._v("O. E. D")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-268"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-268-back"
    }
  }, [_vm._v("186")])]), _vm._v(". James Hogg (1770–1835), the ‘Ettrick Shepherd’, poet, and contributor to "), _c('i', [_vm._v("Blackwood’s")]), _vm._v(". He was introduced to Scott by Laidlaw and assisted in the collection of ballads for the "), _c('i', [_vm._v("Minstrelsy")]), _vm._v(". His personal vanity is well illustrated by his "), _c('i', [_vm._v("Domestic Manners of Sir")]), _vm._v(" "), _c('i', [_vm._v("Walter Scott")]), _vm._v(", 1834.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-269"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-269-back"
    }
  }, [_vm._v("187")])]), _vm._v(". David Thomson, a Galashiels weaver with a turn for poetry. "), _c('i', [_vm._v("Life")]), _vm._v(", vii.93.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-270"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-270-back"
    }
  }, [_vm._v("188")])]), _vm._v(". Sir James Melville, whose "), _c('i', [_vm._v("Memoirs")]), _vm._v(" was published by the Bannatyne Club in 1827.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-271"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-271-back"
    }
  }, [_vm._v("189")])]), _vm._v(". Burns’s ‘Address to the Unco Guid’, l. 40.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-272"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-272-back"
    }
  }, [_vm._v("190")])]), _vm._v(". Moore’s ‘Those evening Bells’ in "), _c('i', [_vm._v("National Airs")]), _vm._v(" (1815).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-273"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-273-back"
    }
  }, [_vm._v("191")])]), _vm._v(". Charles Mathews (1776–1835) the comedian.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-274"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-274-back"
    }
  }, [_vm._v("192")])]), _vm._v(". Dr. Samuel Hibbert’s "), _c('i', [_vm._v("Sketches of the Philosophy of Apparitions, or an")]), _vm._v(" "), _c('i', [_vm._v("Attempt to trace such Illusions to their Physical Causes")]), _vm._v(", 1824. The second edition (1825) was dedicated to Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-275"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-275-back"
    }
  }, [_vm._v("193")])]), _vm._v(". Banamhorar-Chat: Elizabeth, Lady Stafford (1765–1839) and Countess of Sutherland in her own right. Her Gaelic title means ‘The Great Lady of the Cat’. She was a fellow resident of George Square in Scott’s youth, and presented a set of colours to be carried in the ‘bickers’ described by Lockhart. "), _c('i', [_vm._v("Life")]), _vm._v(", i. 135–9.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-276"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-276-back"
    }
  }, [_vm._v("194")])]), _vm._v(". The Duke of Buccleuch’s sisters.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-277"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-277-back"
    }
  }, [_vm._v("195")])]), _vm._v(". The daughters of Baron Montagu, the Duke of Buccleuch’s uncle.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-278"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-278-back"
    }
  }, [_vm._v("196")])]), _vm._v(". See p. 91, n. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-279"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-279-back"
    }
  }, [_vm._v("197")])]), _vm._v(". Margaret, the daughter of Scott’s old friend Mrs. Maclean Clephane.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-280"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-280-back"
    }
  }, [_vm._v("198")])]), _vm._v(". Their mother, Lady Alvanley, died in Edinburgh, and the arrangements for the funeral and the erection of a suitable monument were made by Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-9-281"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-9-281-back"
    }
  }, [_vm._v("199")])]), _vm._v(". "), _c('i', [_vm._v("Coriolanus")]), _vm._v(", ii. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-282"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-282-back"
    }
  }, [_vm._v("200")])]), _vm._v(". At this time eleven insurance companies had their head offices in Edinburgh. Scott was Governor of the Scottish Union, as well as Extraordinary Director of the Edinburgh Life Assurance Company of 24 George Street, referred to here.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-283"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-283-back"
    }
  }, [_vm._v("201")])]), _vm._v(". An allusion to i "), _c('i', [_vm._v("Henry IV")]), _vm._v(", ii. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-284"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-284-back"
    }
  }, [_vm._v("202")])]), _vm._v(". "), _c('i', [_vm._v("Othello")]), _vm._v(", i.3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-285"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-285-back"
    }
  }, [_vm._v("203")])]), _vm._v(". The Solicitor-General, John Hope.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-286"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-286-back"
    }
  }, [_vm._v("204")])]), _vm._v(". The first Viscount Melville (1742–1811), ‘the uncrowned King of Scotland’, whose rule by patronage stretched from 1783 until 1806. Throughout his tenure of different Cabinet posts he was, in effect, the arbiter on all Scottish affairs. Scott had been intimate with the family, through his friendship with the son, from an early age.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-287"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-287-back"
    }
  }, [_vm._v("205")])]), _vm._v(". Scott borrowed "), _c('i', [_vm._v("£")]), _vm._v("10,000 from Mr. Farie of Farme, paid "), _c('i', [_vm._v("£")]), _vm._v("3000 to John Moss’s daughter, Mrs. Stevenson of Melrose, to clear off the mortgage on Kaeside, and sank the remaining "), _c('i', [_vm._v("£")]), _vm._v("7000 in James Ballantyne & Coy. The money due to the Misses Ferguson was still unpaid when the crash came. Sederunt Book i. 71; ii. 127–8.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-288"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-288-back"
    }
  }, [_vm._v("206")])]), _vm._v(". "), _c('i', [_vm._v("Macbeth")]), _vm._v(", iv. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-289"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-289-back"
    }
  }, [_vm._v("207")])]), _vm._v(". ‘As his custom is’. The point is that he arrives at or just before the dinner-hour.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-290"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-290-back"
    }
  }, [_vm._v("208")])]), _vm._v(". Robert Sym Wilson, W.S., Secretary to the Royal Bank of Scotland.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-291"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-291-back"
    }
  }, [_vm._v("209")])]), _vm._v(". As the Lockharts were now in London, Chiefswood, the small house on the Abbotsford estate which they used when in the country, was temporarily uninhabited. It was later let to Captain Hamilton.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-292"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-292-back"
    }
  }, [_vm._v("210")])]), _vm._v(". ‘But who is to guard the guardian herself?’ – an adaptation of Juvenal’s "), _c('i', [_vm._v("Satires")]), _vm._v(", vi. 347.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-293"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-293-back"
    }
  }, [_vm._v("211")])]), _vm._v(". Sir Samuel Shepherd (1760–1840). Before becoming Lord Chief Baron of the Court of Exchequer in Scotland he had been Attorney-General, and but for his deafness might have risen higher. He was a member of the Blair-Adam Club and a close, although not an early, friend of Scott’s. Scott sketches his character in the Entry for 20 December 1825.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-294"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-294-back"
    }
  }, [_vm._v("212")])]), _vm._v(". ‘That final day has come’ – a reminiscence of Virgil’s "), _c('i', [_vm._v("venit summa")]), _vm._v(" "), _c('i', [_vm._v("dies")]), _vm._v(" in "), _c('i', [_vm._v("Aeneid")]), _vm._v(", i. 118.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-295"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-295-back"
    }
  }, [_vm._v("213")])]), _vm._v(". As Clerk of Session and Sheriff of Selkirkshire respectively.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-296"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-296-back"
    }
  }, [_vm._v("214")])]), _vm._v(". The village between Abbotsford and Melrose.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-297"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-297-back"
    }
  }, [_vm._v("215")])]), _vm._v(". William Laidlaw (1780–1845), factor on the Abbotsford estate since 1816, and nephew of Scott’s first Sheriff-Substitute, Charles Erskine. Scott met him in his ballad-collecting days, and the friendship ripened with the years. Kaeside, on the hill above Abbotsford, was the frequent object of Scott’s walk, especially when there was politics to discuss, and the loss of Laidlaw was a cruel deprivation. Happily he was restored in 1829 when Purdie’s death left the estate without a manager. Laidlaw wrote a little in prose and verse, and acted as Scott’s amanuensis during his illness in 1819 and again in his declining months.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-298"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-298-back"
    }
  }, [_vm._v("216")])]), _vm._v(". See Introduction, pp. xliii–xliv.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-299"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-299-back"
    }
  }, [_vm._v("217")])]), _vm._v(". "), _c('i', [_vm._v("The Edinburgh Weekly Journal")]), _vm._v(". After the crash James Ballantyne continued to edit this paper and to manage the printing side of James Ballantyne and Coy.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-300"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-300-back"
    }
  }, [_vm._v("218")])]), _vm._v(". ‘Unknown superiors’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-301"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-301-back"
    }
  }, [_vm._v("219")])]), _vm._v(". In the Entry for 13 December.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-302"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-302-back"
    }
  }, [_vm._v("220")])]), _vm._v(". Lady Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-303"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-303-back"
    }
  }, [_vm._v("221")])]), _vm._v(". Scott’s authorship of the Waverley Novels was acknowledged at the meeting of his creditors a month later, although the better-known confession at the Theatrical Fund Dinner was not made until February 1827.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-304"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-304-back"
    }
  }, [_vm._v("222")])]), _vm._v(". Beaumont and Fletcher’s "), _c('i', [_vm._v("The Nice Valour")]), _vm._v(", iii. 3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-305"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-305-back"
    }
  }, [_vm._v("223")])]), _vm._v(". ‘Ballad’ in Charles Dibdin’s "), _c('i', [_vm._v("Liberty Hall")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-306"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-306-back"
    }
  }, [_vm._v("224")])]), _vm._v(". ‘Kittle’ means ‘tricky’. Later events proved the truth of this prophecy. Constable’s creditors laid claim to "), _c('i', [_vm._v("Woodstock, The Life of")]), _vm._v(" "), _c('i', [_vm._v("Napoleon")]), _vm._v(", and the manuscripts of the novels.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-307"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-307-back"
    }
  }, [_vm._v("225")])]), _vm._v(". "), _c('i', [_vm._v("Don Quixote")]), _vm._v(", pt. ii, ch. 23.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-308"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-308-back"
    }
  }, [_vm._v("226")])]), _vm._v(". "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. ii, ch. 6.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-309"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-309-back"
    }
  }, [_vm._v("227")])]), _vm._v(". Hector Macdonald Buchanan.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-310"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-310-back"
    }
  }, [_vm._v("228")])]), _vm._v(". These figures are deleted in the original and ‘This was a mistake’ added in the margin.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-311"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-311-back"
    }
  }, [_vm._v("229")])]), _vm._v(". An allusion to Isaiah 52: 7.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-312"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-312-back"
    }
  }, [_vm._v("230")])]), _vm._v(". Scott had unsuccessfully wooed Williamina Belsches, who in January 1797 married Sir William Forbes. See "), _c('i', [_vm._v("Sir Walter Scott’s")]), _vm._v(" "), _c('i', [_vm._v("Congé")]), _vm._v(", by Lord Sands, third edition, 1931.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-313"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-313-back"
    }
  }, [_vm._v("231")])]), _vm._v(". By his marriage to Charlotte Carpenter on Christmas Eve 1797.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-314"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-314-back"
    }
  }, [_vm._v("232")])]), _vm._v(". The failure of John Ballantyne & Coy., Scott’s publishing house, was followed the next year by the success of "), _c('i', [_vm._v("Waverley")]), _vm._v(", the first of his novels.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-315"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-315-back"
    }
  }, [_vm._v("233")])]), _vm._v(". An allusion to Falstaff’s soliloquy,"), _c('i', [_vm._v(" 1 Henry IV")]), _vm._v(", v. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-316"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-316-back"
    }
  }, [_vm._v("234")])]), _vm._v(". The ‘great counsell’ was James Scarlett (1769–1844), later Baron Abinger; his son was James Yorke Scarlett (1799–1871) who rose to the rank of major-general.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-317"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-317-back"
    }
  }, [_vm._v("235")])]), _vm._v(". The Lord President’s wife.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-318"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-318-back"
    }
  }, [_vm._v("236")])]), _vm._v(". A phrase from Anthony à Wood, much used by Monkbarns in"), _c('i', [_vm._v(" The")]), _vm._v(" "), _c('i', [_vm._v("Antiquary")]), _vm._v(" and by Scott himself.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-319"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-319-back"
    }
  }, [_vm._v("237")])]), _vm._v(". A new make of pen from Joseph Bramah of Piccadilly, the inventor of patent locks and pens.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-320"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-320-back"
    }
  }, [_vm._v("238")])]), _vm._v(". To his "), _c('i', [_vm._v("Miscellany")]), _vm._v(". See the Entry for 7 December and note. Scott wrote at once to Constable with the good news. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 339.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-321"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-321-back"
    }
  }, [_vm._v("239")])]), _vm._v(". Charles James Mathews (1803–78), later known as a comic actor and adapter of plays. ‘On Tuesday we met the man of men – the great "), _c('i', [_vm._v("Well-Known")]), _vm._v(" – at James Ballantyne’s. Charles was all hopes, all fears. Ballantyne, with great kindness, placed him next Sir Walter at dinner’, wrote the elder Mathews to his wife."), _c('i', [_vm._v(" Memoirs of Mathews")]), _vm._v(", iii. 511. Scott invited father and son to visit Abbotsford when they had finished their Scottish engagements. They arrived on 11 January.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-322"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-322-back"
    }
  }, [_vm._v("240")])]), _vm._v(". A slip for James Smith (1775–1839), the wit, parodist and critic, joint-author with his brother Horace of "), _c('i', [_vm._v("Rejected Addresses")]), _vm._v(". Some of his sketches were actually written for the elder Mathews.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-323"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-323-back"
    }
  }, [_vm._v("241")])]), _vm._v(". George Colman the younger (1762–1836), dramatist and humorous poet.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-324"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-324-back"
    }
  }, [_vm._v("242")])]), _vm._v(". A slip for ‘weeks’. For the duel in which Boswell was killed see the Entry for 14 December 1826 and note.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-325"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-325-back"
    }
  }, [_vm._v("243")])]), _vm._v(". Henry Savary, a banker’s son in Bristol, recently tried for forgery.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-326"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-326-back"
    }
  }, [_vm._v("244")])]), _vm._v(". John Gay’s "), _c('i', [_vm._v("What d’ye call it")]), _vm._v(", sc. 8.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-327"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-327-back"
    }
  }, [_vm._v("245")])]), _vm._v(". William Erskine (1769–1822), the gentle, scholarly, retiring ‘little man of feeble make’ who had been one of Scott’s most intimate friends from 1792. He was raised to the Bench in 1822 as Lord Kinnedder, and died a few months later, snuffed out by unfounded rumours of immorality. See "), _c('i', [_vm._v("Life")]), _vm._v(", i. 279 and vi. 393.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-328"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-328-back"
    }
  }, [_vm._v("246")])]), _vm._v(". Gilbert Elliot, second Earl of Minto (1782–1859). He was a Whig and later First Lord of the Admiralty.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-329"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-329-back"
    }
  }, [_vm._v("247")])]), _vm._v(". Thomas Thomson (1768–1852) was the son of a clergyman and a brilliant graduate of Glasgow University. His bent for legal antiquarianism led him as Vice-president and later President of the Bannatyne Club to superintend the Club’s publications, thirteen of which he edited himself. As Deputy Clerk-Register he brought some order into the records of Scotland, many of which he also published for the first time. He was a member of the Blair-Adam Club and a brother of the Revd. John Thomson of Duddingston.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-330"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-330-back"
    }
  }, [_vm._v("248")])]), _vm._v(". Lord Minto’s mother-in-law, the widow of Patrick Brydone, author of "), _c('i', [_vm._v("A Tour through Sicily and Malta")]), _vm._v(", 1773.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-331"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-331-back"
    }
  }, [_vm._v("249")])]), _vm._v(". The daughter-in-law of Scott’s great friend William Adam of Blair-Adam.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-332"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-332-back"
    }
  }, [_vm._v("250")])]), _vm._v(". Gilbert, first Earl of Minto (1751–1814), Governor of Corsica 1794–6, an eyewitness of the Battle of St. Vincent, and Governor-General of India from1807 to 1813. A triumphal welcome had been prepared for him in Hawick, but the Earl died of a chill on the way from London.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-333"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-333-back"
    }
  }, [_vm._v("251")])]), _vm._v(". Thomas Campbell (1777–1844), the poet.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-334"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-334-back"
    }
  }, [_vm._v("252")])]), _vm._v(". Richard Savage (1697–1743), the subject of Dr. Johnson’s short "), _c('i', [_vm._v("Life")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-335"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-335-back"
    }
  }, [_vm._v("253")])]), _vm._v(". A slip for‘1812’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-336"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-336-back"
    }
  }, [_vm._v("254")])]), _vm._v(". Sir Alexander Don (1751–1815), fifth baronet, of Newton Don near Kelso, at this time M. P. for Roxburghshire.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-337"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-337-back"
    }
  }, [_vm._v("255")])]), _vm._v(". The fourth Duke (1772–1819).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-338"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-338-back"
    }
  }, [_vm._v("256")])]), _vm._v(". ‘See Canning’s "), _c('i', [_vm._v("German Play")]), _vm._v(", in the Anti-Jacobin.’ J. G. L.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-339"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-339-back"
    }
  }, [_vm._v("257")])]), _vm._v(". He had died on 1 December. Scott met him in Paris in 1815.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-340"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-340-back"
    }
  }, [_vm._v("258")])]), _vm._v(". He sent Jane a copy of ‘Bonny Dundee’ and received a characteristic reply: ‘Many thanks for the beautiful song you sent me, I am quite delighted with it and shall try to sing it as well as I can, although you know I am not very fond of performing in that way.’ 14 January 1826, Walpole. For the letter to Walter see "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 345.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-341"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-341-back"
    }
  }, [_vm._v("259")])]), _vm._v(". It is characteristic of Constable that his plan (abandoned because of his bankruptcy) should have been for a series ‘in a Superior stile’ and at double the usual price; equally characteristic of Cadell that the Magnum Opus which took its place should be a cheap edition for the mass market.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-342"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-342-back"
    }
  }, [_vm._v("260")])]), _vm._v(". James Ballantyne’s printing concern, in which Scott was a partner and for which a new edition would mean work and profit.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-343"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-343-back"
    }
  }, [_vm._v("261")])]), _vm._v(". The Taylor Johnson’s "), _c('i', [_vm._v("Musical Museum")]), _vm._v(", no. 490.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-344"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-344-back"
    }
  }, [_vm._v("262")])]), _vm._v(".‘(Will) a stranger (reap) these crops?’ Virgil’s "), _c('i', [_vm._v("Eclogues")]), _vm._v(", i. 71.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-345"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-345-back"
    }
  }, [_vm._v("263")])]), _vm._v(". ‘No divinity is lacking if we had prudence’ – an adaptation of Juvenal’s "), _c('i', [_vm._v("Satires")]), _vm._v(", x. 365.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-346"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-346-back"
    }
  }, [_vm._v("264")])]), _vm._v(". "), _c('i', [_vm._v("Candide")]), _vm._v(", ch. 30.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-347"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-347-back"
    }
  }, [_vm._v("265")])]), _vm._v(". "), _c('i', [_vm._v("The Memoirs of La Rochejacquelein")]), _vm._v(" was published as vol. v of Constable’s "), _c('i', [_vm._v("Miscellany")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-348"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-348-back"
    }
  }, [_vm._v("266")])]), _vm._v(". ‘Gil Morrice’, st. 7, in Percy’s "), _c('i', [_vm._v("Reliques")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-349"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-349-back"
    }
  }, [_vm._v("267")])]), _vm._v(". Christmas dinner at Mertoun, the seat of the Scotts of Harden, was ‘an engagement of 150 years standing when we are all in the County’. "), _c('i', [_vm._v("Letters")]), _vm._v(", xi. 448. With Christmas on a Sunday, however, the festivities this year were held on the 26th.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-350"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-350-back"
    }
  }, [_vm._v("268")])]), _vm._v(". James Clarkson, the doctor from Melrose.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-351"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-351-back"
    }
  }, [_vm._v("269")])]), _vm._v(". Scott’s butler. He continued to serve Scott after the crash and, unknown to Scott, recorded some of his experiences. See, for instance, notes 2–6, pp. 806–9.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-352"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-352-back"
    }
  }, [_vm._v("270")])]), _vm._v(". Job 2: 10.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-353"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-353-back"
    }
  }, [_vm._v("271")])]), _vm._v(". These were urgently required by Constable, as a letter to Ballantyne of the same date makes clear. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 351.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-354"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-354-back"
    }
  }, [_vm._v("272")])]), _vm._v(". From Huntly Burn, where he was spending Christmas with his sisters.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-355"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-355-back"
    }
  }, [_vm._v("273")])]), _vm._v(". This too was urgent: it was to appear in the January "), _c('i', [_vm._v("Quarterly")]), _vm._v(", as the first article of Lockhart’s first number. Scott was working under the double handicap of his illness and of having left his copy of Pepys in Edinburgh. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 358.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-356"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-356-back"
    }
  }, [_vm._v("274")])]), _vm._v(". "), _c('i', [_vm._v("As You Like It")]), _vm._v(", iv. 3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-357"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-357-back"
    }
  }, [_vm._v("275")])]), _vm._v(". The Revd. George Thomson, son of the minister in Melrose, the original of Dominie Sampson, and formerly tutor to Scott’s sons. He had a wooden leg and an eccentric manner. ‘I hope he will not go utterly mad till I can get some hapless congregation for him’, wrote Scott in May 1826 ("), _c('i', [_vm._v("Letters")]), _vm._v(", x. 26) but repeated efforts to recommend his ‘very worthy friend George Thompson’ ("), _c('i', [_vm._v("Letters")]), _vm._v(", vii. 46), for whom he had a real regard, were in vain.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-358"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-358-back"
    }
  }, [_vm._v("276")])]), _vm._v(". ‘Losing’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-359"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-359-back"
    }
  }, [_vm._v("277")])]), _vm._v(". In Scott’s day postage was paid by the recipient not the sender. The cost of a letter from London to Edinburgh was 13"), _c('i', [_vm._v("d")]), _vm._v(". Scott says elsewhere that unsolicited packages cost him "), _c('i', [_vm._v("£")]), _vm._v("100 a year. See the Entry for 6 January 1828.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-360"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-360-back"
    }
  }, [_vm._v("278")])]), _vm._v(". This abbreviation of ‘Sir Walter Scott’ was coined by Tom Purdie, who took it upon himself, when Scott became a baronet, to change the markings on the Abbotsford sheep from ‘WS’ to ‘SWS’. "), _c('i', [_vm._v("Life")]), _vm._v(", ix. 32.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-361"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-361-back"
    }
  }, [_vm._v("279")])]), _vm._v(". Burns’s ‘O Poortith Cauld and Restless Love’, ll. 11–12.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-362"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-362-back"
    }
  }, [_vm._v("280")])]), _vm._v(". "), _c('i', [_vm._v("A Spiritual Diary and Soliloquies")]), _vm._v(", by Dr. John Rutty (1698–1775).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-363"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-363-back"
    }
  }, [_vm._v("281")])]), _vm._v(". To assist him with an article on Moore’s"), _c('i', [_vm._v(" Life of Sheridan")]), _vm._v(". Lockhart had written on the 25th asking for ‘what it wd cost you no trouble (certainly no reading) to throw off at once’. Letters, ix. 352n.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-364"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-364-back"
    }
  }, [_vm._v("282")])]), _vm._v(". See the entry for 24 December and note.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-365"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-365-back"
    }
  }, [_vm._v("283")])]), _vm._v(". Only the letter from Cork arrived on this day; the silver box came on 5 January.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-366"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-366-back"
    }
  }, [_vm._v("284")])]), _vm._v(". Queenstown.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-367"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-367-back"
    }
  }, [_vm._v("285")])]), _vm._v(". "), _c('i', [_vm._v("A Midsummer Night’s Dream")]), _vm._v(", v. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-368"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-368-back"
    }
  }, [_vm._v("286")])]), _vm._v(". George Huntly Gordon was the son of Major Pryse Gordon, who showed Scott the field of Waterloo in 1815. Debarred by his deafness from becoming a minister of the Scottish Church as he had intended, he acted for many years as Scott’s amanuensis, copying the manuscript for the press to preserve the author’s anonymity and cataloguing his library. In 1826 Scott helped to procure him a post as assistant private secretary to the Secretary of the Treasury.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-369"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-369-back"
    }
  }, [_vm._v("287")])]), _vm._v(". The lawyer who transacted most of Scott’s local business. After the crash, the Trustees appointed him to supervise the day-to-day financial management of the estate.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-370"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-370-back"
    }
  }, [_vm._v("288")])]), _vm._v(". New Year’s Eve.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-371"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-371-back"
    }
  }, [_vm._v("289")])]), _vm._v(". Sir Adam Ferguson’s brother James.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-372"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-372-back"
    }
  }, [_vm._v("290")])]), _vm._v(". The Misses Ferguson.\n            ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2257debe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674951_chapter_04.vue
// module id = 87
// module chunks = 0